export const listSVGIcon03 = {
  "add-media-video": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.8333 17.5H3C2.72386 17.5 2.5 17.2762 2.5 17V3C2.5 2.72386 2.72386 2.5 3 2.5H17C17.2762 2.5 17.5 2.72386 17.5 3V10.8333"
        stroke="#ED1117"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 15.8335H15.834M18.334 15.8335H15.834M15.834 15.8335V13.3335M15.834 15.8335V18.3335"
        stroke="#ED1117"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24807 7.09396C7.91474 6.90349 7.5 7.14417 7.5 7.52809V12.4716C7.5 12.8555 7.91474 13.0962 8.24807 12.9057L12.5736 10.4339C12.9095 10.242 12.9095 9.75766 12.5736 9.56574L8.24807 7.09396Z"
        stroke="#ED1117"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "filter-white": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.28784 3.75H16.7122C16.8332 3.75 16.9517 3.78517 17.0532 3.85124C17.1546 3.9173 17.2347 4.01142 17.2837 4.12215C17.3327 4.23288 17.3485 4.35546 17.3291 4.47498C17.3097 4.5945 17.2561 4.70583 17.1746 4.79542L12.0375 10.4462C11.9329 10.5613 11.875 10.7112 11.875 10.8666V15.2905C11.875 15.3934 11.8496 15.4947 11.801 15.5854C11.7525 15.6761 11.6823 15.7535 11.5967 15.8105L9.09669 17.4772C9.00256 17.54 8.89317 17.576 8.78018 17.5814C8.66718 17.5869 8.55483 17.5616 8.45509 17.5082C8.35535 17.4548 8.27197 17.3754 8.21383 17.2784C8.1557 17.1813 8.125 17.0703 8.125 16.9572V10.8666C8.125 10.7112 8.06705 10.5613 7.96246 10.4462L2.82538 4.79542C2.74393 4.70583 2.69026 4.5945 2.67089 4.47498C2.65152 4.35546 2.66729 4.23288 2.71627 4.12215C2.76525 4.01142 2.84535 3.9173 2.94682 3.85124C3.04829 3.78517 3.16676 3.75 3.28784 3.75V3.75Z"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "sort-up-down": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3334 14.1759V9.16758C13.3334 8.70924 12.9584 8.33424 12.5 8.33424C12.0417 8.33424 11.6667 8.70924 11.6667 9.16758V14.1759H10.175C9.80002 14.1759 9.61669 14.6259 9.88336 14.8842L12.2084 17.2009C12.375 17.3592 12.6334 17.3592 12.8 17.2009L15.125 14.8842C15.3917 14.6259 15.2 14.1759 14.8334 14.1759H13.3334ZM7.20836 2.79258L4.88336 5.11758C4.61669 5.37591 4.80003 5.82591 5.17503 5.82591H6.66669V10.8342C6.66669 11.2926 7.04169 11.6676 7.50003 11.6676C7.95836 11.6676 8.33336 11.2926 8.33336 10.8342V5.82591H9.82503C10.2 5.82591 10.3834 5.37591 10.1167 5.11758L7.79169 2.79258C7.63336 2.63424 7.36669 2.63424 7.20836 2.79258Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  "cancel-post": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2496 4.75794C14.9246 4.43294 14.3996 4.43294 14.0746 4.75794L9.99961 8.82461L5.92461 4.74961C5.59961 4.42461 5.07461 4.42461 4.74961 4.74961C4.42461 5.07461 4.42461 5.59961 4.74961 5.92461L8.82461 9.99961L4.74961 14.0746C4.42461 14.3996 4.42461 14.9246 4.74961 15.2496C5.07461 15.5746 5.59961 15.5746 5.92461 15.2496L9.99961 11.1746L14.0746 15.2496C14.3996 15.5746 14.9246 15.5746 15.2496 15.2496C15.5746 14.9246 15.5746 14.3996 15.2496 14.0746L11.1746 9.99961L15.2496 5.92461C15.5663 5.60794 15.5663 5.07461 15.2496 4.75794Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "re-post": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.33333 7.50033V4.16699L2.5 10.0003L8.33333 15.8337V12.417C12.5 12.417 15.4167 13.7503 17.5 16.667C16.6667 12.5003 14.1667 8.33366 8.33333 7.50033Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  "delete-black": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.99935 15.8333C4.99935 16.75 5.74935 17.5 6.66602 17.5H13.3327C14.2493 17.5 14.9993 16.75 14.9993 15.8333V5.83333H4.99935V15.8333ZM6.66602 7.5H13.3327V15.8333H6.66602V7.5ZM12.916 3.33333L12.0827 2.5H7.91602L7.08268 3.33333H4.16602V5H15.8327V3.33333H12.916Z"
        fill="#666666"
      />
    </svg>
  ),
  "edit-black": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#666666"
      />
    </svg>
  ),
  "search-black": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill="#666666"
      />
    </svg>
  ),
  dashboard: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 4.16667V5.83333H12.5V4.16667H15.8333ZM7.5 4.16667V9.16667H4.16667V4.16667H7.5ZM15.8333 10.8333V15.8333H12.5V10.8333H15.8333ZM7.5 14.1667V15.8333H4.16667V14.1667H7.5ZM17.5 2.5H10.8333V7.5H17.5V2.5ZM9.16667 2.5H2.5V10.8333H9.16667V2.5ZM17.5 9.16667H10.8333V17.5H17.5V9.16667ZM9.16667 12.5H2.5V17.5H9.16667V12.5Z"
        fill="#212529"
      />
    </svg>
  ),
  dolar: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.83268 9.08333C7.94102 8.59167 7.33268 8.08333 7.33268 7.29167C7.33268 6.38333 8.17435 5.75 9.58268 5.75C10.766 5.75 11.3577 6.2 11.5743 6.91667C11.6743 7.25 11.9493 7.5 12.2993 7.5H12.5493C13.0993 7.5 13.491 6.95833 13.2993 6.44167C12.9493 5.45833 12.1327 4.64167 10.8327 4.325V3.75C10.8327 3.05833 10.2743 2.5 9.58268 2.5C8.89102 2.5 8.33268 3.05833 8.33268 3.75V4.3C6.71602 4.65 5.41602 5.7 5.41602 7.30833C5.41602 9.23333 7.00768 10.1917 9.33268 10.75C11.416 11.25 11.8327 11.9833 11.8327 12.7583C11.8327 13.3333 11.4243 14.25 9.58268 14.25C8.20768 14.25 7.49935 13.7583 7.22435 13.0583C7.09935 12.7333 6.81602 12.5 6.47435 12.5H6.24102C5.68268 12.5 5.29102 13.0667 5.49935 13.5833C5.97435 14.7417 7.08268 15.425 8.33268 15.6917V16.25C8.33268 16.9417 8.89102 17.5 9.58268 17.5C10.2743 17.5 10.8327 16.9417 10.8327 16.25V15.7083C12.4577 15.4 13.7493 14.4583 13.7493 12.75C13.7493 10.3833 11.7243 9.575 9.83268 9.08333Z"
        fill="#212529"
      />
    </svg>
  ),
  "shopping-icon": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.334 7.50026H14.3423L10.6923 2.03359C10.534 1.80026 10.2673 1.68359 10.0007 1.68359C9.73398 1.68359 9.46732 1.80026 9.30898 2.04193L5.65898 7.50026H1.66732C1.20898 7.50026 0.833984 7.87526 0.833984 8.33359C0.833984 8.40859 0.842318 8.48359 0.867318 8.55859L2.98398 16.2836C3.17565 16.9836 3.81732 17.5003 4.58398 17.5003H15.4173C16.184 17.5003 16.8257 16.9836 17.0257 16.2836L19.1423 8.55859L19.1673 8.33359C19.1673 7.87526 18.7923 7.50026 18.334 7.50026ZM10.0007 4.00026L12.334 7.50026H7.66732L10.0007 4.00026ZM15.4173 15.8336L4.59232 15.8419L2.75898 9.16693H17.2507L15.4173 15.8336ZM10.0007 10.8336C9.08398 10.8336 8.33398 11.5836 8.33398 12.5003C8.33398 13.4169 9.08398 14.1669 10.0007 14.1669C10.9173 14.1669 11.6673 13.4169 11.6673 12.5003C11.6673 11.5836 10.9173 10.8336 10.0007 10.8336Z"
        fill="#212529"
      />
    </svg>
  ),
  "check-box-buy-water": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="15" cy="15" r="15" fill="#DDDDDD" />
      <path d="M6 15L12.5 21L23 10" stroke="white" strokeWidth="3" />
    </svg>
  ),
  "dang-ky-mua-nuoc": (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41618 6.01953C5.62829 6.01953 4.09807 7.45231 4.09807 9.33772V14.7157H1.85319C1.32721 14.7157 0.900879 15.142 0.900879 15.668C0.900879 16.1939 1.32721 16.6202 1.85319 16.6202H4.09807V26.0974H1.85319C1.32721 26.0974 0.900879 26.5237 0.900879 27.0497C0.900879 27.5756 1.32721 28.002 1.85319 28.002H4.09807V32.6126C4.09807 34.4005 5.53078 35.9308 7.41618 35.9308H22.8902C23.1427 35.9308 23.385 35.8304 23.5635 35.6518L29.9578 29.2577C30.1364 29.079 30.2367 28.8368 30.2367 28.5843V13.8776C30.2367 13.3517 29.8103 12.9253 29.2844 12.9253C28.7585 12.9253 28.3322 13.3517 28.3322 13.8776V27.568H22.8901C22.3642 27.568 21.9379 27.9943 21.9379 28.5203V34.0262H7.41618C6.61606 34.0262 6.00261 33.3824 6.00261 32.6126V28.002H8.24734C8.77332 28.002 9.19965 27.5756 9.19965 27.0497C9.19965 26.5237 8.77332 26.0974 8.24734 26.0974H6.00261V16.6202H8.24734C8.77332 16.6202 9.19965 16.1939 9.19965 15.668C9.19965 15.142 8.77332 14.7157 8.24734 14.7157H6.00261V9.33772C6.00261 8.53752 6.64642 7.92415 7.41618 7.92415H26.1513C26.6772 7.92415 27.1035 7.49775 27.1035 6.97184C27.1035 6.44593 26.6772 6.01953 26.1513 6.01953H7.41618ZM23.8424 32.6796L27.0494 29.4726H23.8424V32.6796Z"
        fill="#EAFEFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.1155 1.91945C30.9468 1.08823 32.0338 0.640625 33.1847 0.640625C34.2718 0.640625 35.3588 1.08823 36.1261 1.98343C36.9573 2.75068 37.4049 3.83774 37.4049 4.98869C37.4049 6.13965 36.9573 7.16273 36.19 7.99396L23.2098 20.9742C22.3785 21.7415 21.3555 22.1891 20.2685 22.1891H15.9204V17.841C15.9204 16.6901 16.368 15.667 17.1353 14.8997L30.1155 1.91945ZM22.7297 18.8918L32.6732 8.88916L29.1564 5.37232L19.213 15.375L22.7297 18.8918ZM17.9542 16.8097C17.796 17.124 17.7107 17.4718 17.7107 17.841V20.3987H20.2685C20.6376 20.3987 20.9855 20.3135 21.2998 20.1552L17.9542 16.8097ZM33.9521 7.67423L34.9112 6.65115C35.4227 6.20362 35.6785 5.56417 35.7424 4.86082C35.8064 4.22137 35.4866 3.51801 35.039 3.07041C34.5914 2.62281 33.9521 2.36706 33.2487 2.36706C32.5454 2.36706 31.9059 2.62281 31.4583 3.13439L30.4352 4.15747L33.9521 7.67423ZM29.8967 8.02705C30.2668 8.40063 30.2641 9.00359 29.8905 9.3737L22.9208 16.2795C22.5472 16.6496 21.9442 16.6469 21.5741 16.2733C21.2039 15.8996 21.2067 15.2968 21.5803 14.9266L28.55 8.02077C28.9235 7.65066 29.5265 7.6534 29.8967 8.02705Z"
        fill="#FFF501"
      />
    </svg>
  ),
  "tra-cuu-su-dung-nuoc": (
    <svg
      width="40"
      height="29"
      viewBox="0 0 40 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C8.97278 0 0 8.82788 0 19.677V23.819C0 26.6775 2.36058 29 5.26196 29H34.736C37.6374 29 40 26.6775 40 23.821V19.679C40 8.82788 31.0272 0 20 0ZM37.896 23.821C37.896 25.5337 36.4788 26.928 34.738 26.928H5.26196C3.5211 26.928 2.10399 25.5337 2.10399 23.821V20.714H5.26196C5.84222 20.714 6.31396 20.2499 6.31396 19.679C6.31594 19.1062 5.84421 18.6421 5.26196 18.6421H2.15726C2.40004 14.568 4.04817 10.8706 6.64167 8.00267L8.72788 10.0533C8.93516 10.2553 9.20358 10.3582 9.47398 10.3582C9.74439 10.3582 10.0128 10.2572 10.2201 10.0553C10.6306 9.65136 10.6306 8.99502 10.2201 8.59106L8.1338 6.54049C11.0491 3.98886 14.8071 2.36547 18.9478 2.12655V5.17923C18.9478 5.75012 19.4196 6.21423 19.9998 6.21423C20.5801 6.21423 21.0518 5.75012 21.0518 5.17923V2.12467C25.1928 2.36352 28.9508 3.98496 31.8658 6.53854L29.7795 8.58918C29.369 8.99307 29.369 9.64941 29.7795 10.0533C29.9868 10.2553 30.2572 10.3582 30.5256 10.3582C30.796 10.3582 31.0645 10.2572 31.2718 10.0553L33.358 8.00462C36.1706 11.1155 37.8977 15.1994 37.8977 19.681V23.8211L37.896 23.821Z"
        fill="white"
      />
      <path
        d="M32.7738 16.2152L25.1932 17.5333C24.4293 15.4727 22.5212 14 20.2787 14C17.3692 14 15 16.4669 15 19.5011C15 22.5352 17.3692 25 20.2787 25C23.1229 25 25.4328 22.6425 25.5377 19.7012L33.1183 18.3831C33.6923 18.2841 34.0822 17.7169 33.9852 17.1188C33.8921 16.5186 33.3459 16.1143 32.7739 16.2153L32.7738 16.2152ZM20.2788 22.8014C18.5331 22.8014 17.112 21.3205 17.112 19.5012C17.112 17.682 18.5331 16.201 20.2788 16.201C21.8484 16.201 23.1428 17.3973 23.3922 18.9608C23.4219 19.1383 23.4457 19.3176 23.4457 19.5012C23.4457 21.3205 22.0245 22.8014 20.2788 22.8014Z"
        fill="#FFF001"
      />
    </svg>
  ),
  "hoa-don-dien-tu": (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.2192 3.20672H27.4339C27.1195 2.27578 26.2384 1.60341 25.2026 1.60341H23.5576C22.8149 0.604781 21.6387 0 20.3926 0C19.1465 0 17.9702 0.604781 17.2276 1.60331H15.5826C14.5468 1.60331 13.6658 2.27569 13.3513 3.20663H7.56574C5.82518 3.20663 4.40918 4.62272 4.40918 6.36319V40.0333C4.40918 41.7739 5.82527 43.1899 7.56574 43.1899H23.5991C24.0142 43.1899 24.3507 42.8534 24.3507 42.4383C24.3507 42.0233 24.0143 41.6867 23.5991 41.6867H7.56574C6.65402 41.6867 5.91227 40.9449 5.91227 40.0332V6.36328C5.91227 5.45156 6.65402 4.70981 7.56574 4.70981H13.2277V7.16494C13.2277 7.57997 13.5641 7.91653 13.9793 7.91653H26.806C27.221 7.91653 27.5576 7.58006 27.5576 7.16494V4.70981H33.2192C34.1309 4.70981 34.8727 5.45156 34.8727 6.36328V28.0084C34.8727 28.4234 35.2091 28.76 35.6243 28.76C36.0393 28.76 36.3759 28.4235 36.3759 28.0084V6.36328C36.3758 4.62272 34.9598 3.20672 33.2192 3.20672ZM26.0545 6.41334H14.7309V3.96113C14.7309 3.96009 14.731 3.95925 14.731 3.95822C14.731 3.95775 14.7309 3.95719 14.7309 3.95681C14.7317 3.48769 15.1134 3.10641 15.5826 3.10641H17.6306C17.8982 3.10641 18.1456 2.96419 18.2802 2.73281C18.7285 1.96284 19.5181 1.50309 20.3926 1.50309C21.2671 1.50309 22.0568 1.96284 22.505 2.73281C22.6395 2.96409 22.887 3.10641 23.1546 3.10641H25.2026C25.6713 3.10641 26.0527 3.48694 26.0544 3.95531C26.0544 3.95634 26.0543 3.95719 26.0543 3.95822C26.0543 3.96019 26.0546 3.96206 26.0546 3.96403L26.0545 6.41334Z"
        fill="white"
      />
      <path
        d="M23.599 38.4809H9.11906V7.91725H10.7728C11.1878 7.91725 11.5244 7.58078 11.5244 7.16566C11.5244 6.75053 11.1879 6.41406 10.7728 6.41406H8.36756C7.95253 6.41406 7.61597 6.75053 7.61597 7.16566V39.2325C7.61597 39.6475 7.95244 39.9841 8.36756 39.9841H23.5991C24.0142 39.9841 24.3507 39.6476 24.3507 39.2325C24.3506 38.8173 24.0142 38.4809 23.599 38.4809Z"
        fill="white"
      />
      <path
        d="M32.4175 6.41406H30.0126C29.5975 6.41406 29.261 6.75053 29.261 7.16566C29.261 7.58078 29.5975 7.91725 30.0126 7.91725H31.666V28.0089C31.666 28.4239 32.0025 28.7605 32.4176 28.7605C32.8328 28.7605 33.1692 28.424 33.1692 28.0089V7.16566C33.1691 6.75063 32.8326 6.41406 32.4175 6.41406Z"
        fill="white"
      />
      <path
        d="M34.8225 30.4609C29.9876 30.4609 26.0542 34.3943 26.0542 39.2292C26.0542 44.0641 29.9877 47.9974 34.8225 47.9974C39.6572 47.9974 43.5907 44.0641 43.5907 39.2292C43.5907 34.3943 39.6573 30.4609 34.8225 30.4609ZM34.8225 46.4943C30.8164 46.4943 27.5573 43.2352 27.5573 39.2292C27.5573 35.2232 30.8164 31.964 34.8225 31.964C38.8285 31.964 42.0876 35.2232 42.0876 39.2292C42.0876 43.2352 38.8286 46.4943 34.8225 46.4943Z"
        fill="white"
      />
      <path
        d="M20.4006 3.20703H20.3926C19.9776 3.20703 19.645 3.5435 19.645 3.95862C19.645 4.37366 19.9854 4.71022 20.4006 4.71022C20.8156 4.71022 21.1521 4.37375 21.1521 3.95862C21.1522 3.5435 20.8158 3.20703 20.4006 3.20703Z"
        fill="white"
      />
      <path
        d="M39.3624 36.2944C39.0689 36.0008 38.593 36.0008 38.2995 36.2944L33.2192 41.3747L30.544 38.6994C30.2504 38.4059 29.7746 38.4059 29.4811 38.6994C29.1876 38.993 29.1876 39.4688 29.4811 39.7623L32.6879 42.969C32.8346 43.1157 33.0269 43.1891 33.2192 43.1891C33.4115 43.1891 33.6039 43.1158 33.7506 42.969L39.3623 37.3573C39.6558 37.0637 39.6558 36.5878 39.3624 36.2944Z"
        fill="#FFF501"
      />
      <path
        d="M17.1357 16.6221V13.5904C18.1946 13.7717 18.8392 14.3112 18.8392 14.705C18.8392 15.12 19.1757 15.4566 19.5908 15.4566C20.0059 15.4566 20.3424 15.1201 20.3424 14.705C20.3424 13.3765 18.9838 12.303 17.1357 12.0714V11.9743C17.1357 11.5592 16.7992 11.2227 16.3841 11.2227C15.969 11.2227 15.6325 11.5591 15.6325 11.9743V12.0714C13.7844 12.3029 12.4258 13.3764 12.4258 14.705C12.4258 16.5869 14.191 17.3101 15.6325 17.7482V20.7799C14.5736 20.5986 13.929 20.0592 13.929 19.6653C13.929 19.2503 13.5925 18.9137 13.1774 18.9137C12.7622 18.9137 12.4258 19.2502 12.4258 19.6653C12.4258 20.9938 13.7844 22.0673 15.6325 22.2989V22.3961C15.6325 22.8111 15.969 23.1477 16.3841 23.1477C16.7992 23.1477 17.1357 22.8112 17.1357 22.3961V22.2989C18.9838 22.0674 20.3424 20.9939 20.3424 19.6653C20.3423 17.7835 18.5772 17.0602 17.1357 16.6221ZM15.6325 16.1629C14.3646 15.7211 13.929 15.3226 13.929 14.705C13.929 14.4673 14.1386 14.2048 14.504 13.985C14.8128 13.7992 15.2046 13.6648 15.6325 13.5914V16.1629ZM18.2642 20.3853C17.9553 20.5711 17.5636 20.7055 17.1357 20.7789V18.2074C18.4036 18.6493 18.8392 19.0477 18.8392 19.6653C18.8392 19.9031 18.6296 20.1655 18.2642 20.3853Z"
        fill="#FFF501"
      />
      <path
        d="M27.6076 12.8281H23.5992C23.1842 12.8281 22.8477 13.1646 22.8477 13.5797C22.8477 13.9948 23.1841 14.3313 23.5992 14.3313H27.6076C28.0227 14.3313 28.3592 13.9948 28.3592 13.5797C28.3592 13.1646 28.0228 12.8281 27.6076 12.8281Z"
        fill="white"
      />
      <path
        d="M26.0042 16.0352H23.5993C23.1842 16.0352 22.8477 16.3716 22.8477 16.7867C22.8477 17.2019 23.1841 17.5383 23.5993 17.5383H26.0042C26.4192 17.5383 26.7558 17.2019 26.7558 16.7867C26.7558 16.3716 26.4192 16.0352 26.0042 16.0352Z"
        fill="white"
      />
      <path
        d="M27.6074 19.2383H23.599C23.184 19.2383 22.8474 19.5747 22.8474 19.9899C22.8474 20.405 23.1839 20.7415 23.599 20.7415H27.6074C28.0224 20.7415 28.359 20.405 28.359 19.9899C28.359 19.5747 28.0225 19.2383 27.6074 19.2383Z"
        fill="white"
      />
      <path
        d="M14.7809 26.457H13.1776C12.7626 26.457 12.426 26.7935 12.426 27.2086C12.426 27.6237 12.7625 27.9602 13.1776 27.9602H14.7809C15.196 27.9602 15.5325 27.6237 15.5325 27.2086C15.5325 26.7935 15.196 26.457 14.7809 26.457Z"
        fill="white"
      />
      <path
        d="M14.7807 32.8672H13.1774C12.7623 32.8672 12.4258 33.2037 12.4258 33.6188C12.4258 34.0339 12.7622 34.3704 13.1774 34.3704H14.7807C15.1957 34.3704 15.5323 34.0339 15.5323 33.6188C15.5323 33.2037 15.1957 32.8672 14.7807 32.8672Z"
        fill="white"
      />
      <path
        d="M14.7807 29.6641H13.1774C12.7623 29.6641 12.4258 30.0005 12.4258 30.4157C12.4258 30.8308 12.7622 31.1672 13.1774 31.1672H14.7807C15.1957 31.1672 15.5323 30.8308 15.5323 30.4157C15.5323 30.0005 15.1957 29.6641 14.7807 29.6641Z"
        fill="white"
      />
      <path
        d="M27.6075 26.457H17.9874C17.5724 26.457 17.2358 26.7935 17.2358 27.2086C17.2358 27.6237 17.5723 27.9602 17.9874 27.9602H27.6075C28.0225 27.9602 28.3591 27.6237 28.3591 27.2086C28.3591 26.7935 28.0226 26.457 27.6075 26.457Z"
        fill="white"
      />
      <path
        d="M25.2024 32.8672H17.9874C17.5724 32.8672 17.2358 33.2037 17.2358 33.6188C17.2358 34.0339 17.5723 34.3704 17.9874 34.3704H25.2024C25.6175 34.3704 25.954 34.0339 25.954 33.6188C25.954 33.2037 25.6175 32.8672 25.2024 32.8672Z"
        fill="white"
      />
      <path
        d="M27.6075 29.6641H17.9874C17.5724 29.6641 17.2358 30.0005 17.2358 30.4157C17.2358 30.8308 17.5723 31.1672 17.9874 31.1672H27.6075C28.0225 31.1672 28.3591 30.8308 28.3591 30.4157C28.3591 30.0005 28.0226 29.6641 27.6075 29.6641Z"
        fill="white"
      />
    </svg>
  ),
  "thanh-toan-truc-tuyen": (
    <svg
      width="32"
      height="35"
      viewBox="0 0 32 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7265 0.378906C19.9154 0.378906 20.0916 0.433056 20.2406 0.526728C20.3017 0.565068 20.3587 0.610352 20.4105 0.662212L27.3774 7.62911C27.5587 7.8104 27.6605 8.05625 27.6605 8.31259V15.3666C27.6605 15.9005 27.2278 16.3332 26.6939 16.3332C26.16 16.3332 25.7273 15.9005 25.7273 15.3666V9.27908H19.7265C19.1927 9.27908 18.7598 8.84633 18.7598 8.31244V2.31241H2.78875V32.3571H14.7109C15.2447 32.3571 15.6775 32.7898 15.6775 33.3237C15.6775 33.8576 15.2447 34.2903 14.7109 34.2903H1.82211C1.28822 34.2903 0.855469 33.8576 0.855469 33.3237V1.34577C0.855469 0.811881 1.28822 0.379053 1.82211 0.379053H19.7082L19.7265 0.378906ZM20.6932 7.3458V3.67893L24.36 7.3458H20.6932ZM8.6496 11.3167C8.11579 11.3167 7.68297 11.7495 7.68297 12.2834C7.68297 12.8173 8.11579 13.25 8.6496 13.25H19.1696C19.7035 13.25 20.1363 12.8173 20.1363 12.2834C20.1363 11.7495 19.7035 11.3167 19.1696 11.3167H8.6496ZM4.57369 16.7422C4.57369 16.2083 5.00644 15.7756 5.54033 15.7756H15.6773C16.2112 15.7756 16.644 16.2083 16.644 16.7422C16.644 17.2761 16.2112 17.7088 15.6773 17.7088H5.54033C5.00644 17.7088 4.57369 17.2761 4.57369 16.7422ZM5.86249 20.2344C5.32861 20.2344 4.89585 20.6671 4.89585 21.201C4.89585 21.7349 5.32861 22.1676 5.86249 22.1676H11.9411C12.4749 22.1676 12.9078 21.7349 12.9078 21.201C12.9078 20.6671 12.4749 20.2344 11.9411 20.2344H5.86249ZM4.89585 25.6598C4.89585 25.1259 5.32861 24.6932 5.86249 24.6932H11.0354C11.5693 24.6932 12.0021 25.1259 12.0021 25.6598C12.0021 26.1937 11.5693 26.6264 11.0354 26.6264H5.86249C5.32861 26.6264 4.89585 26.1937 4.89585 25.6598ZM15.1199 25.3812C15.1199 21.4902 18.2741 18.3359 22.1651 18.3359C26.0561 18.3359 29.2103 21.4902 29.2103 25.3812C29.2103 29.2722 26.0561 32.4264 22.1651 32.4264C18.2741 32.4264 15.1199 29.2722 15.1199 25.3812ZM22.1651 16.4027C17.2063 16.4027 13.1865 20.4224 13.1865 25.3812C13.1865 30.3399 17.2063 34.3598 22.1651 34.3598C27.1238 34.3598 31.1437 30.3399 31.1437 25.3812C31.1437 20.4224 27.1238 16.4027 22.1651 16.4027Z"
        fill="white"
      />
      <path
        d="M22.1216 24.7947C23.8979 24.7947 25.3438 26.08 25.3438 27.6589C25.3438 28.9889 24.3127 30.1006 22.9272 30.421V31.1496C22.9272 31.5945 22.5665 31.9551 22.1216 31.9551C21.6767 31.9551 21.316 31.5945 21.316 31.1496V30.421C20.2171 30.1668 19.3412 29.415 19.0258 28.4511C18.8874 28.0283 19.2601 27.6589 19.705 27.6589C20.1499 27.6589 20.4978 28.0495 20.7532 28.4138C21.0378 28.82 21.5449 29.0909 22.1216 29.0909C23.0098 29.0909 23.7327 28.4483 23.7327 27.6589C23.7327 26.8694 23.0098 26.2268 22.1216 26.2268C20.3454 26.2268 18.8994 24.9415 18.8994 23.3626C18.8994 22.0326 19.9305 20.9209 21.316 20.6005V19.8719C21.316 19.4271 21.6767 19.0664 22.1216 19.0664C22.5665 19.0664 22.9272 19.4271 22.9272 19.8719V20.6005C24.0261 20.8547 24.902 21.6066 25.2174 22.5704C25.3558 22.9932 24.9831 23.3626 24.5383 23.3626C24.0933 23.3626 23.7454 22.972 23.4901 22.6077C23.2054 22.2015 22.6983 21.9306 22.1216 21.9306C21.2335 21.9306 20.5105 22.5732 20.5105 23.3626C20.5105 24.1521 21.2335 24.7947 22.1216 24.7947Z"
        fill="#FFF001"
      />
    </svg>
  ),
  "sua-chua": (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_552_10132)">
        <path
          d="M31.7058 10.5995C30.118 6.82871 27.1858 3.78242 23.4782 2.05204C19.7707 0.321651 15.5525 0.0306268 11.6425 1.23546C7.73244 2.4403 4.4096 5.05503 2.31902 8.57205C0.228435 12.0891 -0.480721 16.2574 0.329222 20.2679C1.13917 24.2784 3.41042 27.8448 6.70205 30.2749C9.99368 32.7049 14.0708 33.8252 18.142 33.4181C22.2131 33.0111 25.9878 31.1059 28.7332 28.0723C31.4786 25.0387 32.9988 21.0932 32.9988 17.0017C33.0017 14.8025 32.5619 12.6252 31.7058 10.5995ZM29.8124 22.6031C28.4233 25.9045 25.857 28.5719 22.6117 30.0874C19.3664 31.603 15.6737 31.8585 12.2506 30.8045C8.82747 29.7504 5.91817 27.4619 4.08752 24.3834C2.25687 21.3048 1.6355 17.6558 2.34405 14.1449C3.0526 10.634 5.04051 7.51156 7.92184 5.38394C10.8032 3.25632 14.3723 2.27528 17.9363 2.6313C21.5003 2.98732 24.8048 4.65499 27.2083 7.31053C29.6118 9.96607 30.9428 13.42 30.9429 17.0017C30.9455 18.9258 30.5611 20.8307 29.8124 22.6031V22.6031Z"
          fill="white"
        />
        <path
          d="M21.4629 18.4041C21.4014 18.342 21.3323 18.2881 21.2573 18.2435C22.1317 16.0269 21.6749 13.4015 19.8846 11.6116C19.0359 10.763 17.9582 10.1803 16.7834 9.93499C15.6086 9.68965 14.3878 9.79225 13.2704 10.2302C13.1113 10.2924 12.9702 10.3931 12.8599 10.5234C12.7495 10.6538 12.6734 10.8095 12.6383 10.9766C12.6033 11.1438 12.6104 11.317 12.659 11.4807C12.7077 11.6443 12.7964 11.7933 12.917 11.9142L14.795 13.7921L13.3414 15.2457L11.4647 13.369C11.3439 13.2484 11.1949 13.1597 11.0312 13.111C10.8675 13.0624 10.6943 13.0553 10.5272 13.0903C10.3601 13.1254 10.2043 13.2015 10.074 13.3119C9.9437 13.4223 9.84292 13.5633 9.7808 13.7224C9.33214 14.8715 9.23815 16.1287 9.51096 17.3318C9.78376 18.5348 10.4108 19.6285 11.3113 20.4717C12.2117 21.3149 13.3441 21.869 14.5625 22.0623C15.7809 22.2556 17.0292 22.0794 18.1464 21.5564L20.6974 24.1073C20.9093 24.3219 21.1615 24.4925 21.4396 24.6092C21.7176 24.7259 22.016 24.7865 22.3176 24.7874C22.6192 24.7884 22.918 24.7297 23.1968 24.6147C23.4756 24.4998 23.7289 24.3308 23.9421 24.1175C24.1554 23.9043 24.3243 23.651 24.4393 23.3722C24.5543 23.0934 24.613 22.7946 24.612 22.493C24.6111 22.1915 24.5505 21.8931 24.4338 21.615C24.317 21.3369 24.1465 21.0847 23.9319 20.8728L21.4629 18.4041ZM12.6157 18.8814C11.9074 18.1733 11.4819 17.2309 11.4191 16.2312L12.6157 17.4278C12.8085 17.6206 13.0699 17.7288 13.3425 17.7288C13.6151 17.7288 13.8765 17.6206 14.0693 17.4278L16.9768 14.5203C17.1695 14.3276 17.2778 14.0661 17.2778 13.7935C17.2778 13.521 17.1695 13.2595 16.9768 13.0667L15.7805 11.8698C16.4445 11.9115 17.0884 12.1137 17.657 12.459C18.2257 12.8043 18.702 13.2824 19.0452 13.8523C19.3884 14.4222 19.5882 15.0669 19.6275 15.731C19.6667 16.3951 19.5442 17.0588 19.2706 17.6652C18.9969 18.2715 18.5801 18.8024 18.0561 19.2123C17.5321 19.6222 16.9165 19.8988 16.2621 20.0184C15.6076 20.138 14.934 20.097 14.2989 19.899C13.6638 19.701 13.0862 19.3518 12.6157 18.8814V18.8814ZM22.4776 22.6534C22.4343 22.6967 22.3755 22.7211 22.3141 22.7211C22.2528 22.7211 22.194 22.6967 22.1506 22.6534L19.858 20.3607L19.884 20.3354C19.9853 20.2341 20.0817 20.1302 20.1731 20.0238L22.476 22.3267C22.4976 22.348 22.5148 22.3734 22.5266 22.4013C22.5383 22.4293 22.5445 22.4593 22.5447 22.4896C22.5449 22.52 22.5391 22.5501 22.5276 22.5782C22.5162 22.6062 22.4993 22.6318 22.478 22.6534H22.4776Z"
          fill="#FFF501"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_10132">
          <rect
            width="33.0967"
            height="33"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "lap-dat": (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_552_10119)">
        <path
          d="M6.79384 1.24144e-05C5.72135 1.24144e-05 4.74374 0.193885 3.76612 0.68063C3.18038 0.973502 2.98238 1.75312 3.47325 2.23986L6.79384 5.54808L5.62235 6.7175L2.30176 3.40723C2.21569 3.31168 2.10986 3.236 1.99163 3.18543C1.87339 3.13486 1.74557 3.11061 1.61702 3.11435C1.22515 3.11435 0.932279 3.31029 0.738406 3.7001C0.0952743 4.98114 -0.128307 6.43213 0.0993581 7.84735C0.327023 9.26258 0.994383 10.5702 2.00683 11.585C3.37425 12.9462 5.03661 13.5299 6.79384 13.5299C7.57758 13.5299 8.3572 13.4329 9.04194 13.1421L19.8844 23.9474C19.0058 26.3812 19.5915 29.1057 21.4478 31.0527C22.8152 32.4139 24.4755 32.9997 26.2327 32.9997C27.3093 32.9997 28.2849 32.8058 29.2645 32.319C29.8482 32.0262 30.0442 31.2466 29.5553 30.7598L26.2348 27.4516L27.4062 26.2822L30.7268 29.5924C30.8129 29.688 30.9187 29.7637 31.037 29.8142C31.1552 29.8648 31.283 29.8891 31.4116 29.8853C31.8034 29.8853 32.0963 29.6894 32.2902 29.2996C32.9333 28.0185 33.1569 26.5675 32.9292 25.1523C32.7016 23.7371 32.0342 22.4294 31.0218 21.4147C29.6544 20.0535 27.992 19.4698 26.2348 19.4698C25.451 19.4698 24.6714 19.5667 23.8897 19.8576L13.0493 9.05429C13.928 6.62057 13.3422 3.89603 11.486 1.94905C10.8717 1.32992 10.1407 0.838849 9.33524 0.504285C8.52981 0.169721 7.66599 -0.00168018 6.79384 1.24144e-05ZM5.52336 8.76142C5.77888 8.7595 6.03149 8.70693 6.26656 8.60674C6.50163 8.50655 6.7145 8.36074 6.89284 8.17774L8.06433 7.00831C8.24938 6.83294 8.39676 6.6217 8.49747 6.38749C8.59819 6.15327 8.65013 5.901 8.65013 5.64605C8.65013 5.3911 8.59819 5.13882 8.49747 4.90461C8.39676 4.67039 8.24938 4.45915 8.06433 4.28378L5.81623 2.04187C6.11116 2.04187 6.40403 1.94493 6.69691 1.94493C7.96739 1.94493 9.23582 2.43167 10.1165 3.40516C11.4839 4.7664 11.8737 6.71544 11.288 8.46649C10.9951 9.1471 11.191 9.92672 11.7768 10.5104L22.6192 21.3178C23.0111 21.7055 23.4999 21.8994 23.9867 21.8994C24.1826 21.8994 24.4755 21.8994 24.6714 21.8025C25.2021 21.6036 25.765 21.505 26.3317 21.5117C27.6022 21.5117 28.8727 21.9984 29.7513 22.9719C30.9228 24.1393 31.4116 25.6964 31.1187 27.2536L28.8706 25.0158C28.6927 24.8333 28.4806 24.6878 28.2462 24.5876C28.0119 24.4874 27.7601 24.4346 27.5052 24.4321C27.2497 24.434 26.9971 24.4866 26.762 24.5868C26.527 24.687 26.3141 24.8328 26.1358 25.0158L24.9643 26.1832C24.7812 26.3599 24.6352 26.5712 24.5346 26.8049C24.4341 27.0386 24.381 27.29 24.3785 27.5444C24.3805 27.7995 24.4333 28.0517 24.5338 28.2861C24.6344 28.5205 24.7808 28.7326 24.9643 28.9098L27.2124 31.1476C26.9174 31.1476 26.6246 31.2445 26.3317 31.2445C25.0612 31.2445 23.7928 30.7577 22.9121 29.7843C22.2613 29.1357 21.8062 28.3171 21.599 27.4219C21.3918 26.5268 21.4409 25.5915 21.7406 24.7229C22.0335 24.0423 21.8376 23.2627 21.2518 22.6811L10.4094 11.8737C10.2313 11.6909 10.0187 11.5453 9.78403 11.4451C9.54933 11.3449 9.29712 11.2922 9.04194 11.29C8.84601 11.29 8.65007 11.29 8.3572 11.387C7.82667 11.5865 7.26369 11.6858 6.69691 11.6798C5.42642 11.6798 4.15593 11.1931 3.27732 10.2196C2.10583 9.05017 1.61702 7.493 1.90989 5.93582L4.158 8.17568C4.5478 8.56342 5.03661 8.75936 5.52336 8.75936V8.76142Z"
          fill="white"
        />
        <path
          d="M10.2483 18.1749C9.99833 18.1771 9.75132 18.229 9.52155 18.3274C9.29178 18.4258 9.08383 18.5689 8.90974 18.7482L2.02106 25.6349C1.83966 25.8076 1.69525 26.0155 1.59658 26.2457C1.4979 26.476 1.44702 26.7239 1.44702 26.9744C1.44702 27.225 1.4979 27.4729 1.59658 27.7031C1.69525 27.9334 1.83966 28.1412 2.02106 28.314L4.70228 30.9911C4.87637 31.1705 5.08433 31.3135 5.31409 31.4119C5.54386 31.5104 5.79088 31.5622 6.04083 31.5645C6.29078 31.5622 6.5378 31.5104 6.76757 31.4119C6.99734 31.3135 7.20529 31.1705 7.37938 30.9911L14.2681 24.1045C14.4495 23.9317 14.5939 23.7239 14.6925 23.4936C14.7912 23.2633 14.8421 23.0154 14.8421 22.7649C14.8421 22.5144 14.7912 22.2665 14.6925 22.0362C14.5939 21.806 14.4495 21.5981 14.2681 21.4253L11.5848 18.7482C11.2981 18.3646 10.8217 18.1749 10.2462 18.1749H10.2483ZM6.1357 29.6526L3.45861 26.9734L10.3452 20.0889L13.0223 22.768L6.1357 29.6546V29.6526ZM29.3798 2.29585L30.7184 3.63647L27.371 6.98387L26.7007 6.31356L26.0304 5.64326L29.3798 2.29585ZM29.3798 0.000316533C29.2538 -0.00308617 29.1286 0.0209798 29.0129 0.0708426C28.8971 0.120706 28.7936 0.19517 28.7095 0.289063L24.0236 4.97501C23.9329 5.06132 23.8607 5.16514 23.8114 5.28019C23.7621 5.39524 23.7366 5.51911 23.7366 5.64429C23.7366 5.76946 23.7621 5.89334 23.8114 6.00838C23.8607 6.12343 23.9329 6.22726 24.0236 6.31356L24.6918 6.98387L20.0059 11.6698C19.9149 11.7561 19.8424 11.8601 19.7929 11.9753C19.7434 12.0906 19.7178 12.2147 19.7178 12.3401C19.7178 12.4656 19.7434 12.5897 19.7929 12.7049C19.8424 12.8201 19.9149 12.9241 20.0059 13.0104C20.1977 13.2002 20.4844 13.2951 20.6741 13.2951C20.925 13.2841 21.1632 13.1822 21.3444 13.0084L26.0304 8.32242L26.7007 8.99066C26.8925 9.18247 27.1792 9.2794 27.371 9.2794C27.6214 9.2674 27.8589 9.16478 28.0392 8.99066L32.7272 4.30471C32.8182 4.21838 32.8907 4.11443 32.9402 3.99919C32.9897 3.88395 33.0153 3.75983 33.0153 3.6344C33.0153 3.50897 32.9897 3.38486 32.9402 3.26962C32.8907 3.15438 32.8182 3.05043 32.7272 2.9641L30.0481 0.289063C29.9532 0.0951905 29.6665 0.000316533 29.3798 0.000316533Z"
          fill="#FFF501"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_10119">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "sang-ten": (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_552_10162)">
        <path
          d="M21.6777 0H7.17998C6.92368 0 6.6777 0.101967 6.49642 0.283241L0.283241 6.49642C0.101967 6.6777 0 6.92368 0 7.17998V29.9621C0 31.6372 1.36283 33 3.03786 33H21.6777C22.4896 33 23.2527 32.6838 23.8258 32.11C24.3995 31.5365 24.7155 30.7736 24.7155 29.9621V20L21 23.7605L18.5 22L24.7155 10.2324V3.03786C24.7155 2.2264 24.3995 1.46354 23.8263 0.890259C23.2527 0.316223 22.4896 0 21.6777 0ZM7.24896 2.26517V6.14445C7.24896 6.75348 6.75348 7.24871 6.1447 7.24871H2.26517L7.24896 2.26517ZM22.7822 29.9621C22.7822 30.257 22.6671 30.5342 22.4581 30.7431C22.2499 30.9516 21.9727 31.0664 21.6779 31.0664H3.03786C2.42908 31.0664 1.93359 30.5709 1.93359 29.9621V9.18256H6.14445C7.81947 9.18256 9.1823 7.81973 9.1823 6.1447V1.93359H21.6777C21.9727 1.93359 22.2499 2.0484 22.4586 2.25737C22.6671 2.46584 22.7819 2.74303 22.7819 3.03786L22.782 10.6558L17 23L21.5 25L22.7821 23.7605L22.7822 29.9621Z"
          fill="white"
        />
        <path
          d="M18.5711 12.4258H6.14453C5.61078 12.4258 5.17773 12.8586 5.17773 13.3926C5.17773 13.9266 5.61078 14.3594 6.14453 14.3594H18.5711C19.1051 14.3594 19.5379 13.9266 19.5379 13.3926C19.5379 12.8586 19.1051 12.4258 18.5711 12.4258Z"
          fill="white"
        />
        <path
          d="M16.7058 16.5703H6.00988C5.55047 16.5703 5.17773 17.0031 5.17773 17.5371C5.17773 18.0711 5.55047 18.5039 6.00988 18.5039H16.7058C17.1654 18.5039 17.5379 18.0711 17.5379 17.5371C17.5379 17.0031 17.1654 16.5703 16.7058 16.5703Z"
          fill="white"
        />
        <path
          d="M14.8404 20.7109H5.87523C5.49016 20.7109 5.17773 21.144 5.17773 21.6777C5.17773 22.2117 5.49016 22.6445 5.87523 22.6445H14.8404C15.2257 22.6445 15.5379 22.2117 15.5379 21.6777C15.5379 21.144 15.2257 20.7109 14.8404 20.7109Z"
          fill="white"
        />
        <path
          d="M12.358 24.8516H6.14453C5.61078 24.8516 5.17773 25.2844 5.17773 25.8184C5.17773 26.3521 5.61078 26.7852 6.14453 26.7852H12.358C12.8917 26.7852 13.3248 26.3521 13.3248 25.8184C13.3248 25.2844 12.892 24.8516 12.358 24.8516Z"
          fill="white"
        />
        <path
          d="M29.9562 2.30854C28.4445 1.58703 26.6276 2.22992 25.9061 3.74159L17.1955 21.9916C15.8261 24.8606 15.1332 28.057 15.1916 31.2354C15.1982 31.6015 15.4113 31.9325 15.7416 32.0902C16.0722 32.248 16.4634 32.2053 16.7524 31.9803C19.2599 30.0267 21.3094 27.4775 22.6787 24.6087L31.3892 6.35866C32.1107 4.847 31.4679 3.03004 29.9562 2.30854V2.30854ZM29.1233 4.05356C29.6727 4.31578 29.9064 4.97637 29.6442 5.52578L28.7225 7.45689L26.7294 6.50558L27.6511 4.57447C27.9133 4.02506 28.5737 3.79122 29.1233 4.05356ZM21.1395 23.3445L19.1463 22.3932L25.8965 8.2506L27.8896 9.20191L21.1395 23.3445ZM17.2157 29.0019C17.3825 27.3477 17.7712 25.7151 18.3664 24.1635L20.2537 25.0643C19.4216 26.5031 18.3966 27.8317 17.2157 29.0019Z"
          fill="#FFF501"
        />
        <g clipPath="url(#clip1_552_10162)">
          <path
            d="M292.9 -101L268 -125.9C247.75 -146.15 215 -146.15 194.75 -125.9L35.5 32.8C5.39999 62.8 -11.9 104.3 -12 146.8C-15.875 146.55 -19.5 144.413 -21.375 140.538C-33.255 116.658 -67.625 110.158 -87.375 126.418L-101.255 84.788C-104.5 74.9 -113.6 68.3 -124 68.3C-134.4 68.3 -143.5 74.925 -146.75 84.8L-165 139.4C-166.5 144 -170.75 147 -175.62 147H-188C-196.87 147 -204 154.1 -204 163C-204 171.9 -196.87 179 -188 179H-175.6C-156.98 179 -140.5 167.12 -134.62 149.5L-124 117.6L-107.2 168C-102.6 181.6 -84 182.9 -77.7 170.1L-69.951 154.72C-65.951 146.72 -54.261 146.22 -49.761 155.095C-42.6 169.6 -28.1 178.7 -12 178.9L20 179C86.84 179 132.1 132.7 134.1 131.5L292.9 -27.8C302.6 -37.5 308 -50.6 308 -64.4C308 -78.2 302.6 -91.2 292.9 -101ZM111.5 109C87.3 133.3 54.4 146.9 20 146.9C20 112.52 33.75 79.58 57.1 55.46L177.7 -64.44L230.45 -11.69L111.5 109ZM270.3 -50.4L249 -29.2L196.3 -82L217.42 -103.25C225.17 -110.875 237.67 -110.999 245.42 -103.25L270.3 -78.37C277.9 -70.6 277.9 -58.1 270.3 -50.4ZM96.4 211C89.771 211 83.3 214.795 81.2 221.1C76.1 233.8 65 243 50.1 243H-205.1C-222.72 243 -236.99 228.67 -236.99 211V-173C-236.99 -190.67 -222.71 -205 -205.1 -205H-77.5V-93C-77.5 -66.49 -56.08 -45 -29.66 -45H34.41C43.062 -45 50.07 -52.037 50.07 -60.72V-61.3C50.1 -70 43.9 -77 35.3 -77H-28.8C-37.6 -77 -44.7 -84.2 -44.7 -93V-202.92C-40.239 -201.354 -36.063 -199.074 -32.62 -195.621L57.23 -105.481C63.347 -99.342 73.27 -99.342 79.38 -105.481L79.7 -105.9C85.817 -112.039 85.817 -121.99 79.7 -128.13L-10.1 -218.25C-22.1 -230.258 -38.3 -237 -55.2 -237H-204.07C-239.3 -237 -268 -208.35 -268 -173L-267.993 211C-267.993 246.35 -239.293 275 -204.063 275H50.9365C79.1365 275 103.057 256.64 111.487 231.2C114.8 221.2 106.9 211 96.4 211Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_552_10162">
          <rect width="33" height="33" fill="white" />
        </clipPath>
        <clipPath id="clip1_552_10162">
          <rect
            width="576"
            height="512"
            fill="white"
            transform="translate(-268 -237)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "cap-lai": (
    <svg
      width="33"
      height="33"
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_552_10145)">
        <path
          d="M21.6777 0H7.17998C6.92368 0 6.6777 0.101967 6.49642 0.283241L0.283241 6.49642C0.101967 6.6777 0 6.92368 0 7.17998V29.9621C0 31.6372 1.36283 33 3.03786 33H21.6777C22.4896 33 23.2527 32.6838 23.8258 32.11C24.3995 31.5365 24.7155 30.7736 24.7155 29.9621V3.03786C24.7155 2.2264 24.3995 1.46354 23.8263 0.890259C23.2527 0.316223 22.4896 0 21.6777 0V0ZM7.24896 2.26517V6.14445C7.24896 6.75348 6.75348 7.24871 6.1447 7.24871H2.26517L7.24896 2.26517ZM22.7822 29.9621C22.7822 30.257 22.6671 30.5342 22.4581 30.7431C22.2499 30.9516 21.9727 31.0664 21.6779 31.0664H3.03786C2.42908 31.0664 1.93359 30.5709 1.93359 29.9621V9.18256H6.14445C7.81947 9.18256 9.1823 7.81973 9.1823 6.1447V1.93359H21.6777C21.9727 1.93359 22.2499 2.0484 22.4586 2.25737C22.6671 2.46584 22.7819 2.74303 22.7819 3.03786V29.9621H22.7822Z"
          fill="white"
        />
        <path
          d="M18.5711 12.4258H6.14453C5.61078 12.4258 5.17773 12.8586 5.17773 13.3926C5.17773 13.9266 5.61078 14.3594 6.14453 14.3594H18.5711C19.1051 14.3594 19.5379 13.9266 19.5379 13.3926C19.5379 12.8586 19.1051 12.4258 18.5711 12.4258Z"
          fill="white"
        />
        <path
          d="M18.5711 16.5703H6.14453C5.61078 16.5703 5.17773 17.0031 5.17773 17.5371C5.17773 18.0711 5.61078 18.5039 6.14453 18.5039H18.5711C19.1051 18.5039 19.5379 18.0711 19.5379 17.5371C19.5379 17.0031 19.1051 16.5703 18.5711 16.5703Z"
          fill="white"
        />
        <path
          d="M18.571 20.7109H6.14441C5.61066 20.7109 5.17761 21.144 5.17761 21.6777C5.17761 22.2117 5.61066 22.6445 6.14441 22.6445H18.571C19.105 22.6445 19.5378 22.2117 19.5378 21.6777C19.5378 21.144 19.105 20.7109 18.571 20.7109Z"
          fill="white"
        />
        <path
          d="M12.358 24.8516H6.14453C5.61078 24.8516 5.17773 25.2844 5.17773 25.8184C5.17773 26.3521 5.61078 26.7852 6.14453 26.7852H12.358C12.8917 26.7852 13.3248 26.3521 13.3248 25.8184C13.3248 25.2844 12.892 24.8516 12.358 24.8516Z"
          fill="white"
        />
        <path
          d="M29.9622 0C28.2871 0 26.9243 1.36283 26.9243 3.03786V23.26C26.9243 26.4391 27.6758 29.6223 29.0976 32.4655C29.2612 32.793 29.5961 33 29.9622 33C30.3285 33 30.6631 32.793 30.827 32.4655C32.2485 29.6223 33 26.4389 33 23.26V3.03786C33 1.36283 31.6372 0 29.9622 0V0ZM29.9622 1.93359C30.571 1.93359 31.0664 2.42908 31.0664 3.03786V5.17765H28.8579V3.03786C28.8579 2.42908 29.3531 1.93359 29.9622 1.93359ZM31.0664 22.7822H28.8579V7.11124H31.0664V22.7822ZM29.9622 29.5779C29.4002 28.0132 29.0477 26.3724 28.9166 24.7158H31.0078C30.8766 26.3727 30.5239 28.0132 29.9622 29.5779Z"
          fill="#FFF501"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_10145">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  book: (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 4C15.1046 4 16 4.89543 16 6V20C16 21.1046 15.1046 22 14 22H2C0.895431 22 0 21.1046 0 20V2.5C0 1.39543 0.89543 0.5 2 0.5H14C14.5523 0.5 15 0.947715 15 1.5C15 2.05228 14.5523 2.5 14 2.5H3.25C2.83579 2.5 2.5 2.83579 2.5 3.25C2.5 3.66421 2.83579 4 3.25 4H6C6.55228 4 7 4.44772 7 5V13.7929C7 14.2383 7.53857 14.4614 7.85355 14.1464L9.64645 12.3536C9.84171 12.1583 10.1583 12.1583 10.3536 12.3536L12.1464 14.1464C12.4614 14.4614 13 14.2383 13 13.7929V5C13 4.44772 13.4477 4 14 4Z"
        fill="#154398"
      />
    </svg>
  ),
  exportFile: (
    <svg
      width="14"
      height="20"
      viewBox="0 0 14 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.1 1C6.1 0.447715 5.65228 0 5.1 0H2C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H12C13.1046 20 14 19.1046 14 18V8.9C14 8.34772 13.5523 7.9 13 7.9H9C7.39837 7.9 6.1 6.60163 6.1 5V1ZM4.5 11.1C4.00294 11.1 3.6 11.5029 3.6 12C3.6 12.4971 4.00294 12.9 4.5 12.9H7C7.49706 12.9 7.9 12.4971 7.9 12C7.9 11.5029 7.49706 11.1 7 11.1H4.5ZM4.5 14.6C4.00294 14.6 3.6 15.0029 3.6 15.5C3.6 15.9971 4.00294 16.4 4.5 16.4H9.5C9.99706 16.4 10.4 15.9971 10.4 15.5C10.4 15.0029 9.99706 14.6 9.5 14.6H4.5Z"
        fill="#154398"
      />
      <path
        d="M11.8929 6.1C12.3383 6.1 12.5614 5.56143 12.2464 5.24645L8.75355 1.75355C8.43857 1.43857 7.9 1.66165 7.9 2.10711V5C7.9 5.60751 8.39249 6.1 9 6.1H11.8929Z"
        fill="#154398"
      />
    </svg>
  ),
  "dang-ki-thay-doi": (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M42.4597 30.923L39.5983 28.0547L29.9258 37.764L32.7872 40.6323L42.4597 30.923Z"
        stroke="#FFF001"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7793 40.6286L29.0908 41.4656L29.9195 37.7656"
        stroke="#FFF001"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5884 32.7985L37.7285 29.9297"
        stroke="#FFF001"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7993 41.6244C21.6214 42.4881 17.2774 41.9801 13.4095 40.1757C9.54172 38.3712 6.35547 35.3661 4.32194 31.6047C2.28849 27.8432 1.51577 23.5252 2.11799 19.2892C2.72028 15.0532 4.66553 11.124 7.66614 8.08272C10.6668 5.04148 14.5635 3.04962 18.78 2.40174C22.9964 1.7538 27.3089 2.48419 31.0795 4.48499C34.8502 6.48571 37.8788 9.65054 39.7176 13.5115C41.5564 17.3724 42.1077 21.7245 41.29 25.924"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5418 28.2386C26.1168 27.537 25.8571 26.7472 25.7822 25.9297"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5301 25.6758C17.4503 26.566 17.2105 27.4343 16.8223 28.2387"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6904 27.3291H21.7882C23.1059 27.3291 24.4122 27.0578 24.9359 26.5325C25.6897 25.7764 29.0042 21.2279 28.4805 15.5654C28.0662 11.0688 25.2063 9.03125 21.6616 9.03125C18.1169 9.03125 15.3318 11.0573 14.8945 15.5654C14.3766 21.2279 17.6911 25.7764 18.4449 26.5325C18.9629 27.0578 20.2748 27.3233 21.5926 27.3291H21.6904Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8983 30.5276C30.2046 29.5587 28.4075 28.7843 26.541 28.2188"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8229 28.2383C16.8229 28.2383 9.67598 30.3104 8.93945 33.1793"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "green-pencil": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 14.5501V17.0835C2.5 17.3168 2.68333 17.5001 2.91667 17.5001H5.45C5.55833 17.5001 5.66667 17.4585 5.74167 17.3751L14.8417 8.28346L11.7167 5.15846L2.625 14.2501C2.54167 14.3335 2.5 14.4335 2.5 14.5501ZM17.2583 5.8668C17.5833 5.5418 17.5833 5.0168 17.2583 4.6918L15.3083 2.7418C14.9833 2.4168 14.4583 2.4168 14.1333 2.7418L12.6083 4.2668L15.7333 7.3918L17.2583 5.8668Z"
        fill="#00C590"
      />
    </svg>
  ),

  information: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_363_15847)">
        <path
          d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_15847">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "download-red": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 10.8333V15C15.8333 15.4583 15.4583 15.8333 15 15.8333H5C4.54167 15.8333 4.16667 15.4583 4.16667 15V10.8333C4.16667 10.375 3.79167 10 3.33333 10C2.875 10 2.5 10.375 2.5 10.8333V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10.8333C17.5 10.375 17.125 10 16.6667 10C16.2083 10 15.8333 10.375 15.8333 10.8333ZM10.8333 10.5583L12.4 8.99167C12.725 8.66667 13.25 8.66667 13.575 8.99167C13.9 9.31667 13.9 9.84167 13.575 10.1667L10.5833 13.1583C10.2583 13.4833 9.73333 13.4833 9.40833 13.1583L6.41667 10.1667C6.09167 9.84167 6.09167 9.31667 6.41667 8.99167C6.74167 8.66667 7.26667 8.66667 7.59167 8.99167L9.16667 10.5583V3.33333C9.16667 2.875 9.54167 2.5 10 2.5C10.4583 2.5 10.8333 2.875 10.8333 3.33333V10.5583Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "printer-red": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 6.66667H4.16667C2.78334 6.66667 1.66667 7.78333 1.66667 9.16667V12.5C1.66667 13.4167 2.41667 14.1667 3.33334 14.1667H5.00001V15.8333C5.00001 16.75 5.75001 17.5 6.66667 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V14.1667H16.6667C17.5833 14.1667 18.3333 13.4167 18.3333 12.5V9.16667C18.3333 7.78333 17.2167 6.66667 15.8333 6.66667ZM12.5 15.8333H7.50001C7.04167 15.8333 6.66667 15.4583 6.66667 15V11.6667H13.3333V15C13.3333 15.4583 12.9583 15.8333 12.5 15.8333ZM15.8333 10C15.375 10 15 9.625 15 9.16667C15 8.70833 15.375 8.33333 15.8333 8.33333C16.2917 8.33333 16.6667 8.70833 16.6667 9.16667C16.6667 9.625 16.2917 10 15.8333 10ZM14.1667 2.5H5.83334C5.37501 2.5 5.00001 2.875 5.00001 3.33333V5C5.00001 5.45833 5.37501 5.83333 5.83334 5.83333H14.1667C14.625 5.83333 15 5.45833 15 5V3.33333C15 2.875 14.625 2.5 14.1667 2.5Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "eye-red": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99998 3.75C5.83331 3.75 2.27498 6.34167 0.833313 10C2.27498 13.6583 5.83331 16.25 9.99998 16.25C14.1666 16.25 17.725 13.6583 19.1666 10C17.725 6.34167 14.1666 3.75 9.99998 3.75ZM9.99998 14.1667C7.69998 14.1667 5.83331 12.3 5.83331 10C5.83331 7.7 7.69998 5.83333 9.99998 5.83333C12.3 5.83333 14.1666 7.7 14.1666 10C14.1666 12.3 12.3 14.1667 9.99998 14.1667ZM9.99998 7.5C8.61665 7.5 7.49998 8.61667 7.49998 10C7.49998 11.3833 8.61665 12.5 9.99998 12.5C11.3833 12.5 12.5 11.3833 12.5 10C12.5 8.61667 11.3833 7.5 9.99998 7.5Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "clear-orange": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9397 2.76904L1.8138 12.338C0.728733 13.3634 0.728733 15.0245 1.8138 16.0499L5.28602 19.3312C5.80686 19.8233 6.51432 20.0981 7.25217 20.0981H11.8225H12.2305H21.5447C22.3129 20.0981 22.9336 19.5116 22.9336 18.7856C22.9336 18.0597 22.3129 17.4731 21.5447 17.4731H16.1584L21.8312 12.1165C22.9162 11.0911 22.9162 9.42998 21.8312 8.40459L15.872 2.76904C14.7869 1.74365 13.0291 1.74365 11.944 2.76904H11.9397ZM12.2305 17.4772H11.8225H7.24783L3.77561 14.196L9.18793 9.08135L15.1515 14.7169L12.2305 17.4772Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "save-orange": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.59 3.59C17.21 3.21 16.7 3 16.17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V7.83C21 7.3 20.79 6.79 20.41 6.42L17.59 3.59ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM13 9H7C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5H13C14.1 5 15 5.9 15 7C15 8.1 14.1 9 13 9Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "download-white": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_363_13605)">
        <path
          d="M11.25 1.25C11.25 0.558594 10.6914 0 10 0C9.30859 0 8.75 0.558594 8.75 1.25V10.7305L5.88281 7.86328C5.39453 7.375 4.60156 7.375 4.11328 7.86328C3.625 8.35156 3.625 9.14453 4.11328 9.63281L9.11328 14.6328C9.60156 15.1211 10.3945 15.1211 10.8828 14.6328L15.8828 9.63281C16.3711 9.14453 16.3711 8.35156 15.8828 7.86328C15.3945 7.375 14.6016 7.375 14.1133 7.86328L11.25 10.7305V1.25ZM2.5 13.75C1.12109 13.75 0 14.8711 0 16.25V17.5C0 18.8789 1.12109 20 2.5 20H17.5C18.8789 20 20 18.8789 20 17.5V16.25C20 14.8711 18.8789 13.75 17.5 13.75H13.5352L11.7656 15.5195C10.7891 16.4961 9.20703 16.4961 8.23047 15.5195L6.46484 13.75H2.5ZM16.875 17.8125C16.3555 17.8125 15.9375 17.3945 15.9375 16.875C15.9375 16.3555 16.3555 15.9375 16.875 15.9375C17.3945 15.9375 17.8125 16.3555 17.8125 16.875C17.8125 17.3945 17.3945 17.8125 16.875 17.8125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_13605">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "qr-code": (
    <svg
      width="20"
      height="23"
      viewBox="0 0 20 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.14286 1.42773C0.959821 1.42773 0 2.38756 0 3.57059V7.85631C0 9.03934 0.959821 9.99916 2.14286 9.99916H6.42857C7.61161 9.99916 8.57143 9.03934 8.57143 7.85631V3.57059C8.57143 2.38756 7.61161 1.42773 6.42857 1.42773H2.14286ZM5.71429 4.28488V7.14202H2.85714V4.28488H5.71429ZM2.14286 12.8563C0.959821 12.8563 0 13.8161 0 14.9992V19.2849C0 20.4679 0.959821 21.4277 2.14286 21.4277H6.42857C7.61161 21.4277 8.57143 20.4679 8.57143 19.2849V14.9992C8.57143 13.8161 7.61161 12.8563 6.42857 12.8563H2.14286ZM5.71429 15.7134V18.5706H2.85714V15.7134H5.71429ZM11.4286 3.57059V7.85631C11.4286 9.03934 12.3884 9.99916 13.5714 9.99916H17.8571C19.0402 9.99916 20 9.03934 20 7.85631V3.57059C20 2.38756 19.0402 1.42773 17.8571 1.42773H13.5714C12.3884 1.42773 11.4286 2.38756 11.4286 3.57059ZM14.2857 4.28488H17.1429V7.14202H14.2857V4.28488ZM15.7143 19.9992V21.4277H17.1429V19.9992H15.7143ZM20 19.9992H18.5714V21.4277H20V19.9992ZM18.5714 12.8563V14.2849H15.7143V12.8563H11.4286V17.142V21.4277H14.2857V17.142H15.7143V18.5706H20V15.7134V14.2849V12.8563H18.5714Z"
        fill="#00C590"
      />
    </svg>
  ),

  "small-image-red": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15 16.6673H3.33333V5.00065H10.8333V3.33398H3.33333C2.41667 3.33398 1.66667 4.08398 1.66667 5.00065V16.6673C1.66667 17.584 2.41667 18.334 3.33333 18.334H15C15.9167 18.334 16.6667 17.584 16.6667 16.6673V9.16732H15V16.6673ZM8.50833 14.0257L6.875 12.059L4.58333 15.0007H13.75L10.8 11.0757L8.50833 14.0257ZM16.6667 3.33398V0.833984H15V3.33398H12.5C12.5083 3.34232 12.5 5.00065 12.5 5.00065H15V7.49232C15.0083 7.50065 16.6667 7.49232 16.6667 7.49232V5.00065H19.1667V3.33398H16.6667Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "user-setting": (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_363_13524)">
        <path
          d="M7 8C4.79063 8 3 6.20937 3 4C3 1.79062 4.79063 0 7 0C9.20938 0 11 1.79062 11 4C11 6.20937 9.20938 8 7 8ZM5.57188 9.5H8.42813C8.79688 9.5 9.15938 9.5375 9.50625 9.60312C9.44063 10.1812 9.7375 10.7156 10.1875 11.0031C9.66875 11.3344 9.35312 11.9906 9.5625 12.6687C9.6875 13.0719 9.85625 13.4656 10.075 13.8437C10.2937 14.2219 10.55 14.5656 10.8375 14.875C11.3281 15.4031 12.075 15.45 12.625 15.1469V15.175C12.625 15.4625 12.7094 15.7531 12.8719 15.9969H0.928125C0.415625 16 0 15.5844 0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5ZM13.625 6.81875C13.625 6.6 13.7656 6.40312 13.9781 6.35625C14.3062 6.28125 14.65 6.24062 15 6.24062C15.35 6.24062 15.6938 6.28125 16.0219 6.35625C16.2344 6.40312 16.375 6.6 16.375 6.81875V7.775C16.6219 7.88125 16.8562 8.01562 17.0719 8.175L17.85 7.72812C18.0406 7.61875 18.2781 7.64375 18.4281 7.80312C18.6656 8.05625 18.875 8.34062 19.0562 8.65312C19.2375 8.96562 19.3781 9.29062 19.4781 9.62187C19.5437 9.83125 19.4437 10.05 19.2531 10.1594L18.4719 10.6094C18.4844 10.7344 18.4937 10.8625 18.4937 10.9937C18.4937 11.125 18.4875 11.25 18.4719 11.3781L19.2531 11.8281C19.4437 11.9375 19.5406 12.1562 19.4781 12.3656C19.375 12.6969 19.2344 13.0219 19.0562 13.3344C18.8781 13.6469 18.6656 13.9312 18.4281 14.1844C18.2781 14.3437 18.0375 14.3687 17.85 14.2594L17.0719 13.8125C16.8562 13.9719 16.625 14.1062 16.375 14.2125V15.1687C16.375 15.3875 16.2344 15.5844 16.0219 15.6312C15.6938 15.7062 15.35 15.7469 15 15.7469C14.65 15.7469 14.3062 15.7062 13.9781 15.6312C13.7656 15.5844 13.625 15.3875 13.625 15.1687V14.2125C13.375 14.1062 13.1375 13.9719 12.9219 13.8094L12.15 14.2562C11.9594 14.3656 11.7219 14.3406 11.5719 14.1812C11.3344 13.9281 11.125 13.6437 10.9438 13.3312C10.7625 13.0187 10.6219 12.6937 10.5219 12.3625C10.4563 12.1531 10.5562 11.9344 10.7469 11.825L11.5219 11.3781C11.5094 11.25 11.5 11.1219 11.5 10.9906C11.5 10.8594 11.5063 10.7312 11.5219 10.6031L10.7437 10.1562C10.5531 10.0469 10.4563 9.82812 10.5188 9.61875C10.6219 9.2875 10.7594 8.9625 10.9406 8.65C11.1219 8.3375 11.3313 8.05312 11.5688 7.8C11.7188 7.64062 11.9563 7.61562 12.1469 7.725L12.9219 8.17187C13.1375 8.0125 13.375 7.87812 13.625 7.76875V6.81875ZM16.5031 10.9906C16.5031 10.1625 15.8313 9.49062 15 9.49062C14.1687 9.49062 13.4969 10.1625 13.4969 10.9906C13.4969 11.8187 14.1687 12.4906 15 12.4906C15.8313 12.4906 16.5031 11.8187 16.5031 10.9906Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_13524">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "speed-icon": (
    <svg
      width="53"
      height="8"
      viewBox="0 0 53 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="49" cy="4" r="4" fill="#ED1117" />
      <path
        d="M49 4.00044C49 6 17 6.00045 0 4.00044C17 3.00045 49 2.5 49 4.00044Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "close-tag": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16.3 16.3C15.91 16.69 15.28 16.69 14.89 16.3L12 13.41L9.11 16.3C8.72 16.69 8.09 16.69 7.7 16.3C7.31 15.91 7.31 15.28 7.7 14.89L10.59 12L7.7 9.11C7.31 8.72 7.31 8.09 7.7 7.7C8.09 7.31 8.72 7.31 9.11 7.7L12 10.59L14.89 7.7C15.28 7.31 15.91 7.31 16.3 7.7C16.69 8.09 16.69 8.72 16.3 9.11L13.41 12L16.3 14.89C16.68 15.27 16.68 15.91 16.3 16.3Z"
        fill="#838383"
      />
    </svg>
  ),
  "small-image": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.02 5H19V2.98C19 2.44 18.56 2 18.02 2H17.99C17.44 2 17 2.44 17 2.98V5H14.99C14.45 5 14.01 5.44 14 5.98V6.01C14 6.56 14.44 7 14.99 7H17V9.01C17 9.55 17.44 10 17.99 9.99H18.02C18.56 9.99 19 9.55 19 9.01V7H21.02C21.56 7 22 6.56 22 6.02V5.98C22 5.44 21.56 5 21.02 5ZM16 9.01V8H14.99C14.46 8 13.96 7.79 13.58 7.42C13.21 7.04 13 6.54 13 5.98C13 5.62 13.1 5.29 13.27 5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V10.72C18.7 10.89 18.36 11 17.98 11C16.89 10.99 16 10.1 16 9.01ZM15.96 19H6C5.59 19 5.35 18.53 5.6 18.2L7.58 15.57C7.79 15.29 8.2 15.31 8.4 15.59L10 18L12.61 14.52C12.81 14.26 13.2 14.25 13.4 14.51L16.35 18.19C16.61 18.52 16.38 19 15.96 19Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),

  "arrow-orange": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66663 9.99967C1.66663 14.5997 5.39996 18.333 9.99996 18.333C14.6 18.333 18.3333 14.5997 18.3333 9.99967C18.3333 5.39967 14.6 1.66634 9.99996 1.66634C5.39996 1.66634 1.66663 5.39967 1.66663 9.99967ZM12.2083 10.2913L9.88329 12.6163C9.61663 12.883 9.16663 12.6997 9.16663 12.3247V7.66634C9.16663 7.29134 9.61663 7.10801 9.87496 7.37467L12.2 9.69967C12.3666 9.86634 12.3666 10.133 12.2083 10.2913Z"
        fill="#F88C00"
      />
    </svg>
  ),
  "shopping-cart": (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.55 13.5C16.3 13.5 16.96 13.09 17.3 12.47L20.88 5.98C21.25 5.32 20.77 4.5 20.01 4.5H5.21L4.27 2.5H1V4.5H3L6.6 12.09L5.25 14.53C4.52 15.87 5.48 17.5 7 17.5H19V15.5H7L8.1 13.5H15.55ZM6.16 6.5H18.31L15.55 11.5H8.53L6.16 6.5ZM7 18.5C5.9 18.5 5.01 19.4 5.01 20.5C5.01 21.6 5.9 22.5 7 22.5C8.1 22.5 9 21.6 9 20.5C9 19.4 8.1 18.5 7 18.5ZM17 18.5C15.9 18.5 15.01 19.4 15.01 20.5C15.01 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  favorite: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.6602 3.99065C17.0202 2.19065 13.7602 3.03065 12.0002 5.09065C10.2402 3.03065 6.98021 2.18065 4.34021 3.99065C2.94021 4.95065 2.06021 6.57065 2.00021 8.28065C1.86021 12.1607 5.30021 15.2707 10.5502 20.0407L10.6502 20.1307C11.4102 20.8207 12.5802 20.8207 13.3402 20.1207L13.4502 20.0207C18.7002 15.2607 22.1302 12.1507 22.0002 8.27065C21.9402 6.57065 21.0602 4.95065 19.6602 3.99065ZM12.1002 18.5507L12.0002 18.6507L11.9002 18.5507C7.14021 14.2407 4.00021 11.3907 4.00021 8.50065C4.00021 6.50065 5.50021 5.00065 7.50021 5.00065C9.04021 5.00065 10.5402 5.99065 11.0702 7.36065H12.9402C13.4602 5.99065 14.9602 5.00065 16.5002 5.00065C18.5002 5.00065 20.0002 6.50065 20.0002 8.50065C20.0002 11.3907 16.8602 14.2407 12.1002 18.5507Z"
        fill="#838383"
      />
    </svg>
  ),
  truck: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.7138 12.7116L18.6672 9.67489C18.5177 9.52572 18.303 9.4404 18.0781 9.4404H15.2805V7.72687C15.2805 6.91794 14.6526 6.25977 13.8808 6.25977H4.53006C3.7583 6.25977 3.13037 6.91794 3.13037 7.72687V15.7367C3.13037 16.2026 3.50264 16.5815 3.95984 16.5815H6.13577C6.30411 17.2425 6.97122 17.738 7.76749 17.738C8.56377 17.738 9.23057 17.2425 9.39921 16.5815H14.6825H15.2805H17.5357C17.704 17.2425 18.3712 17.738 19.1674 17.738C19.9637 17.738 20.6308 17.2425 20.7991 16.5815H21.1248C21.5592 16.5815 21.913 16.268 21.913 15.883V13.1756C21.913 13.005 21.8424 12.8402 21.7138 12.7116ZM20.9481 12.7458H17.3138C17.2376 12.7458 17.1754 12.691 17.1754 12.6234V11.182C17.1754 11.1144 17.2376 11.0593 17.3138 11.0593H19.2559L20.9481 12.7458ZM7.76749 17.2081C7.17425 17.2081 6.69164 16.7804 6.69164 16.2548C6.69164 15.7291 7.17425 15.3011 7.76749 15.3011C8.36074 15.3011 8.84335 15.7288 8.84335 16.2548C8.84335 16.7804 8.36074 17.2081 7.76749 17.2081ZM9.42373 16.0515C9.3113 15.3298 8.61251 14.7715 7.76749 14.7715C6.92248 14.7715 6.22368 15.3298 6.11125 16.0515H3.95984C3.8504 16.0515 3.7284 15.9225 3.7284 15.7367V7.72687C3.7284 7.21019 4.08812 6.78969 4.53006 6.78969H13.8808C14.3231 6.78969 14.6825 7.21019 14.6825 7.72687V9.4404V13.5733H6.39262C6.22757 13.5733 6.09361 13.6918 6.09361 13.8383C6.09361 13.9848 6.22757 14.1032 6.39262 14.1032H14.6825V16.0515H9.42373ZM19.1671 17.2081C18.5742 17.2081 18.0913 16.7804 18.0913 16.2548C18.0913 15.7291 18.5739 15.3011 19.1671 15.3011C19.7604 15.3011 20.2433 15.7288 20.2433 16.2548C20.2433 16.7804 19.7607 17.2081 19.1671 17.2081ZM21.1248 16.0515H20.8237C20.7112 15.3298 20.0121 14.7715 19.1671 14.7715C18.3221 14.7715 17.6233 15.3298 17.5109 16.0515H15.2802V9.97033H18.0778C18.1322 9.97033 18.1837 9.99099 18.2201 10.027L18.7243 10.5294H17.3138C16.9078 10.5294 16.5774 10.8222 16.5774 11.182V12.6234C16.5774 12.983 16.9075 13.2758 17.3138 13.2758H21.3149V15.883C21.3149 15.976 21.2297 16.0515 21.1248 16.0515Z"
        fill="black"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  ),
  share: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
        fill="#838383"
      />
    </svg>
  ),
  "key-next": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.29006 15.8805L13.1701 12.0005L9.29006 8.12047C8.90006 7.73047 8.90006 7.10047 9.29006 6.71047C9.68006 6.32047 10.3101 6.32047 10.7001 6.71047L15.2901 11.3005C15.6801 11.6905 15.6801 12.3205 15.2901 12.7105L10.7001 17.3005C10.3101 17.6905 9.68006 17.6905 9.29006 17.3005C8.91006 16.9105 8.90006 16.2705 9.29006 15.8805Z"
        fill="#838383"
      />
    </svg>
  ),
  "key-previous": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7099 15.8805L10.8299 12.0005L14.7099 8.12047C15.0999 7.73047 15.0999 7.10047 14.7099 6.71047C14.3199 6.32047 13.6899 6.32047 13.2999 6.71047L8.70994 11.3005C8.31994 11.6905 8.31994 12.3205 8.70994 12.7105L13.2999 17.3005C13.6899 17.6905 14.3199 17.6905 14.7099 17.3005C15.0899 16.9105 15.0999 16.2705 14.7099 15.8805Z"
        fill="#838383"
      />
    </svg>
  ),
  "media-solid": (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_28_4323)">
        <path
          d="M0.937857 0H8.43786C8.7484 0 9.04137 0.158203 9.21715 0.416016L13.9691 7.54102C11.0687 7.78125 8.46129 9.04102 6.49254 10.957L0.15856 1.45898C-0.0347996 1.17188 -0.0523777 0.802734 0.111685 0.498047C0.275747 0.193359 0.592153 0 0.937857 0ZM29.8422 1.45898L23.5082 10.9629C21.5453 9.04688 18.932 7.78711 16.0316 7.54688L20.7836 0.416016C20.9593 0.152344 21.2523 0 21.5629 0H29.0629C29.4086 0 29.725 0.1875 29.889 0.498047C30.0531 0.808594 30.0355 1.17188 29.8422 1.45898ZM25.3129 19.6875C25.3129 25.3828 20.6957 30 15.0004 30C9.30504 30 4.68786 25.3828 4.68786 19.6875C4.68786 13.9922 9.30504 9.375 15.0004 9.375C20.6957 9.375 25.3129 13.9922 25.3129 19.6875ZM15.4925 14.127C15.2933 13.7168 14.7132 13.7168 14.5082 14.127L13.1957 16.7871C13.1136 16.9512 12.9613 17.0625 12.7855 17.0859L9.84411 17.5137C9.39293 17.5781 9.21715 18.1289 9.53942 18.4512L11.6664 20.5254C11.7953 20.6543 11.8539 20.8301 11.8246 21.0117L11.3207 23.9355C11.2445 24.3809 11.7132 24.7266 12.1175 24.5156L14.7425 23.1328C14.9007 23.0508 15.0941 23.0508 15.2523 23.1328L17.8773 24.5156C18.2816 24.7266 18.7504 24.3867 18.6742 23.9355L18.1703 21.0117C18.141 20.8359 18.1996 20.6543 18.3285 20.5254L20.4554 18.4512C20.7836 18.1348 20.6019 17.584 20.1507 17.5137L17.2152 17.0859C17.0394 17.0625 16.8812 16.9453 16.805 16.7871L15.4925 14.127Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_4323">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  handshake: (
    <svg
      width="38"
      height="30"
      viewBox="0 0 38 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_28_4342)">
        <path
          d="M18.9492 4.99219L13.2773 9.58594C12.334 10.3477 12.1523 11.7188 12.8672 12.6973C13.623 13.7402 15.0938 13.9453 16.1074 13.1543L21.9258 8.63086C22.3359 8.31445 22.9219 8.38477 23.2441 8.79492C23.5664 9.20508 23.4902 9.79102 23.0801 10.1133L21.8555 11.0625L30 18.5625V7.5H29.959L29.7305 7.35352L25.4766 4.62891C24.5801 4.05469 23.5312 3.75 22.4648 3.75C21.1875 3.75 19.9453 4.18945 18.9492 4.99219ZM20.2852 12.2813L17.2559 14.6367C15.4102 16.0781 12.7324 15.7031 11.3496 13.8047C10.0488 12.0176 10.377 9.52148 12.0938 8.13281L16.9688 4.18945C16.2891 3.90234 15.5566 3.75586 14.8125 3.75586C13.7109 3.75 12.6387 4.07813 11.7188 4.6875L7.5 7.5V20.625H9.15234L14.5078 25.5117C15.6562 26.5605 17.4316 26.4785 18.4805 25.3301C18.8027 24.9727 19.0195 24.5566 19.1309 24.123L20.127 25.0371C21.2695 26.0859 23.0508 26.0098 24.0996 24.8672C24.3633 24.5801 24.5566 24.2461 24.6797 23.9004C25.8164 24.6621 27.3633 24.5039 28.3184 23.4609C29.3672 22.3184 29.291 20.5371 28.1484 19.4883L20.2852 12.2813ZM5.625 7.5H0V20.625C0 21.6621 0.837891 22.5 1.875 22.5H3.75C4.78711 22.5 5.625 21.6621 5.625 20.625V7.5ZM2.8125 20.625C2.29688 20.625 1.875 20.2031 1.875 19.6875C1.875 19.1719 2.29688 18.75 2.8125 18.75C3.32812 18.75 3.75 19.1719 3.75 19.6875C3.75 20.2031 3.32812 20.625 2.8125 20.625ZM31.875 7.5V20.625C31.875 21.6621 32.7129 22.5 33.75 22.5H35.625C36.6621 22.5 37.5 21.6621 37.5 20.625V7.5H31.875ZM35.625 19.6875C35.625 20.2031 35.2031 20.625 34.6875 20.625C34.1719 20.625 33.75 20.2031 33.75 19.6875C33.75 19.1719 34.1719 18.75 34.6875 18.75C35.2031 18.75 35.625 19.1719 35.625 19.6875Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_4342">
          <rect width="37.5" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "file-sign": (
    <svg
      width="33"
      height="30"
      viewBox="0 0 33 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_28_4295)">
        <path
          d="M21.5 25.8011V26.25C21.5 28.0529 20.0691 29.5 18.3333 29.5H3.66667C1.93095 29.5 0.5 28.0529 0.5 26.25V3.75C0.5 1.94713 1.93095 0.5 3.66667 0.5H12.3333V7.5C12.3333 8.8026 13.3659 9.875 14.6667 9.875H21.5V11.7259L16.2112 17.1348C15.6785 17.6797 15.3019 18.3574 15.1203 19.1069L14.2611 22.6276L14.2606 22.6298C14.2225 22.789 14.1962 22.9491 14.1815 23.109C13.6396 22.4196 12.8125 22 11.9167 22C11.4771 22 11.0538 22.0999 10.6721 22.2848L10.1964 20.6657L10.1963 20.6655C9.94136 19.7988 9.15626 19.1875 8.25 19.1875C7.34376 19.1875 6.55867 19.7988 6.30368 20.6655C6.30367 20.6655 6.30367 20.6655 6.30366 20.6655L5.45002 23.5659L5.44916 23.5688C5.39499 23.7572 5.23267 23.875 5.05312 23.875H4.58333C3.79249 23.875 3.16667 24.5314 3.16667 25.3125C3.16667 26.0936 3.79249 26.75 4.58333 26.75H5.05312C6.49583 26.75 7.75803 25.7833 8.16826 24.387L8.16848 24.3863L8.25369 24.0946L8.73812 25.7276C8.89899 26.2893 9.39269 26.6935 9.96759 26.7478C10.5521 26.803 11.1089 26.482 11.3642 25.952C11.3644 25.9517 11.3645 25.9513 11.3647 25.951L11.8679 24.9159L11.868 24.9159L11.8725 24.9063C11.8764 24.8977 11.8828 24.8901 11.8923 24.8841C11.9022 24.8778 11.913 24.875 11.9224 24.875C11.9361 24.875 11.9605 24.8826 11.9772 24.9165C11.9773 24.9167 11.9773 24.9168 11.9774 24.9169L12.481 25.953L12.4815 25.954C12.7186 26.439 13.2062 26.75 13.75 26.75H17.4167C17.4952 26.75 17.5696 26.7417 17.6172 26.7363C17.8185 26.7218 18.0144 26.6876 18.203 26.6426L18.2031 26.6427L18.2106 26.6407L21.5 25.8011ZM18.2268 19.1582L18.2269 19.158L25.2715 11.9478L28.6399 15.3927L21.5795 22.6192C21.5794 22.6192 21.5794 22.6193 21.5793 22.6193C21.4094 22.7931 21.1927 22.9168 20.9597 22.9765C20.9596 22.9765 20.9595 22.9765 20.9595 22.9765L17.5164 23.8554L17.5141 23.856C17.3767 23.8917 17.2336 23.8534 17.1268 23.7442C17.0189 23.6339 16.9755 23.478 17.0138 23.3239L17.0144 23.3217L17.8738 19.8002L17.8742 19.7984C17.9334 19.5521 18.0551 19.3337 18.2268 19.1582ZM20.8118 7H15.1667V1.22655L20.8118 7ZM28.6126 8.53625C28.6128 8.53608 28.613 8.5359 28.6131 8.53574C29.3174 7.82061 30.4446 7.82244 31.1415 8.53511L31.9653 9.37771C31.9656 9.37796 31.9658 9.37821 31.9661 9.37846C32.6712 10.105 32.6694 11.2773 31.9665 11.9961L30.6396 13.3532L27.2712 9.9082L28.6126 8.53625Z"
          fill="#00C590"
          stroke="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_28_4295">
          <rect width="33" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "back-arrow": (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.55 7.4749C40.325 6.2499 38.35 6.2499 37.125 7.4749L16.35 28.2499C15.375 29.2249 15.375 30.7999 16.35 31.7749L37.125 52.5499C38.35 53.7749 40.325 53.7749 41.55 52.5499C42.775 51.3249 42.775 49.3499 41.55 48.1249L23.45 29.9999L41.575 11.8749C42.775 10.6749 42.775 8.6749 41.55 7.4749Z"
        fill="white"
      />
    </svg>
  ),

  "next-arrow": (
    <svg
      width="60"
      height="68"
      viewBox="0 0 60 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_225_8601)">
        <path
          d="M18.45 11.4749C19.675 10.2499 21.65 10.2499 22.875 11.4749L43.65 32.2499C44.625 33.2249 44.625 34.7999 43.65 35.7749L22.875 56.5499C21.65 57.7749 19.675 57.7749 18.45 56.5499C17.225 55.3249 17.225 53.3499 18.45 52.1249L36.55 33.9999L18.425 15.8749C17.225 14.6749 17.225 12.6749 18.45 11.4749Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_225_8601"
          x="-10"
          y="-6"
          width="80"
          height="80"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_225_8601"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_225_8601"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  ),
  shopping: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
        fill="#154398"
      />
    </svg>
  ),
  "access-time": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99325 1.33301C4.31325 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31325 14.6663 7.99325 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99325 1.33301ZM7.99992 13.333C5.05325 13.333 2.66659 10.9463 2.66659 7.99967C2.66659 5.05301 5.05325 2.66634 7.99992 2.66634C10.9466 2.66634 13.3333 5.05301 13.3333 7.99967C13.3333 10.9463 10.9466 13.333 7.99992 13.333Z"
        fill="#838383"
      />
      <path
        d="M8.33325 4.66699H7.33325V8.66699L10.8333 10.767L11.3333 9.94699L8.33325 8.16699V4.66699Z"
        fill="#838383"
      />
    </svg>
  ),
  author: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z"
        fill="#838383"
      />
    </svg>
  ),
  "arrow-right-orange": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74167 13.2333L10.975 9.99998L7.74167 6.76665C7.41667 6.44165 7.41667 5.91665 7.74167 5.59165C8.06667 5.26665 8.59167 5.26665 8.91667 5.59165L12.7417 9.41665C13.0667 9.74165 13.0667 10.2667 12.7417 10.5917L8.91667 14.4166C8.59167 14.7416 8.06667 14.7416 7.74167 14.4166C7.42501 14.0916 7.41667 13.5583 7.74167 13.2333Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "yellow-checked": (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.29188 5.72323C2.44867 5.00974 1.18672 5.1149 0.473227 5.95812C-0.240261 6.80133 -0.135098 8.06328 0.708115 8.77677L3.29188 5.72323ZM8.5 12.75L7.20812 14.2768C8.00217 14.9487 9.1787 14.8997 9.91421 14.1642L8.5 12.75ZM20.4142 3.66421C21.1953 2.88317 21.1953 1.61683 20.4142 0.835786C19.6332 0.0547378 18.3668 0.0547378 17.5858 0.835786L20.4142 3.66421ZM0.708115 8.77677L7.20812 14.2768L9.79188 11.2232L3.29188 5.72323L0.708115 8.77677ZM9.91421 14.1642L20.4142 3.66421L17.5858 0.835786L7.08579 11.3358L9.91421 14.1642Z"
        fill="#FFF501"
      />
    </svg>
  ),
  "phone-animation": (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_21117)">
        <path
          d="M27.9796 55.9592C43.4323 55.9592 55.9592 43.4323 55.9592 27.9796C55.9592 12.5269 43.4323 0 27.9796 0C12.5269 0 0 12.5269 0 27.9796C0 43.4323 12.5269 55.9592 27.9796 55.9592Z"
          fill="#1552C1"
        />
        <path
          d="M21.3722 15.5806C22.0247 15.8253 22.5958 16.274 22.922 16.8858C23.8601 18.2317 24.7167 19.6185 25.4508 21.0868C25.614 21.4131 25.7363 21.7801 25.8587 22.1472C26.0218 22.5959 25.9403 23.0853 25.614 23.4116C25.2061 23.8603 24.7167 24.2681 24.3088 24.676C23.8601 25.0839 23.7786 25.1246 24.0233 25.7364C25.2061 28.7139 27.6125 31.0387 30.6715 32.1399C30.8346 32.2215 31.0794 32.1807 31.1609 32.0176C31.528 31.5689 31.9359 31.1203 32.3438 30.6716C32.7924 30.1006 33.5674 29.9375 34.2199 30.2638C35.158 30.7124 36.0553 31.1611 36.9526 31.6505C37.8499 32.1807 38.7065 32.7925 39.6038 33.3635C39.7669 33.4451 39.8893 33.5675 40.0116 33.6898C40.5826 34.3424 40.7458 34.9542 40.1748 35.6884C39.7669 36.2186 39.3183 36.708 38.8696 37.1567C37.7684 38.2171 36.5856 39.1552 35.3212 39.971C34.6686 40.3788 34.0568 40.5012 33.4042 40.3788C31.2833 39.971 29.244 39.1552 27.4086 37.9724C23.2891 35.4437 19.9038 31.936 17.4974 27.735C16.6409 26.2259 16.0291 24.5944 15.662 22.8814L15.5397 22.188V21.617C15.6212 21.4539 15.7028 21.2907 15.7844 21.1276C16.5593 19.7816 17.4974 18.558 18.5579 17.416C19.2105 16.641 19.9854 15.9884 20.8827 15.5398H21.3722V15.5806ZM21.1274 17.2936C21.0459 17.3344 21.0051 17.3752 20.9643 17.416C19.6183 18.6396 18.4355 20.0263 17.4566 21.5354C17.2935 21.7801 17.2119 22.1064 17.2935 22.3919C17.5382 23.7379 17.9869 25.0431 18.6395 26.2667C20.9235 30.6308 24.3904 34.2608 28.6322 36.7896C30.1413 37.7277 31.8543 38.4211 33.6081 38.7474C33.8936 38.8289 34.1791 38.7474 34.4239 38.5842C35.5659 37.8093 36.6671 36.9528 37.646 35.9739C38.0131 35.6068 38.3394 35.2805 38.7065 34.9134C38.5841 34.8319 38.5025 34.7503 38.421 34.7095C36.9526 33.649 35.4027 32.711 33.7713 31.936C33.6081 31.8136 33.4042 31.8544 33.2818 32.0176C32.7924 32.5886 32.2622 33.2004 31.732 33.7714C31.4872 34.0161 31.1202 34.1385 30.7939 34.0161C28.7137 33.4451 26.7968 32.3031 25.2877 30.7532C23.7786 29.2849 22.6773 27.4495 22.0655 25.4509C21.8616 24.9615 22.0247 24.3905 22.4326 24.0642C22.9628 23.6155 23.4931 23.1261 24.0641 22.6367C24.1864 22.5551 24.1864 22.3919 24.1456 22.3104C23.4523 20.8421 22.6365 19.4145 21.6985 18.0686C21.4945 17.7831 21.3314 17.5383 21.1274 17.2936Z"
          fill="white"
        />
        <path
          d="M28.8362 18.5172V16.845C31.365 16.845 33.8121 17.7423 35.7291 19.3737C38.1763 21.4131 39.6038 24.4313 39.6038 27.6126H37.9316C37.9316 22.5959 33.8529 18.558 28.8362 18.5172Z"
          fill="white"
        />
        <path
          d="M28.8362 22.6774V21.0459C32.0583 20.842 35.5252 23.7786 35.4436 27.6533H33.8121C33.8121 24.9206 31.5689 22.7181 28.8362 22.6774Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_21117">
          <rect width="56" height="56" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "arrow-up-orange": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.12 14.71L12 10.83L15.88 14.71C16.27 15.1 16.9 15.1 17.29 14.71C17.68 14.32 17.68 13.69 17.29 13.3L12.7 8.70998C12.31 8.31998 11.68 8.31998 11.29 8.70998L6.7 13.3C6.31 13.69 6.31 14.32 6.7 14.71C7.09 15.09 7.73 15.1 8.12 14.71Z"
        fill="#F88C00"
      />
    </svg>
  ),

  link: (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1423 6.59564L9.7783 8.05835C9.52823 8.32651 9.54304 8.75052 9.8112 9.00058C10.0794 9.25065 10.5034 9.23584 10.7534 8.96768L12.1174 7.50497C12.8676 6.70048 14.1396 6.65606 14.9441 7.40626C15.7486 8.15646 15.793 9.42848 15.0428 10.233L13.6789 11.6957C13.4288 11.9638 13.4436 12.3878 13.7118 12.6379C13.9799 12.888 14.4039 12.8732 14.654 12.605L16.018 11.1423C17.2729 9.79661 17.1992 7.686 15.8535 6.43112C14.5078 5.17625 12.3972 5.24995 11.1423 6.59564ZM9.48815 13.2571C9.75631 13.5072 10.1803 13.4924 10.4304 13.2242L13.1584 10.2988C13.4084 10.0306 13.3936 9.6066 13.1255 9.35654C12.8573 9.10647 12.4333 9.12128 12.1832 9.38944L9.45525 12.3149C9.20518 12.583 9.21999 13.007 9.48815 13.2571ZM11.8602 13.646L10.4962 15.1087C9.74599 15.9131 8.47398 15.9576 7.66949 15.2074C6.865 14.4572 6.82058 13.1852 7.57078 12.3807L8.93477 10.918C9.18484 10.6498 9.17003 10.2258 8.90187 9.97572C8.63371 9.72566 8.2097 9.74046 7.95964 10.0086L6.59564 11.4713C5.34076 12.817 5.41447 14.9276 6.76016 16.1825C8.10585 17.4374 10.2165 17.3637 11.4713 16.018L12.8353 14.5553C13.0854 14.2871 13.0706 13.8631 12.8024 13.613C12.5343 13.363 12.1103 13.3778 11.8602 13.646Z"
        fill="black"
      />
    </svg>
  ),
  "download-app": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6667 8.66667V12C12.6667 12.3667 12.3667 12.6667 12 12.6667H4C3.63333 12.6667 3.33333 12.3667 3.33333 12V8.66667C3.33333 8.3 3.03333 8 2.66667 8C2.3 8 2 8.3 2 8.66667V12.6667C2 13.4 2.6 14 3.33333 14H12.6667C13.4 14 14 13.4 14 12.6667V8.66667C14 8.3 13.7 8 13.3333 8C12.9667 8 12.6667 8.3 12.6667 8.66667ZM8.66667 8.44667L9.92 7.19333C10.18 6.93333 10.6 6.93333 10.86 7.19333C11.12 7.45333 11.12 7.87333 10.86 8.13333L8.46667 10.5267C8.20667 10.7867 7.78667 10.7867 7.52667 10.5267L5.13333 8.13333C4.87333 7.87333 4.87333 7.45333 5.13333 7.19333C5.39333 6.93333 5.81333 6.93333 6.07333 7.19333L7.33333 8.44667V2.66667C7.33333 2.3 7.63333 2 8 2C8.36667 2 8.66667 2.3 8.66667 2.66667V8.44667Z"
        fill="black"
      />
    </svg>
  ),
  "small-phone": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.82 10.1733L11.1267 9.98C10.72 9.93334 10.32 10.0733 10.0334 10.36L8.80669 11.5867C6.92003 10.6267 5.37336 9.08667 4.41336 7.19334L5.64669 5.96C5.93336 5.67333 6.07336 5.27334 6.02669 4.86667L5.83336 3.18667C5.75336 2.51333 5.18669 2.00667 4.50669 2.00667L3.35336 2.00667C2.60003 2.00667 1.97336 2.63333 2.02003 3.38667C2.37336 9.08 6.92669 13.6267 12.6134 13.98C13.3667 14.0267 13.9934 13.4 13.9934 12.6467V11.4933C14 10.82 13.4934 10.2533 12.82 10.1733Z"
        fill="black"
      />
    </svg>
  ),
  message: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.13882 23.595L5.29076 26.8298C5.1541 26.9447 4.98748 27.0182 4.8105 27.0416C4.63351 27.065 4.45352 27.0374 4.29168 26.9621C4.12984 26.8867 3.99289 26.7667 3.89693 26.6161C3.80098 26.4656 3.75 26.2907 3.75 26.1122V7.50006C3.75 7.25142 3.84877 7.01296 4.02459 6.83715C4.2004 6.66133 4.43886 6.56256 4.6875 6.56256H25.3125C25.5611 6.56256 25.7996 6.66133 25.9754 6.83715C26.1512 7.01296 26.25 7.25142 26.25 7.50006V22.5001C26.25 22.7487 26.1512 22.9872 25.9754 23.163C25.7996 23.3388 25.5611 23.4376 25.3125 23.4376H9.57081L9.13882 23.595Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 13.125H18.75"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 16.875H18.75"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  call: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6812 4.6875C20.2704 5.11493 21.7195 5.95245 22.8832 7.11618C24.047 8.2799 24.8845 9.72899 25.3119 11.3183"
        fill="white"
      />
      <path
        d="M18.6812 4.6875C20.2704 5.11493 21.7195 5.95245 22.8832 7.11618C24.047 8.2799 24.8845 9.72899 25.3119 11.3183"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7114 8.31079C18.665 8.56725 19.5344 9.06976 20.2327 9.768C20.9309 10.4662 21.4334 11.3357 21.6899 12.2893"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.8371 14.6268C11.8095 16.6149 13.4211 18.2192 15.4136 19.1826C15.5594 19.2516 15.7207 19.2816 15.8815 19.2694C16.0424 19.2572 16.1973 19.2034 16.3311 19.1131L19.2649 17.1568C19.3947 17.0702 19.544 17.0175 19.6993 17.0032C19.8546 16.9889 20.011 17.0136 20.1543 17.0751L25.643 19.4274C25.8295 19.5066 25.9852 19.6442 26.0866 19.8196C26.188 19.995 26.2297 20.1985 26.2054 20.3996C26.0319 21.7571 25.3695 23.0049 24.3423 23.9092C23.3151 24.8135 21.9935 25.3124 20.625 25.3125C16.3981 25.3125 12.3443 23.6334 9.35549 20.6445C6.36662 17.6556 4.6875 13.6019 4.6875 9.37499C4.68757 8.00645 5.18648 6.68485 6.0908 5.65766C6.99512 4.63047 8.24285 3.96812 9.60035 3.79464C9.80146 3.7703 10.005 3.81198 10.1804 3.9134C10.3558 4.01482 10.4934 4.17048 10.5726 4.35693L12.927 9.85043C12.9879 9.99253 13.0127 10.1475 12.9992 10.3015C12.9857 10.4555 12.9344 10.6038 12.8497 10.7331L10.9001 13.712C10.8114 13.846 10.7589 14.0007 10.7479 14.1611C10.7368 14.3214 10.7676 14.4819 10.8371 14.6268Z"
        fill="white"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  youtube: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6752 8.69886C18.5185 8.10977 18.0549 7.64504 17.4652 7.48577C16.3988 7.19995 12.1203 7.19995 12.1203 7.19995C12.1203 7.19995 7.84391 7.19995 6.77537 7.48577C6.18778 7.64286 5.72423 8.10759 5.56536 8.69886C5.28027 9.76795 5.28027 12 5.28027 12C5.28027 12 5.28027 14.232 5.56536 15.301C5.72206 15.8901 6.1856 16.3549 6.77537 16.5141C7.84391 16.8 12.1203 16.8 12.1203 16.8C12.1203 16.8 16.3988 16.8 17.4652 16.5141C18.0528 16.357 18.5163 15.8923 18.6752 15.301C18.9603 14.232 18.9603 12 18.9603 12C18.9603 12 18.9603 9.76795 18.6752 8.69886Z"
        fill="white"
      />
      <path
        d="M10.7536 14.0574L14.3074 12L10.7536 9.9425V14.0574Z"
        fill="#154398"
      />
    </svg>
  ),
  facebook: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8079 12.7496L15.1499 10.5789H13.0435V9.16789C13.0435 8.57434 13.3375 7.99435 14.2779 7.99435H15.2491V6.14585C14.6835 6.05574 14.112 6.00699 13.5393 6C11.8056 6 10.6737 7.04127 10.6737 8.92369V10.5789H8.75195V12.7496H10.6737V18H13.0435V12.7496H14.8079Z"
        fill="white"
      />
    </svg>
  ),
  phone: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.23 15.26L16.69 14.97C16.08 14.9 15.48 15.11 15.05 15.54L13.21 17.38C10.38 15.94 8.06004 13.63 6.62004 10.79L8.47004 8.94001C8.90004 8.51001 9.11004 7.91001 9.04004 7.30001L8.75004 4.78001C8.63004 3.77001 7.78004 3.01001 6.76004 3.01001H5.03004C3.90004 3.01001 2.96004 3.95001 3.03004 5.08001C3.56004 13.62 10.39 20.44 18.92 20.97C20.05 21.04 20.99 20.1 20.99 18.97V17.24C21 16.23 20.24 15.38 19.23 15.26Z"
        fill="white"
      />
    </svg>
  ),
  fax: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 8H5C3.34 8 2 9.34 2 11V15C2 16.1 2.9 17 4 17H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V17H20C21.1 17 22 16.1 22 15V11C22 9.34 20.66 8 19 8ZM15 19H9C8.45 19 8 18.55 8 18V14H16V18C16 18.55 15.55 19 15 19ZM19 12C18.45 12 18 11.55 18 11C18 10.45 18.45 10 19 10C19.55 10 20 10.45 20 11C20 11.55 19.55 12 19 12ZM17 3H7C6.45 3 6 3.45 6 4V6C6 6.55 6.45 7 7 7H17C17.55 7 18 6.55 18 6V4C18 3.45 17.55 3 17 3Z"
        fill="white"
      />
    </svg>
  ),
  email: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill="white"
      />
    </svg>
  ),
  "email-red": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L13.06 12.34C12.41 12.75 11.59 12.75 10.94 12.34L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill="#3f51b5"
      />
    </svg>
  ),
  address: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C8.13 2 5 5.13 5 9C5 13.17 9.42 18.92 11.24 21.11C11.64 21.59 12.37 21.59 12.77 21.11C14.58 18.92 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill="white"
      />
    </svg>
  ),
  "credit-card": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 5.25H3C2.58579 5.25 2.25 5.58579 2.25 6V18C2.25 18.4142 2.58579 18.75 3 18.75H21C21.4142 18.75 21.75 18.4142 21.75 18V6C21.75 5.58579 21.4142 5.25 21 5.25Z"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 15.75H18.75"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 15.75H12.75"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.25 9.07983H21.75"
        stroke="#3776FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "credit-card-fill": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.4286 75.4286C82.5192 75.4286 81.6472 75.7898 81.0042 76.4328C80.3612 77.0758 80 77.9479 80 78.8572C80 79.7665 80.3612 80.6386 81.0042 81.2815C81.6472 81.9245 82.5192 82.2857 83.4286 82.2857H99.4286C100.338 82.2857 101.21 81.9245 101.853 81.2815C102.496 80.6386 102.857 79.7665 102.857 78.8572C102.857 77.9479 102.496 77.0758 101.853 76.4328C101.21 75.7898 100.338 75.4286 99.4286 75.4286H83.4286ZM9.16113 40C9.16113 35.4535 10.9672 31.0931 14.1822 27.8782C17.3971 24.6633 21.7574 22.8572 26.304 22.8572H101.714C106.261 22.8572 110.621 24.6633 113.836 27.8782C117.051 31.0931 118.857 35.4535 118.857 40V88C118.857 92.5466 117.051 96.907 113.836 100.122C110.621 103.337 106.261 105.143 101.714 105.143H26.3086C21.762 105.143 17.4016 103.337 14.1867 100.122C10.9718 96.907 9.1657 92.5466 9.1657 88L9.16113 40ZM26.304 29.7143C23.576 29.7143 20.9598 30.798 19.0309 32.7269C17.1019 34.6559 16.0183 37.2721 16.0183 40V43.4286H112V40C112 37.2721 110.916 34.6559 108.987 32.7269C107.058 30.798 104.442 29.7143 101.714 29.7143H26.304ZM16.0183 88C16.0183 90.728 17.1019 93.3442 19.0309 95.2731C20.9598 97.2021 23.576 98.2857 26.304 98.2857H101.714C104.442 98.2857 107.058 97.2021 108.987 95.2731C110.916 93.3442 112 90.728 112 88V50.2857H16.0228L16.0183 88Z"
        fill="3776FF"
      />
    </svg>
  ),
  signup: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.75 4.375H17.5"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.625 2.5V6.25"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.4209 16.8743C3.1893 15.5442 4.29419 14.4398 5.62456 13.672C6.95493 12.9042 8.46393 12.5 9.99997 12.5C11.536 12.5 13.045 12.9043 14.3754 13.6721C15.7057 14.44 16.8106 15.5444 17.579 16.8744"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6915 9.23303C14.3573 10.1354 13.7696 10.9221 12.9991 11.4987C12.2286 12.0752 11.3081 12.417 10.348 12.483C9.38799 12.549 8.42931 12.3364 7.58715 11.8708C6.74499 11.4052 6.05519 10.7063 5.60059 9.85813C5.146 9.00997 4.94596 8.04859 5.0245 7.0895C5.10305 6.1304 5.45683 5.21438 6.04336 4.45148C6.62989 3.68857 7.42421 3.11124 8.3309 2.78883C9.23759 2.46642 10.2181 2.41265 11.1546 2.63397"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  signin: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.34473 13.2812L10.6251 10L7.34473 6.71875"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 10H10.6227"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.625 3.125H15C15.1658 3.125 15.3247 3.19085 15.4419 3.30806C15.5592 3.42527 15.625 3.58424 15.625 3.75V16.25C15.625 16.4158 15.5592 16.5747 15.4419 16.6919C15.3247 16.8092 15.1658 16.875 15 16.875H10.625"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        handle
      />
    </svg>
  ),
  home: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 19V14H14V19C14 19.55 14.45 20 15 20H18C18.55 20 19 19.55 19 19V12H20.7C21.16 12 21.38 11.43 21.03 11.13L12.67 3.6C12.29 3.26 11.71 3.26 11.33 3.6L2.97001 11.13C2.63001 11.43 2.84001 12 3.30001 12H5.00001V19C5.00001 19.55 5.45001 20 6.00001 20H9.00001C9.55001 20 10 19.55 10 19Z"
        fill="#333"
      />
    </svg>
  ),
  contact: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59241 11.75L2.5 14.25V4.25C2.5 4.08424 2.56585 3.92527 2.68306 3.80806C2.80027 3.69085 2.95924 3.625 3.125 3.625H13.125C13.2908 3.625 13.4497 3.69085 13.5669 3.80806C13.6842 3.92527 13.75 4.08424 13.75 4.25V11.125C13.75 11.2908 13.6842 11.4497 13.5669 11.5669C13.4497 11.6842 13.2908 11.75 13.125 11.75H5.59241Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 11.75V14.875C6.25 15.0408 6.31585 15.1997 6.43306 15.3169C6.55027 15.4342 6.70924 15.5 6.875 15.5H14.4076L17.5 18V8C17.5 7.83424 17.4342 7.67527 17.3169 7.55806C17.1997 7.44085 17.0408 7.375 16.875 7.375H13.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  sort: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 10H12"
        stroke="#8B939F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 6.25H18.125"
        stroke="#8B939F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 14H5.75"
        stroke="#8B939F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  video: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.875 5.1875H11.875C12.538 5.1875 13.1739 5.45089 13.6428 5.91973C14.1116 6.38857 14.375 7.02446 14.375 7.6875V15.1875C14.375 15.3533 14.3092 15.5122 14.1919 15.6294C14.0747 15.7467 13.9158 15.8125 13.75 15.8125H3.75C3.08696 15.8125 2.45107 15.5491 1.98223 15.0803C1.51339 14.6114 1.25 13.9755 1.25 13.3125V5.8125C1.25 5.64674 1.31585 5.48777 1.43306 5.37056C1.55027 5.25335 1.70924 5.1875 1.875 5.1875V5.1875Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.375 9.25L18.75 6.75V14.25L14.375 11.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  rating: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 12V18L10 16L6.5 18V12"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="7.5" r="5.5" stroke="#0D99FF" strokeWidth="2" />
    </svg>
  ),
  voting: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 12V18L10 16L6.5 18V12"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="7.5" r="5.5" stroke="#0D99FF" strokeWidth="2" />
    </svg>
  ),
  "file-icon": (
    <svg
      width="89"
      height="89"
      viewBox="0 0 89 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.3">
        <path
          opacity="0.3"
          d="M61.7206 22.3036C59.9655 22.3019 58.2827 21.5995 57.0417 20.3505C55.8007 19.1016 55.1027 17.4081 55.101 15.6419V6.39238H25.5249C24.3901 6.39196 23.2664 6.61648 22.2179 7.05319C21.1694 7.48991 20.2168 8.13025 19.4142 8.93759C18.6117 9.74493 17.9751 10.7035 17.5407 11.7585C17.1064 12.8135 16.8828 13.9442 16.8828 15.0862V67.4948C16.8828 68.6367 17.1064 69.7676 17.5407 70.8226C17.9751 71.8776 18.6117 72.8361 19.4142 73.6434C20.2168 74.4508 21.1694 75.091 22.2179 75.5278C23.2664 75.9645 24.3901 76.1891 25.5249 76.1887H61.0303C62.1648 76.1887 63.2882 75.9638 64.3363 75.5269C65.3844 75.09 66.3367 74.4496 67.1389 73.6423C67.9411 72.835 68.5774 71.8766 69.0116 70.8218C69.4457 69.767 69.6692 68.6365 69.6692 67.4948V22.3036H61.7206Z"
          fill="#0072FF"
        />
      </g>
      <path
        d="M69.6697 22.3036H61.7211C59.966 22.3019 58.2833 21.5995 57.0423 20.3505C55.8012 19.1016 55.1033 17.4081 55.1016 15.6419V6.39238L69.6697 22.3036Z"
        fill="#0072FF"
      />
      <path
        d="M58.8083 33.4431H25.6655C25.3471 33.4431 25.0417 33.3158 24.8165 33.0892C24.5914 32.8626 24.4648 32.5553 24.4648 32.2348C24.4644 32.0759 24.4952 31.9184 24.5553 31.7714C24.6155 31.6245 24.7039 31.4909 24.8154 31.3783C24.9269 31.2658 25.0594 31.1765 25.2053 31.1156C25.3512 31.0547 25.5075 31.0233 25.6655 31.0233H58.8083C59.1275 31.0233 59.4337 31.151 59.6595 31.3782C59.8853 31.6054 60.0121 31.9135 60.0121 32.2348C60.0113 32.5556 59.884 32.8629 59.6584 33.0894C59.4327 33.3159 59.127 33.4431 58.8083 33.4431Z"
        fill="#0072FF"
      />
      <path
        d="M58.8083 40.6702H25.6655C25.3471 40.6702 25.0417 40.5429 24.8165 40.3163C24.5914 40.0897 24.4648 39.7824 24.4648 39.462C24.4644 39.303 24.4952 39.1455 24.5553 38.9986C24.6155 38.8516 24.7039 38.718 24.8154 38.6055C24.9269 38.4929 25.0594 38.4036 25.2053 38.3427C25.3512 38.2818 25.5075 38.2504 25.6655 38.2504H58.8083C59.1275 38.2504 59.4337 38.378 59.6595 38.6052C59.8853 38.8324 60.0121 39.1406 60.0121 39.462C60.0113 39.7827 59.884 40.09 59.6584 40.3165C59.4327 40.543 59.127 40.6702 58.8083 40.6702Z"
        fill="#0072FF"
      />
      <path
        d="M58.8083 47.8973H25.6655C25.5075 47.8973 25.3512 47.8659 25.2053 47.805C25.0594 47.7441 24.9269 47.6548 24.8154 47.5423C24.7039 47.4297 24.6155 47.2961 24.5553 47.1492C24.4952 47.0022 24.4644 46.8447 24.4648 46.6858C24.4648 46.3653 24.5914 46.058 24.8165 45.8314C25.0417 45.6048 25.3471 45.4775 25.6655 45.4775H58.8083C59.127 45.4775 59.4327 45.6047 59.6584 45.8312C59.884 46.0577 60.0113 46.365 60.0121 46.6858C60.0121 47.0071 59.8853 47.3152 59.6595 47.5424C59.4337 47.7697 59.1275 47.8973 58.8083 47.8973Z"
        fill="#0072FF"
      />
      <path
        d="M45.736 55.1244H25.6655C25.5075 55.1244 25.3512 55.0931 25.2053 55.0322C25.0594 54.9712 24.9269 54.8819 24.8154 54.7693C24.7039 54.6568 24.6155 54.5233 24.5553 54.3763C24.4952 54.2293 24.4644 54.0719 24.4648 53.9129C24.4648 53.5925 24.5914 53.2851 24.8165 53.0585C25.0417 52.8319 25.3471 52.7046 25.6655 52.7046H45.736C46.0545 52.7046 46.3599 52.8319 46.5851 53.0585C46.8102 53.2851 46.9367 53.5925 46.9367 53.9129C46.9371 54.0719 46.9064 54.2293 46.8462 54.3763C46.7861 54.5233 46.6977 54.6568 46.5862 54.7693C46.4747 54.8819 46.3421 54.9712 46.1963 55.0322C46.0504 55.0931 45.894 55.1244 45.736 55.1244Z"
        fill="#0072FF"
      />
      <path d="M41.3509 75.3292V77.678H38.9336V75.3292H41.3509Z" fill="white" />
    </svg>
  ),
  "add-primary": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.125 10H16.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V16.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "edit-green": (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2167 7.51667L12.9833 8.28333L5.43333 15.8333H4.66667V15.0667L12.2167 7.51667ZM15.2167 2.5C15.0083 2.5 14.7917 2.58333 14.6333 2.74167L13.1083 4.26667L16.2333 7.39167L17.7583 5.86667C18.0833 5.54167 18.0833 5.01667 17.7583 4.69167L15.8083 2.74167C15.6417 2.575 15.4333 2.5 15.2167 2.5ZM12.2167 5.15833L3 14.375V17.5H6.125L15.3417 8.28333L12.2167 5.15833Z"
        fill="#00C590"
      />
    </svg>
  ),
  "edit-orange": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.37333 6.01333L9.98667 6.62667L3.94667 12.6667H3.33333V12.0533L9.37333 6.01333ZM11.7733 2C11.6067 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2ZM9.37333 4.12667L2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667Z"
        fill="#ED1117"
      />
    </svg>
  ),
  "arrow-up": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_395_40305)">
        <path d="M12 8L18 14H6L12 8Z" fill="#6A7688" />
      </g>
      <defs>
        <clipPath id="clip0_395_40305">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 24) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "search-white": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.0625 15.625C12.6869 15.625 15.625 12.6869 15.625 9.0625C15.625 5.43813 12.6869 2.5 9.0625 2.5C5.43813 2.5 2.5 5.43813 2.5 9.0625C2.5 12.6869 5.43813 15.625 9.0625 15.625Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7021 13.7031L17.4991 17.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "check-special": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25476 15.7452C3.53569 15.0262 4.01262 13.5165 3.64662 12.632C3.26722 11.715 1.875 10.9769 1.875 9.99997C1.875 9.02301 3.26722 8.285 3.64663 7.36803C4.01262 6.48346 3.5357 4.97382 4.25476 4.25476C4.97382 3.53569 6.48346 4.01262 7.36804 3.64662C8.28503 3.26722 9.02305 1.875 10 1.875C10.977 1.875 11.715 3.26722 12.632 3.64663C13.5165 4.01262 15.0262 3.5357 15.7452 4.25476C16.4643 4.97382 15.9874 6.48346 16.3534 7.36804C16.7328 8.28503 18.125 9.02305 18.125 10C18.125 10.977 16.7328 11.715 16.3534 12.632C15.9874 13.5165 16.4643 15.0262 15.7452 15.7452C15.0262 16.4643 13.5165 15.9874 12.632 16.3534C11.715 16.7328 10.9769 18.125 9.99997 18.125C9.02301 18.125 8.285 16.7328 7.36803 16.3534C6.48346 15.9874 4.97382 16.4643 4.25476 15.7452Z"
        fill="#0D99FF"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4375 8.125L8.85414 12.5L6.5625 10.3125"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "diem-danh": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M2.4209 16.8743C3.1893 15.5442 4.29419 14.4398 5.62456 13.672C6.95493 12.9042 8.46393 12.5 9.99997 12.5C11.536 12.5 13.045 12.9043 14.3754 13.6721"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 14L14 18L12 16.0001"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gear: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 13.75C12.0711 13.75 13.75 12.0711 13.75 10C13.75 7.92893 12.0711 6.25 10 6.25C7.92893 6.25 6.25 7.92893 6.25 10C6.25 12.0711 7.92893 13.75 10 13.75Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.59963 3.44993L8.12545 2.34462C8.04635 2.28512 7.95425 2.24527 7.85673 2.22835C7.75921 2.21143 7.65906 2.21793 7.56455 2.2473C7.10798 2.39028 6.66502 2.57355 6.24091 2.79495C6.15311 2.841 6.07753 2.90727 6.02039 2.98829C5.96325 3.06931 5.9262 3.16276 5.9123 3.26092L5.6517 5.08521C5.55236 5.17326 5.45511 5.26485 5.35994 5.35996C5.26481 5.4551 5.1732 5.55237 5.08513 5.65179L5.08509 5.65182L3.26112 5.91265C3.16312 5.92651 3.06981 5.96346 2.98889 6.02045C2.90797 6.07744 2.84175 6.15285 2.79569 6.24046C2.57395 6.6644 2.39032 7.10721 2.24698 7.56366C2.21746 7.6583 2.21088 7.75861 2.22777 7.8563C2.24465 7.95399 2.28453 8.04627 2.34411 8.12551L3.4498 9.59975C3.44182 9.73225 3.43782 9.86578 3.43778 10.0003C3.43778 10.1349 3.44179 10.2684 3.44981 10.401L3.4498 10.4011L2.3445 11.8752C2.285 11.9543 2.24514 12.0464 2.22822 12.144C2.21131 12.2415 2.2178 12.3416 2.24718 12.4361C2.39016 12.8927 2.57343 13.3357 2.79483 13.7598C2.84088 13.8476 2.90715 13.9232 2.98817 13.9803C3.06919 14.0374 3.16264 14.0745 3.2608 14.0884L5.08509 14.349C5.17314 14.4483 5.26472 14.5456 5.35983 14.6407C5.45497 14.7359 5.55225 14.8275 5.65166 14.9156L5.65169 14.9156L5.91253 16.7396C5.92638 16.8376 5.96333 16.9309 6.02032 17.0118C6.07732 17.0927 6.15273 17.1589 6.24033 17.205C6.66427 17.4267 7.10708 17.6104 7.56353 17.7537C7.65818 17.7832 7.75848 17.7898 7.85617 17.7729C7.95387 17.756 8.04614 17.7161 8.12538 17.6566L9.59962 16.5509C9.73213 16.5589 9.86565 16.5629 10.0002 16.5629C10.1347 16.5629 10.2683 16.5589 10.4009 16.5509L10.4009 16.5509L11.8751 17.6562C11.9542 17.7157 12.0463 17.7555 12.1438 17.7725C12.2413 17.7894 12.3415 17.7829 12.436 17.7535C12.8926 17.6105 13.3355 17.4273 13.7596 17.2059C13.8474 17.1598 13.923 17.0935 13.9802 17.0125C14.0373 16.9315 14.0744 16.838 14.0883 16.7399L14.3489 14.9156C14.4482 14.8275 14.5454 14.736 14.6406 14.6408C14.7357 14.5457 14.8274 14.4484 14.9154 14.349L14.9155 14.349L16.7394 14.0881C16.8374 14.0743 16.9307 14.0373 17.0117 13.9804C17.0926 13.9234 17.1588 13.848 17.2049 13.7603C17.4266 13.3364 17.6102 12.8936 17.7536 12.4371C17.7831 12.3425 17.7897 12.2422 17.7728 12.1445C17.7559 12.0468 17.716 11.9545 17.6564 11.8753L16.5508 10.4011C16.5587 10.2686 16.5627 10.135 16.5628 10.0005C16.5628 9.86594 16.5588 9.73238 16.5507 9.5998L16.5508 9.59975L17.6561 8.12557C17.7156 8.04647 17.7554 7.95437 17.7723 7.85685C17.7893 7.75933 17.7828 7.65918 17.7534 7.56467C17.6104 7.1081 17.4271 6.66515 17.2057 6.24103C17.1597 6.15323 17.0934 6.07765 17.0124 6.02051C16.9314 5.96338 16.8379 5.92633 16.7398 5.91242L14.9155 5.65182C14.8274 5.55248 14.7358 5.45523 14.6407 5.36007C14.5456 5.26493 14.4483 5.17332 14.3489 5.08525L14.3489 5.08521L14.088 3.26124C14.0742 3.16324 14.0372 3.06993 13.9802 2.98901C13.9232 2.90809 13.8478 2.84187 13.7602 2.79581C13.3363 2.57407 12.8935 2.39044 12.437 2.2471C12.3424 2.21759 12.2421 2.211 12.1444 2.22789C12.0467 2.24478 11.9544 2.28466 11.8752 2.34423L10.4009 3.44993C10.2684 3.44195 10.1349 3.43794 10.0004 3.4379C9.86581 3.4379 9.73225 3.44191 9.59968 3.44993L9.59963 3.44993Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "white-down": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.76668 7.7418L10 10.9751L13.2333 7.7418C13.5583 7.4168 14.0834 7.4168 14.4083 7.7418C14.7333 8.0668 14.7333 8.5918 14.4083 8.9168L10.5833 12.7418C10.2583 13.0668 9.73335 13.0668 9.40835 12.7418L5.58335 8.9168C5.25835 8.5918 5.25835 8.0668 5.58335 7.7418C5.90835 7.42513 6.44168 7.4168 6.76668 7.7418Z"
        fill="white"
      />
    </svg>
  ),
  "icon-statistic": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_184_10368)">
        <path
          d="M3.4375 17.2496V13.5137H7.8125"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.8125 17.25H2.1875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.8125 17.25V11.0234H12.1875"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.5625 8.5332H12.1875V17.2504H16.5625V8.5332Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.04779 11.2575C6.12347 9.2211 9.23522 7.0368 12.5 3.5"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M13.9071 5.15438L13.5752 2.04705L10.4679 2.37891"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_184_10368">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "export-kq": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V11.8727"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "printer-white": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 6.25V3.125H15V6.25"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.999 11.875H4.99902V17.1875H14.999V11.875Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99902 13.75H2.18652V7.5C2.18652 6.80964 2.7928 6.25 3.54069 6.25H16.4574C17.2052 6.25 17.8115 6.80964 17.8115 7.5V13.75H14.999"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6875 10C15.2053 10 15.625 9.58027 15.625 9.0625C15.625 8.54473 15.2053 8.125 14.6875 8.125C14.1697 8.125 13.75 8.54473 13.75 9.0625C13.75 9.58027 14.1697 10 14.6875 10Z"
        fill="white"
      />
    </svg>
  ),
  printer: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 6.25V3.125H15V6.25"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.999 11.875H4.99902V17.1875H14.999V11.875Z"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.99902 13.75H2.18652V7.5C2.18652 6.80964 2.7928 6.25 3.54069 6.25H16.4574C17.2052 6.25 17.8115 6.80964 17.8115 7.5V13.75H14.999"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5625 9.0625C15.5625 9.54575 15.1707 9.9375 14.6875 9.9375C14.2043 9.9375 13.8125 9.54575 13.8125 9.0625C13.8125 8.57925 14.2043 8.1875 14.6875 8.1875C15.1707 8.1875 15.5625 8.57925 15.5625 9.0625Z"
        fill="#2260BD"
        stroke="#2260BD"
        strokeWidth="0.125"
      />
    </svg>
  ),
  "disease-history": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.875 10H4.375L7.5 3.125L12.5 16.25L15.625 10H18.125"
        stroke="#172B4D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  transfer: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.625 2.5L18.125 10L10.625 17.5V13.75H8.125V6.25H10.625V2.5Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.125 13.75V6.25"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.625 13.75V6.25"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "chat-mess": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.54912 13.828C2.6173 12.2572 2.29097 10.4002 2.6314 8.60583C2.97184 6.81142 3.95563 5.203 5.39803 4.08261C6.84044 2.96222 8.64224 2.40692 10.4651 2.52099C12.2879 2.63506 14.0065 3.41065 15.2979 4.70212C16.5894 5.99359 17.365 7.71211 17.4791 9.53496C17.5932 11.3578 17.0379 13.1596 15.9175 14.602C14.7971 16.0444 13.1887 17.0282 11.3943 17.3687C9.59988 17.7091 7.74291 17.3828 6.17207 16.451L6.17209 16.4509L3.58173 17.191C3.47456 17.2216 3.36115 17.223 3.25325 17.1951C3.14536 17.1671 3.0469 17.1108 2.96809 17.032C2.88927 16.9532 2.83297 16.8547 2.80501 16.7468C2.77705 16.6389 2.77846 16.5255 2.80908 16.4184L3.54918 13.828L3.54912 13.828Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  print: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.875 1.5C6.83947 1.5 6 2.33947 6 3.375V6.36564C5.5736 6.41799 5.1489 6.47583 4.72596 6.53912C3.27191 6.75668 2.25 8.02163 2.25 9.45569V15.75C2.25 17.4069 3.59315 18.75 5.25 18.75H5.51963L5.36461 20.4552C5.26479 21.5533 6.12935 22.5 7.23191 22.5H16.7681C17.8706 22.5 18.7352 21.5533 18.6354 20.4552L18.4804 18.75H18.75C20.4069 18.75 21.75 17.4069 21.75 15.75V9.45569C21.75 8.02163 20.7281 6.75668 19.274 6.53912C18.8511 6.47583 18.4264 6.41799 18 6.36564V3.375C18 2.33947 17.1605 1.5 16.125 1.5H7.875ZM16.5 6.20498V3.375C16.5 3.16789 16.3321 3 16.125 3H7.875C7.66789 3 7.5 3.16789 7.5 3.375V6.20498C8.98198 6.06931 10.483 6 12 6C13.517 6 15.018 6.06931 16.5 6.20498ZM16.2834 14.4696C16.4607 14.4879 16.5996 14.6298 16.6158 14.8073L17.1415 20.591C17.1615 20.8107 16.9886 21 16.7681 21H7.23191C7.0114 21 6.83849 20.8107 6.85845 20.591L7.38425 14.8073C7.40039 14.6298 7.53926 14.4879 7.71659 14.4696C9.12438 14.3244 10.5534 14.25 12 14.25C13.4466 14.25 14.8756 14.3244 16.2834 14.4696ZM17.25 10.5C17.25 10.0858 17.5858 9.75 18 9.75H18.0075C18.4217 9.75 18.7575 10.0858 18.7575 10.5V10.5075C18.7575 10.9217 18.4217 11.2575 18.0075 11.2575H18C17.5858 11.2575 17.25 10.9217 17.25 10.5075V10.5ZM15 9.75C14.5858 9.75 14.25 10.0858 14.25 10.5V10.5075C14.25 10.9217 14.5858 11.2575 15 11.2575H15.0075C15.4217 11.2575 15.7575 10.9217 15.7575 10.5075V10.5C15.7575 10.0858 15.4217 9.75 15.0075 9.75H15Z"
        fill="#154398"
      />
    </svg>
  ),
  "money-circle": (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#E0F3F4" />
      <path
        d="M26.125 13H9.875C9.52982 13 9.25 13.2798 9.25 13.625V22.375C9.25 22.7202 9.52982 23 9.875 23H26.125C26.4702 23 26.75 22.7202 26.75 22.375V13.625C26.75 13.2798 26.4702 13 26.125 13Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18 20.5C19.3807 20.5 20.5 19.3807 20.5 18C20.5 16.6193 19.3807 15.5 18 15.5C16.6193 15.5 15.5 16.6193 15.5 18C15.5 19.3807 16.6193 20.5 18 20.5Z"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 13L26.75 17.375"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 23L26.75 18.625"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 13L9.25 17.375"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.25 23L9.25 18.625"
        stroke="#00AEAC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "user-circle": (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="18" cy="18" r="18" fill="#E3F3FE" />
      <path
        d="M14.875 19.5C17.1187 19.5 18.9375 17.6812 18.9375 15.4375C18.9375 13.1938 17.1187 11.375 14.875 11.375C12.6313 11.375 10.8125 13.1938 10.8125 15.4375C10.8125 17.6812 12.6313 19.5 14.875 19.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M20.1416 11.5263C20.7004 11.3688 21.2864 11.333 21.8602 11.4211C22.434 11.5092 22.9822 11.7193 23.468 12.0371C23.9538 12.355 24.3658 12.7732 24.6763 13.2637C24.9868 13.7542 25.1886 14.3055 25.2681 14.8806C25.3476 15.4557 25.303 16.0411 25.1372 16.5974C24.9714 17.1537 24.6883 17.6681 24.307 18.1058C23.9256 18.5435 23.4549 18.8944 22.9266 19.1349C22.3982 19.3754 21.8244 19.4999 21.2439 19.5"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25 22.4216C9.88448 21.5191 10.7268 20.7825 11.7058 20.274C12.6849 19.7655 13.7719 19.5 14.8751 19.5C15.9783 19.5 17.0653 19.7654 18.0444 20.2738C19.0234 20.7822 19.8658 21.5187 20.5004 22.4212"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.2441 19.5C22.3475 19.4992 23.4347 19.7643 24.4139 20.2728C25.393 20.7813 26.2352 21.5182 26.8692 22.4212"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  send: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="36" height="36" rx="4" fill="#0D99FF" />
      <path
        d="M24.4263 10.8028L9.8694 14.9085C9.74694 14.9431 9.63793 15.0142 9.55696 15.1123C9.47598 15.2105 9.42689 15.331 9.41625 15.4578C9.40561 15.5846 9.43392 15.7116 9.49741 15.8219C9.56089 15.9322 9.65652 16.0204 9.77151 16.0749L16.4599 19.2431C16.5903 19.3049 16.6953 19.4099 16.7571 19.5404L19.9253 26.2287C19.9798 26.3437 20.068 26.4393 20.1783 26.5028C20.2886 26.5663 20.4156 26.5946 20.5424 26.584C20.6692 26.5733 20.7897 26.5242 20.8879 26.4433C20.986 26.3623 21.0571 26.2533 21.0917 26.1308L25.1974 11.574C25.2276 11.467 25.2287 11.354 25.2007 11.2465C25.1726 11.139 25.1164 11.0409 25.0379 10.9624C24.9593 10.8838 24.8612 10.8276 24.7537 10.7995C24.6462 10.7715 24.5332 10.7726 24.4263 10.8028Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6611 19.3388L20.1967 15.8032"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  building: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6.33333V3H1.66669V18H18.3334V6.33333H10ZM5.00002 16.3333H3.33335V14.6667H5.00002V16.3333ZM5.00002 13H3.33335V11.3333H5.00002V13ZM5.00002 9.66667H3.33335V8H5.00002V9.66667ZM5.00002 6.33333H3.33335V4.66667H5.00002V6.33333ZM8.33335 16.3333H6.66669V14.6667H8.33335V16.3333ZM8.33335 13H6.66669V11.3333H8.33335V13ZM8.33335 9.66667H6.66669V8H8.33335V9.66667ZM8.33335 6.33333H6.66669V4.66667H8.33335V6.33333ZM16.6667 16.3333H10V14.6667H11.6667V13H10V11.3333H11.6667V9.66667H10V8H16.6667V16.3333ZM15 9.66667H13.3334V11.3333H15V9.66667ZM15 13H13.3334V14.6667H15V13Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  examination: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.875 5.625H3.125C2.77982 5.625 2.5 5.90482 2.5 6.25V16.25C2.5 16.5952 2.77982 16.875 3.125 16.875H16.875C17.2202 16.875 17.5 16.5952 17.5 16.25V6.25C17.5 5.90482 17.2202 5.625 16.875 5.625Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.125 5.625V4.375C13.125 4.04348 12.9933 3.72554 12.7589 3.49112C12.5245 3.2567 12.2065 3.125 11.875 3.125H8.125C7.79348 3.125 7.47554 3.2567 7.24112 3.49112C7.0067 3.72554 6.875 4.04348 6.875 4.375V5.625"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 9.0625V13.4375"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1875 11.25H7.8125"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  //  "export":
  //  (
  //     <svg
  //       width="20"
  //       height="20"
  //       viewBox="0 0 20 20"
  //       fill="none"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
  //         stroke="#00AEAC"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M10 3.125V11.8727"
  //         stroke="#00AEAC"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //       <path
  //         d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
  //         stroke="#00AEAC"
  //         strokeWidth="2"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       />
  //     </svg>
  //   )
  //   ,
  "cancel-video": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00065 1.3335C4.31398 1.3335 1.33398 4.3135 1.33398 8.00016C1.33398 11.6868 4.31398 14.6668 8.00065 14.6668C11.6873 14.6668 14.6673 11.6868 14.6673 8.00016C14.6673 4.3135 11.6873 1.3335 8.00065 1.3335ZM10.8673 10.8668C10.6073 11.1268 10.1873 11.1268 9.92732 10.8668L8.00065 8.94016L6.07398 10.8668C5.81398 11.1268 5.39398 11.1268 5.13398 10.8668C4.87398 10.6068 4.87398 10.1868 5.13398 9.92683L7.06065 8.00016L5.13398 6.0735C4.87398 5.8135 4.87398 5.3935 5.13398 5.1335C5.39398 4.8735 5.81398 4.8735 6.07398 5.1335L8.00065 7.06016L9.92732 5.1335C10.1873 4.8735 10.6073 4.8735 10.8673 5.1335C11.1273 5.3935 11.1273 5.8135 10.8673 6.0735L8.94065 8.00016L10.8673 9.92683C11.1207 10.1802 11.1207 10.6068 10.8673 10.8668Z"
        fill="#ED1117"
      />
    </svg>
  ),
  cancel: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#FF4648"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12.5 7.5L7.5 12.5"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 12.5L7.5 7.5"
        stroke="#FF4648"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "cancel-blue": (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.5" cy="12" r="10" fill="#154398" />
      <path
        d="M12.4927 13.5314C11.476 14.5641 10.4843 15.5634 9.48428 16.5544C9.30094 16.7293 9.05927 16.8875 8.8176 16.9541C8.34258 17.0874 7.87591 16.8542 7.64257 16.4378C7.4009 16.0048 7.46757 15.4718 7.83424 15.097C8.75926 14.1643 9.68428 13.2316 10.6176 12.2989C10.7176 12.199 10.8176 12.1074 10.951 11.9908C10.851 11.8825 10.7676 11.7909 10.6843 11.7077C9.78428 10.7999 8.87593 9.89223 7.97591 8.98451C7.4509 8.45153 7.40923 7.79365 7.87591 7.3273C8.34259 6.86095 9.00093 6.89426 9.52594 7.4189C10.4343 8.32662 11.3343 9.23434 12.2343 10.1421C12.3177 10.2253 12.401 10.3003 12.5677 10.4585C12.6593 10.3253 12.726 10.1837 12.826 10.0838C13.7094 9.18437 14.5927 8.30164 15.4844 7.41057C16.0011 6.89426 16.6678 6.86927 17.1344 7.35228C17.5845 7.81863 17.5428 8.46819 17.0344 8.98451C16.0511 9.9755 15.0677 10.9582 14.0677 11.9658C14.1594 12.0658 14.2344 12.149 14.3094 12.2323C15.2177 13.1484 16.1344 14.0644 17.0428 14.9804C17.6011 15.5384 17.6511 16.2213 17.1761 16.6876C16.7011 17.154 16.0344 17.0957 15.4761 16.5294C14.5761 15.6217 13.6677 14.714 12.7677 13.8062C12.6927 13.7146 12.6093 13.6314 12.4927 13.5314Z"
        fill="white"
      />
    </svg>
  ),
  recall: (
    <svg
      width="17"
      height="19"
      viewBox="0 0 17 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.00006 3.00052V1.21052C9.00006 0.760519 8.46006 0.540519 8.15006 0.860519L5.35006 3.65052C5.15006 3.85052 5.15006 4.16052 5.35006 4.36052L8.14006 7.15052C8.46006 7.46052 9.00006 7.24052 9.00006 6.79052V5.00052C12.3101 5.00052 15.0001 7.69052 15.0001 11.0005C15.0001 13.7205 13.1701 16.0205 10.6901 16.7505C10.2701 16.8705 10.0001 17.2705 10.0001 17.7005C10.0001 18.3505 10.6201 18.8605 11.2501 18.6705C12.909 18.1858 14.3661 17.1763 15.4029 15.7935C16.4396 14.4106 17 12.7288 17.0001 11.0005C17.0001 6.58052 13.4201 3.00052 9.00006 3.00052ZM3.00006 11.0005C3.00006 9.66052 3.44006 8.42052 4.19006 7.41052C4.49006 7.01052 4.45006 6.46052 4.10006 6.10052C3.68006 5.68052 2.96006 5.72052 2.60006 6.20052C1.82403 7.23368 1.31011 8.43962 1.10237 9.71496C0.894623 10.9903 0.999247 12.297 1.40727 13.523C1.81529 14.7491 2.51455 15.8579 3.44508 16.7544C4.37562 17.6509 5.50968 18.3084 6.75006 18.6705C7.38006 18.8605 8.00006 18.3505 8.00006 17.7005C8.00006 17.2705 7.73006 16.8705 7.31006 16.7505C4.83006 16.0205 3.00006 13.7205 3.00006 11.0005Z"
        fill="#FFA800"
      />
    </svg>
  ),
  checks: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.5625 6.5625L4.6875 13.4375L1.25 10.0002"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7498 6.5625L11.8748 13.4375L10.0488 11.6116"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "check-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.4375 8.125L8.85414 12.5L6.5625 10.3125"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "check-square": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.4375 11.1932V4.0625C3.4375 3.89674 3.50335 3.73777 3.62056 3.62056C3.73777 3.50335 3.89674 3.4375 4.0625 3.4375H15.9375C16.1033 3.4375 16.2622 3.50335 16.3794 3.62056C16.4967 3.73777 16.5625 3.89674 16.5625 4.0625V15.9375C16.5625 16.1033 16.4967 16.2622 16.3794 16.3794C16.2622 16.4967 16.1033 16.5625 15.9375 16.5625H10.5966"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.875L5 16.875L2.5 14.375"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "plus-circle": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M6.875 10H13.125"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 6.875V13.125"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "time-discount": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10 10H14.375"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.0936 13.0936L10 10"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  csyt: (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.25 17.3738H18.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.25 17.3735V3.62354C11.25 3.45777 11.1842 3.2988 11.0669 3.18159C10.9497 3.06438 10.7908 2.99854 10.625 2.99854H3.125C2.95924 2.99854 2.80027 3.06438 2.68306 3.18159C2.56585 3.2988 2.5 3.45777 2.5 3.62354V17.3735"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17.3735V8.62354C17.5 8.45777 17.4342 8.2988 17.3169 8.18159C17.1997 8.06438 17.0408 7.99854 16.875 7.99854H11.25"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 6.12354H7.5"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.25 11.1235H8.75"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 14.2485H7.5"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 14.2485H15"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.75 11.1235H15"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "warning-import": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9.75V13.5"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.7018 3.74857L2.45402 17.9978C2.32204 18.2258 2.25245 18.4846 2.25223 18.748C2.25201 19.0115 2.32118 19.2703 2.45278 19.4986C2.58437 19.7268 2.77376 19.9163 3.00187 20.0481C3.22999 20.1799 3.48879 20.2493 3.75223 20.2493H20.2478C20.5112 20.2493 20.77 20.1799 20.9981 20.0481C21.2263 19.9163 21.4156 19.7268 21.5472 19.4986C21.6788 19.2703 21.748 19.0115 21.7478 18.748C21.7476 18.4846 21.678 18.2258 21.546 17.9978L13.2982 3.74857C13.1664 3.52093 12.9771 3.33193 12.7493 3.20055C12.5214 3.06916 12.263 3 12 3C11.737 3 11.4786 3.06916 11.2507 3.20055C11.0229 3.33193 10.8336 3.52093 10.7018 3.74857V3.74857Z"
        stroke="#FEC328"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 18C12.6213 18 13.125 17.4963 13.125 16.875C13.125 16.2537 12.6213 15.75 12 15.75C11.3787 15.75 10.875 16.2537 10.875 16.875C10.875 17.4963 11.3787 18 12 18Z"
        fill="#FEC328"
      />
    </svg>
  ),
  quanlysuckhoe: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.875H12.5"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.375H12.5"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5002 3.125H15.625C15.7908 3.125 15.9497 3.19085 16.0669 3.30806C16.1842 3.42527 16.25 3.58424 16.25 3.75V16.875C16.25 17.0408 16.1842 17.1997 16.0669 17.3169C15.9497 17.4342 15.7908 17.5 15.625 17.5H4.375C4.20924 17.5 4.05027 17.4342 3.93306 17.3169C3.81585 17.1997 3.75 17.0408 3.75 16.875V3.75C3.75 3.58424 3.81585 3.42527 3.93306 3.30806C4.05027 3.19085 4.20924 3.125 4.375 3.125H7.49983"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 5.625V5C6.875 4.1712 7.20424 3.37634 7.79029 2.79029C8.37634 2.20424 9.1712 1.875 10 1.875C10.8288 1.875 11.6237 2.20424 12.2097 2.79029C12.7958 3.37634 13.125 4.1712 13.125 5V5.625H6.875Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  cauhinhdichvu: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 16.25V3.75C16.25 3.05964 15.6904 2.5 15 2.5L5 2.5C4.30964 2.5 3.75 3.05964 3.75 3.75V16.25C3.75 16.9404 4.30964 17.5 5 17.5H15C15.6904 17.5 16.25 16.9404 16.25 16.25Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 5H12.5"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  quanlychung: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 18.125C15.6066 18.125 18.125 15.6066 18.125 12.5C18.125 9.3934 15.6066 6.875 12.5 6.875C9.3934 6.875 6.875 9.3934 6.875 12.5C6.875 15.6066 9.3934 18.125 12.5 18.125Z"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.57166 7.69727L12.3035 10.4291"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.69653 9.57227L10.4284 12.3041"
        stroke="#BBBBBB"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "management-skdn": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V19H22V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z"
        fill="black"
        fillOpacity="none"
      />
    </svg>
  ),
  "pen-black": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667ZM13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333Z"
        fill="#222D4B"
      />
    </svg>
  ),
  "pen-primary": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 11.5V14H4.5L11.8733 6.62667L9.37333 4.12667L2 11.5ZM3.94667 12.6667H3.33333V12.0533L9.37333 6.01333L9.98667 6.62667L3.94667 12.6667ZM13.8067 3.75333L12.2467 2.19333C12.1133 2.06 11.9467 2 11.7733 2C11.6 2 11.4333 2.06667 11.3067 2.19333L10.0867 3.41333L12.5867 5.91333L13.8067 4.69333C14.0667 4.43333 14.0667 4.01333 13.8067 3.75333Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  "upload-success": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  "upload-green": (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 24H22.5V15H28.5L18 4.5L7.5 15H13.5V24ZM18 8.745L21.255 12H19.5V21H16.5V12H14.745L18 8.745ZM7.5 27H28.5V30H7.5V27Z"
        fill="#00C968"
      />
    </svg>
  ),
  "dot-border": (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="3.5" fill="white" stroke="#222D4B" />
    </svg>
  ),
  "plus-plus": (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66634 5.66732H5.66634V9.66732H4.33301V5.66732H0.333008V4.33398H4.33301V0.333984H5.66634V4.33398H9.66634V5.66732Z"
        fill="#222D4B"
      />
    </svg>
  ),
  "apart-apart": (
    <svg
      width="10"
      height="2"
      viewBox="0 0 10 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.66634 1.66732H0.333008V0.333984H9.66634V1.66732Z"
        fill="#222D4B"
      />
    </svg>
  ),
  "rectangle-black": (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="8" height="8" fill="#222D4B" />
    </svg>
  ),
  "square-square": (
    <svg
      width="6"
      height="6"
      viewBox="0 0 6 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="5"
        height="5"
        fill="white"
        stroke="#C5CED9"
      />
    </svg>
  ),
  eraser: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_5168_17024)">
        <path
          d="M14.0205 6L21.0916 13.0711L13.1419 21.0208L6.99963 21.0208L2.99969 17.0208L14.0205 6Z"
          stroke="#626262"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path d="M9.5 11L14 6.5L20.5 13L16 17.5L9.5 11Z" fill="#626262" />
      </g>
      <defs>
        <clipPath id="clip0_5168_17024">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "edit-primary": (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02V6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0V0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19V3.19Z"
        fill="#01638D"
      />
    </svg>
  ),
  "edit-gray": (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02V6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0V0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19V3.19Z"
        fill="#8e8e93"
      />
    </svg>
  ),
  "white-upload": (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 13H10V7H14L7 0L0 7H4V13ZM7 2.83L9.17 5H8V11H6V5H4.83L7 2.83ZM0 15H14V17H0V15Z"
        fill="white"
      />
    </svg>
  ),
  "red-warning": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00033 3.99398L13.0203 12.6673H2.98033L8.00033 3.99398ZM8.00033 1.33398L0.666992 14.0007H15.3337L8.00033 1.33398ZM8.66699 10.6673H7.33366V12.0007H8.66699V10.6673ZM8.66699 6.66732H7.33366V9.33398H8.66699V6.66732Z"
        fill="#E50500"
      />
    </svg>
  ),
  "black-dot": (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill="#222D4B" />
    </svg>
  ),
  "expire-date-sign": (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4831_16432)">
        <path
          d="M24.9992 11.1104C17.3604 11.1104 11.1104 17.3604 11.1104 24.9992C11.1104 32.6381 17.3604 38.8881 24.9992 38.8881C32.6381 38.8881 38.8881 32.6381 38.8881 24.9992C38.8881 17.3604 32.6381 11.1104 24.9992 11.1104ZM24.9992 36.1103C18.8742 36.1103 13.8881 31.1242 13.8881 24.9992C13.8881 18.8742 18.8742 13.8881 24.9992 13.8881C31.1242 13.8881 36.1103 18.8742 36.1103 24.9992C36.1103 31.1242 31.1242 36.1103 24.9992 36.1103ZM25.6937 18.0548H23.6103V26.3881L30.8326 30.8326L31.9437 29.027L25.6937 25.277V18.0548Z"
          fill="#E50500"
        />
      </g>
      <circle cx="25" cy="25" r="24.5" stroke="#E50500" strokeDasharray="5 5" />
      <defs>
        <clipPath id="clip0_4831_16432">
          <rect
            width="33.3333"
            height="33.3333"
            fill="white"
            transform="translate(8.33301 8.33301)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  "zoom-in": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect opacity="0.5" width="24" height="24" rx="4" fill="#222D4B" />
      <path
        d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
        fill="white"
      />
    </svg>
  ),
  "zoom-out": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="4" fill="#0D99FF" />
      <path
        d="M15 3L17.3 5.3L14.41 8.17L15.83 9.59L18.7 6.7L21 9V3H15ZM3 9L5.3 6.7L8.17 9.59L9.59 8.17L6.7 5.3L9 3H3V9ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM21 15L18.7 17.3L15.83 14.41L14.41 15.83L17.3 18.7L15 21H21V15Z"
        fill="white"
      />
    </svg>
  ),
  "arrow-down-primary": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 10L12 15L17 10H7Z" fill={"#0D99FF"} />
    </svg>
  ),
  "arrow-up-primary": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7 14L12 9L17 14H7Z" fill={"#0D99FF"} />
    </svg>
  ),
  "arrow-down-primary-black": (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0L5 5L10 0H0Z" fill="#323232" />
    </svg>
  ),
  "arrow-up-primary-black": (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 5L5 0L10 5H0Z" fill="#323232" />
    </svg>
  ),
  pin: (
    <svg
      width="27"
      height="28"
      viewBox="0 0 27 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_4412_19837)">
        <path
          d="M18.6293 10.4433L14.658 19.1651C13.8948 20.8411 11.9191 21.5806 10.243 20.8174C8.56689 20.0542 7.82747 18.0785 8.59066 16.4024L12.9073 6.92223C13.3839 5.87562 14.6201 5.41297 15.6667 5.88953C16.7133 6.36609 17.1759 7.60228 16.6994 8.64889L13.0734 16.6122C12.8835 17.0294 12.3868 17.2152 11.9696 17.0253C11.5525 16.8354 11.3666 16.3387 11.5566 15.9216L14.8372 8.71664L13.6996 8.19864L10.4189 15.4036C9.94238 16.4502 10.405 17.6864 11.4516 18.1629C12.4983 18.6395 13.7344 18.1768 14.211 17.1302L17.837 9.16689C18.6002 7.4908 17.8608 5.5151 16.1847 4.75191C14.5086 3.98873 12.5329 4.72814 11.7697 6.40423L7.45304 15.8844C6.40323 18.19 7.41941 20.9052 9.72498 21.955C12.0306 23.0048 14.7458 21.9886 15.7956 19.6831L19.7669 10.9613L18.6293 10.4433Z"
          fill="#0D99FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_4412_19837">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.106445 18.9487) rotate(-65.5185)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  copyVBM: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM15 5H8C6.9 5 6.01 5.9 6.01 7L6 21C6 22.1 6.89 23 7.99 23H19C20.1 23 21 22.1 21 21V11L15 5ZM8 21V7H14V12H19V21H8Z"
        fill="#8E24AA"
      />
    </svg>
  ),
  emptySign: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 15H13V17H11V15ZM11 7H13V13H11V7ZM11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z"
        fill="#E50500"
      />
    </svg>
  ),
  empty: (
    <svg
      width="97"
      height="62"
      viewBox="0 0 97 62"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48.5 61.9989C75.2858 61.9989 97 57.2596 97 51.4135C97 45.5674 75.2858 40.8281 48.5 40.8281C21.7142 40.8281 0 45.5674 0 51.4135C0 57.2596 21.7142 61.9989 48.5 61.9989Z"
        fill="#DCDCDC"
      />
      <path
        d="M83.3594 20.8082L67.9823 3.41315C67.2444 2.22824 66.1659 1.51172 65.0306 1.51172H31.9694C30.8341 1.51172 29.7556 2.22842 29.0177 3.41315L13.6406 20.8082L13.6406 34.78H83.3594V20.8082Z"
        stroke="#B3AAAA"
      />
      <path
        d="M63.0701 25.6029C63.0701 23.1749 64.5762 21.1703 66.4445 21.1699H83.3594V48.5968C83.3594 51.8054 81.3578 54.4382 78.8889 54.4382H18.1111C15.642 54.4382 13.6406 51.8052 13.6406 48.5968V21.1699H30.5555C32.4238 21.1699 33.9299 23.1703 33.9299 25.5983V25.6304C33.9299 28.0584 35.4531 30.0181 37.3214 30.0181H59.6786C61.5469 30.0181 63.0701 28.0404 63.0701 25.6123V25.6029Z"
        fill="#FAFAFA"
        stroke="#B3AAAA"
      />
    </svg>
  ),
  uploadVBMIcon: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.6663 85.3333V41.8666L44.7997 55.7333L37.333 47.9999L63.9997 21.3333L90.6663 47.9999L83.1997 55.7333L69.333 41.8666V85.3333H58.6663ZM21.333 106.667V79.9999H31.9997V95.9999H95.9997V79.9999H106.666V106.667H21.333Z"
        fill="#01638d"
      />
    </svg>
  ),
  settingVBM: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98V12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
        fill="#F57C00"
      />
    </svg>
  ),
  starOrange: (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.99935 5.75797L6.05935 7.0013L5.51268 4.65797L7.33268 3.0813L4.93602 2.87797L3.99935 0.667969L3.06268 2.87797L0.666016 3.0813L2.48602 4.65797L1.93935 7.0013L3.99935 5.75797Z"
        fill="#F57C00"
      />
    </svg>
  ),
  writeVBM: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="49" stroke="#8E24AA" strokeWidth="2" />
      <path
        d="M54.2917 43.7917L56.2083 45.7083L37.3333 64.5833H35.4167V62.6667L54.2917 43.7917V43.7917ZM61.7917 31.25C61.2708 31.25 60.7292 31.4583 60.3333 31.8542L56.5208 35.6667L64.3333 43.4792L68.1458 39.6667C68.9583 38.8542 68.9583 37.5417 68.1458 36.7292L63.2708 31.8542C62.8542 31.4375 62.3333 31.25 61.7917 31.25V31.25ZM54.2917 37.8958L31.25 60.9375V68.75H39.0625L62.1042 45.7083L54.2917 37.8958V37.8958Z"
        fill="#8E24AA"
      />
    </svg>
  ),
  uploadVBM: (
    <svg
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="50" cy="50" r="49" stroke="#00C968" strokeWidth="2" />
      <path
        d="M43.7493 58.3333H56.2494V45.8333H64.5827L49.9993 31.25L35.416 45.8333H43.7493V58.3333ZM49.9993 37.1458L54.5202 41.6667H52.0827V54.1667H47.916V41.6667H45.4785L49.9993 37.1458ZM35.416 62.5H64.5827V66.6667H35.416V62.5Z"
        fill="#00C968"
      />
    </svg>
  ),
  sign: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 0H3C1.34325 0 0 1.34325 0 3V21C0 22.6568 1.34325 24 3 24H11.25V22.5H3C2.17387 22.5 1.5 21.8276 1.5 21V3C1.5 2.17237 2.17387 1.5 3 1.5H18C18.8276 1.5 19.5 2.17237 19.5 3V11.8183L21 10.3183V3C21 1.34325 19.6568 0 18 0Z"
        fill="#8E24AA"
      />
      <path
        d="M23.5605 13.5L22.5 12.4395C22.2069 12.1464 21.8233 12 21.4395 12C21.0557 12 20.6719 12.1464 20.379 12.4395L13.9395 18.879C13.6464 19.1721 12.7504 20.3049 12.75 20.6887L12 24L15.3105 23.25C15.3105 23.25 16.8281 22.3536 17.121 22.0605L23.5605 15.621C24.1464 15.0352 24.1464 14.0852 23.5605 13.5ZM16.5922 21.5287C16.5073 21.6094 16.2135 21.8078 15.8546 22.0363L13.9116 20.0933C14.1109 19.8201 14.3327 19.5454 14.4697 19.4092L19.3183 14.5607L21.4395 16.6819L16.5922 21.5287Z"
        fill="#8E24AA"
      />
      <path opacity="0.3" d="M16.5 6H4.5V4.5H16.5V6Z" fill="#8E24AA" />
      <path opacity="0.3" d="M16.5 9H4.5V7.5H16.5V9Z" fill="#8E24AA" />
      <path opacity="0.3" d="M16.5 12H4.5V10.5H16.5V12Z" fill="#8E24AA" />
      <path opacity="0.3" d="M10.5 15H4.5V13.5H10.5V15Z" fill="#8E24AA" />
    </svg>
  ),
  iconSigned: (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2210_12464)">
        <path
          d="M14.3242 8.95268C14.4809 8.97506 14.6376 9.01982 14.8166 9.06458L15.1747 9.98222L15.6223 9.15411C15.9357 9.15411 16.249 9.17649 16.5624 9.17649L15.9581 8.39314C15.9804 8.326 16.0028 8.25885 16.0252 8.19171C15.9581 8.16933 15.8909 8.14695 15.7566 8.10219C15.9581 7.90075 16.0476 7.81123 16.1595 7.85599C16.2043 7.74408 16.249 7.60979 16.2938 7.49789C15.9804 7.58741 15.6671 7.7217 15.3538 7.83361C15.1747 7.69932 14.9957 7.58741 14.8166 7.45312C14.8166 7.60979 14.839 7.78885 14.7718 7.99028C14.6823 7.78885 14.6152 7.63218 14.548 7.52027C14.5704 7.76646 14.5704 8.03504 14.5928 8.28124C14.5704 8.30362 14.5257 8.326 14.5033 8.37076C14.5928 8.37076 14.6823 8.37076 14.7942 8.37076C14.7942 8.66172 14.6823 8.84077 14.3242 8.95268Z"
          fill="#00C968"
        />
        <path
          d="M13.8545 8.86288C13.8993 8.86288 13.944 8.88527 13.9888 8.88527C13.9888 8.8405 13.9888 8.79574 13.9888 8.75098C13.9216 8.79574 13.8993 8.81812 13.8545 8.86288Z"
          fill="#00C968"
        />
        <path
          d="M20.1208 5.93097C19.9194 5.68477 19.6956 5.43858 19.4718 5.19238C19.4046 5.5281 19.3375 5.84144 19.2927 6.17716L18.8451 6.3786L18.3975 6.60241C18.7108 6.7367 19.0018 6.87099 19.2927 7.02766L19.427 7.99006L20.0761 7.31861C20.3894 7.38576 20.6804 7.49766 20.9713 7.58719L20.5908 6.69193C20.7699 6.42336 20.9489 6.1324 21.128 5.86382C20.7923 5.86382 20.4565 5.90859 20.1208 5.93097Z"
          fill="#00C968"
        />
        <path
          d="M10.9897 12.1309L11.5716 12.9142C11.6387 12.6009 11.7283 12.3099 11.8178 11.9966C12.1087 11.907 12.4445 11.8623 12.7354 11.7951L11.9521 11.1908C11.9744 10.8775 11.9968 10.5418 12.0416 10.2061C11.7506 10.3851 11.4821 10.5865 11.2135 10.7656C10.9001 10.6537 10.5868 10.5418 10.2735 10.4299C10.363 10.7432 10.4749 11.0565 10.5868 11.3699C10.3854 11.6385 10.1839 11.907 10.0049 12.1756C10.3406 12.1756 10.6539 12.1532 10.9897 12.1309Z"
          fill="#00C968"
        />
        <path
          d="M18.1292 35.8776C18.1515 35.6538 18.1292 35.5867 17.9053 35.4748C17.5696 35.3181 17.9501 35.139 18.0396 34.9824C17.9501 34.8929 17.9053 34.8257 17.7934 34.6914C18.0396 34.5795 18.2635 34.4676 18.5096 34.3333C18.6216 34.7138 18.7111 35.0271 18.8006 35.3629C19.2706 35.3629 19.4273 35.721 19.6287 36.1462C19.2259 36.0567 19.3154 35.9672 19.1587 36.4595L22.8293 38.5858C22.8069 38.4291 22.8516 38.2948 23.0083 38.2724C23.0978 38.2501 23.2097 38.2948 23.2769 38.3396L25.1122 35.1614C25.0674 35.1614 25.045 35.1838 25.0002 35.1838C24.9555 35.1838 24.9107 35.0719 24.9107 35.0495C24.9331 35.0048 25.0002 34.96 25.1122 34.8928C25.1345 34.96 25.1569 35.0048 25.1793 35.0495L25.9403 33.7514C25.8507 33.729 25.7388 33.7066 25.5598 33.6395C25.7388 33.5723 25.9179 33.4828 26.0969 33.5052L26.6788 32.4757C26.5893 32.5204 26.4998 32.5652 26.3655 32.5876C26.1193 31.9161 26.3431 31.5804 27.0817 31.5804C27.0593 31.6923 27.0369 31.7818 27.0146 31.8937L30.797 25.3584C30.7523 25.4031 30.7299 25.4255 30.6627 25.4703C30.6851 25.1346 30.7075 24.9331 30.9985 25.0003L33.4828 20.7031C33.4604 20.6583 33.4156 20.5688 33.3709 20.4792C33.438 20.4792 33.5276 20.4792 33.5947 20.5016L37.1533 14.3244L30.5508 10.5195L20.3002 28.2903L13.7872 24.5303L9.95996 31.1552L18.1292 35.8776Z"
          fill="#00C968"
        />
        <path
          d="M0 25.0001C0 25.0896 0 25.1567 0 25.2463C0.0447628 25.2239 0.0895255 25.2015 0.179051 25.2015C0.201432 25.2015 0.290958 25.3134 0.268577 25.3134C0.201432 25.4029 0.15667 25.5148 0.0671442 25.5596C0.0447628 25.5596 0.0223814 25.582 0 25.582C0.0223814 26.9025 0.15667 28.2006 0.402865 29.4764C0.470009 29.4316 0.514772 29.3644 0.559535 29.2749C0.626679 29.1406 0.895255 29.0959 1.09669 29.0063C1.16383 28.6035 0.738586 28.7154 0.581916 28.5363C0.49239 28.2006 0.425246 27.8649 0.290958 27.3725C0.760967 27.7082 0.984781 28.1335 1.38765 28.3349C1.49955 28.3797 1.61146 28.4468 1.72337 28.514C1.70099 28.2901 1.65622 28.0887 1.63384 27.8649C1.41003 27.932 1.20859 27.9768 1.00716 27.753C0.581916 27.2606 0.783348 26.7906 0.80573 26.6339C1.09669 26.522 1.3205 26.4772 1.49955 26.5444C1.47717 26.3206 1.47717 26.0968 1.45479 25.8506C1.41003 25.8506 1.38765 25.8282 1.34288 25.8282C1.09669 25.7163 1.25336 25.582 1.36526 25.4029C1.38765 25.4253 1.41003 25.4477 1.43241 25.4701C1.38765 23.6124 1.5667 21.7772 1.96956 20.009C1.79051 19.8524 1.74575 19.7181 1.79051 19.5614C1.83527 19.4271 1.9248 19.36 2.12623 19.3824C3.9615 11.9517 9.35542 5.61781 16.8979 2.8649C16.8308 2.79775 16.7637 2.73061 16.6741 2.66346C16.8532 2.6187 16.9651 2.57394 17.1441 2.52918C17.1218 2.6187 17.1218 2.70823 17.1218 2.79775C17.547 2.64108 17.9946 2.50679 18.4423 2.37251C18.3751 2.17107 18.2856 1.94726 18.1961 1.67868C18.4199 1.74583 19.3151 1.85773 19.0913 2.19345C22.5381 1.2982 26.0295 1.20867 29.3196 1.83535C29.2972 1.81297 29.2972 1.81297 29.2748 1.79059C29.7225 1.67868 29.7672 1.6563 29.9687 1.96964C30.5058 2.08155 31.0206 2.21584 31.5354 2.37251C31.5577 2.35012 31.5801 2.30536 31.6249 2.2606C31.6473 2.32774 31.6697 2.37251 31.692 2.41727C34.333 3.20062 36.795 4.43159 39.0107 6.06543C39.0107 5.99829 39.0107 5.90876 38.9884 5.75209C39.4136 5.95353 39.3689 5.81924 39.2569 6.2221C39.2346 6.2221 39.2122 6.19972 39.1898 6.19972C43.2408 9.24359 46.3518 13.6303 47.7619 18.89C51.1191 31.4235 43.6437 44.3824 31.1101 47.7396C29.8568 48.0753 28.6034 48.2991 27.3277 48.4334C27.4172 48.5677 27.5515 48.6796 27.5739 48.8139C27.6634 49.3734 27.2381 49.4182 26.6338 49.6867C26.88 49.2167 27.0591 48.8362 27.2605 48.4334C26.0072 48.5453 24.7314 48.5677 23.5005 48.5005C23.6124 48.6348 23.6571 48.702 23.5676 48.9929C23.5676 49.0153 23.3885 49.0153 23.3662 48.9929C23.2319 48.7691 23.3214 48.6124 23.3885 48.5005C23.12 48.4781 22.8514 48.4558 22.5828 48.4334V48.4558C22.4933 48.4558 22.4261 48.4334 22.3814 48.411C20.9937 48.2543 19.6061 47.9634 18.2856 47.5605C18.5765 47.9186 18.487 48.0305 17.9499 48.3439C17.9722 48.1648 18.0618 47.9634 18.017 47.8738C17.9275 47.7172 17.9499 47.6053 18.017 47.4934C16.2936 46.9562 14.6374 46.2176 13.0931 45.3C12.8022 45.3 12.735 45.3 12.6679 45.0538C12.4888 44.9419 12.3098 44.83 12.1531 44.7181C12.1083 44.7628 12.1083 44.7405 11.9964 44.6733C11.9964 44.6509 12.0188 44.6509 12.0188 44.6285C7.38586 41.5623 3.82722 36.8622 2.2829 31.1102C2.12623 30.5283 1.99194 29.924 1.88004 29.3421C1.79051 29.3421 1.70099 29.3197 1.5667 29.2973C1.3205 29.7225 1.07431 30.1254 0.581916 30.2373C0.716204 30.8416 0.872874 31.4459 1.02954 32.0502C1.07431 32.0054 1.16383 31.9607 1.25336 31.8935C1.18621 32.0054 1.14145 32.1397 1.07431 32.2516C1.70099 34.3555 2.61862 36.3474 3.76007 38.1827L3.78245 38.1603C3.93912 38.026 3.62578 37.5336 4.16294 37.6232C4.2077 37.9589 4.2077 38.2499 3.91674 38.4737C3.93912 38.5184 3.9615 38.5632 4.00627 38.608C4.05103 38.5856 4.14056 38.5632 4.29723 38.5184C4.23008 38.5856 4.18532 38.6751 4.11817 38.7646C8.46016 45.3447 15.8236 49.7763 24.239 50.0225C24.2167 50.0001 24.1943 49.9553 24.1719 49.9329C24.3062 49.9777 24.4181 50.0001 24.5076 50.0225C24.6643 50.0225 24.8433 50.0225 25 50.0225C31.0654 50.0225 36.6159 47.8738 40.9355 44.2704C40.8013 44.2704 40.7565 44.2481 40.846 43.9571C41.0251 44.1138 41.0475 44.1138 41.0475 44.1585C44.1361 41.5847 46.5757 38.2499 48.12 34.4898C48.0081 34.5569 47.8962 34.6465 47.7619 34.736C47.7619 34.4226 47.829 34.2212 48.0976 34.1541C48.12 34.1541 48.1647 34.1988 48.2095 34.2436C48.2766 34.0869 48.3438 33.9079 48.4109 33.7512C48.3662 33.7512 48.3214 33.7512 48.2766 33.7512C48.3438 33.6617 48.4333 33.5721 48.5228 33.4379C48.6124 33.1917 48.7019 32.9455 48.769 32.6993C48.7467 32.6993 48.7243 32.7217 48.7019 32.744C48.7914 32.4531 48.8809 32.1621 48.9705 31.8488C48.9928 31.8488 49.0152 31.8488 49.0152 31.8712C49.06 31.6921 49.1048 31.5131 49.1719 31.334C49.1271 31.2669 49.1719 31.1773 49.239 31.0207C49.7091 29.0959 49.9776 27.0815 49.9776 25.0001C49.9776 18.1738 47.2471 11.9741 42.7932 7.47546C42.7708 7.47546 42.7261 7.49784 42.7037 7.52022C42.4575 7.40832 42.3903 7.22926 42.368 7.05021C40.4879 5.23732 38.3169 3.69301 35.9445 2.52918C35.9221 2.55156 35.8774 2.57394 35.855 2.6187C35.855 2.57394 35.855 2.52918 35.855 2.50679C34.2435 1.67868 32.4754 1.07439 30.6625 0.64914C30.5506 0.850572 30.3939 1.02962 30.1477 1.16391C30.0134 1.25344 29.8791 1.36534 29.7001 1.16391C29.9015 1.052 29.9015 0.693902 30.2596 0.761046C30.282 0.761046 30.3715 0.671521 30.3939 0.604377C30.1925 0.559614 29.9911 0.514851 29.7896 0.470088C29.6777 0.537233 29.521 0.626758 29.3196 0.738665C29.2077 0.581995 29.2077 0.470088 29.2301 0.380563C29.0958 0.358182 28.9391 0.3358 28.8048 0.313419C28.7825 0.425326 28.7825 0.581995 28.8048 0.828191C28.6034 0.98486 28.402 1.16391 28.1782 1.34296C28.1558 1.18629 28.0663 1.02962 28.0886 0.895335C28.1334 0.581995 28.1334 0.358182 28.0663 0.201512C27.0815 0.0896051 26.0519 0.0224609 25.0224 0.0224609C23.3214 0.0224609 21.6428 0.201512 20.0313 0.514851C20.0313 0.559614 20.0537 0.626758 20.0313 0.716284C19.8747 0.671521 19.7628 0.626758 19.6956 0.559614C18.8675 0.738665 18.0394 0.962479 17.2337 1.23106C17.1218 1.34296 17.0546 1.36534 16.9651 1.32058C7.0949 4.67779 0 14.0108 0 25.0001Z"
          fill="#00C968"
        />
        <path
          d="M6.02022 25.2235C5.97545 21.8439 6.82595 18.5091 8.57169 15.51L7.27357 14.749C4.54305 19.4939 3.80446 24.9997 5.23687 30.2817C6.6469 35.5637 10.0489 39.9728 14.7713 42.7257L15.5323 41.4276C11.2127 38.9433 8.10169 34.937 6.7588 30.125C6.7588 30.1698 6.73642 30.1698 6.6469 30.2146C6.46784 29.946 6.46784 30.0131 6.69166 29.9012C6.4007 28.7822 6.19927 27.6631 6.10974 26.544C6.08736 26.5664 6.06498 26.6112 6.06498 26.6112C6.08736 27.1707 5.63973 27.2602 5.25925 27.5064C5.12496 27.2378 5.01305 27.014 4.87877 26.7678C5.12496 26.7007 5.41592 26.6783 5.57259 26.5216C5.72926 26.3873 5.77402 26.0964 5.86355 25.8949C5.70688 25.7159 5.57259 25.5816 5.41592 25.4026C5.61735 25.2459 5.75164 25.134 5.88593 24.9997C5.90831 25.0668 5.93069 25.1116 6.02022 25.2235Z"
          fill="#00C968"
        />
        <path
          d="M25.2014 5.3269C25.0671 5.03594 24.9105 4.7226 24.7538 4.43164C24.6195 4.7226 24.4628 5.03594 24.3285 5.3269C23.9928 5.37166 23.6795 5.4388 23.3438 5.52833C23.6123 5.72976 23.8585 5.93119 24.1047 6.15501L23.9928 7.13979C24.2614 6.96074 24.5076 6.80407 24.7985 6.6474C25.0671 6.78169 25.3357 6.96074 25.6043 7.11741L25.4476 6.15501C25.6938 5.93119 25.94 5.70738 26.1862 5.50595C25.8729 5.39404 25.5371 5.37166 25.2014 5.3269Z"
          fill="#00C968"
        />
        <path
          d="M34.7135 40.5778L34.3554 39.6602L33.9078 40.4883C33.5945 40.4883 33.2811 40.4659 32.9678 40.4659L33.5721 41.2492C33.4825 41.5626 33.3706 41.8759 33.2363 42.1669C33.5497 42.0773 33.863 41.9431 34.1764 41.8312C34.4449 42.0326 34.7135 42.2116 35.0045 42.3907C34.9821 42.055 34.9597 41.7192 34.9373 41.4059C35.2059 41.2045 35.4521 40.9807 35.6983 40.7568C35.3402 40.7121 35.0269 40.6449 34.7135 40.5778Z"
          fill="#00C968"
        />
        <path
          d="M29.3871 43.6885C29.5886 43.9347 29.8124 44.2033 30.0362 44.4495C30.1033 44.1138 30.1705 43.8004 30.2152 43.4647L30.6629 43.2633L31.1105 43.0395C30.8867 42.9499 30.6852 42.838 30.4838 42.7485C30.4838 42.7709 30.4838 42.7709 30.4614 42.7933C30.3048 43.0395 30.0586 42.7709 29.4543 42.3233C29.1409 42.2561 28.85 42.1442 28.559 42.0547L28.9395 42.9499C28.7604 43.2185 28.5814 43.5095 28.4023 43.7781C28.7381 43.7557 29.0514 43.7109 29.3871 43.6885Z"
          fill="#00C968"
        />
        <path
          d="M30.1927 42.278L30.1032 41.6289L29.4541 42.3003C29.7898 42.2108 30.036 42.2108 30.1927 42.278Z"
          fill="#00C968"
        />
        <path
          d="M24.3061 44.3148C24.4404 44.6058 24.597 44.9191 24.7537 45.2101C24.888 44.9191 25.0447 44.6058 25.1789 44.3148C25.5147 44.2701 25.828 44.2029 26.1637 44.1134C25.8952 43.912 25.649 43.7105 25.4028 43.4867L25.5147 42.502C25.2461 42.681 24.9999 42.8377 24.7089 42.9943C24.4404 42.8601 24.1718 42.681 23.9032 42.5243L24.0599 43.4867C23.8137 43.7105 23.5675 43.9344 23.3213 44.1358C23.657 44.2253 23.9704 44.2477 24.3061 44.3148Z"
          fill="#00C968"
        />
        <path
          d="M29.5654 7.13982C29.7892 7.36364 30.013 7.58745 30.2368 7.81126L30.3263 6.82648C30.6173 6.66981 30.9082 6.51314 31.1992 6.37886C30.9082 6.22219 30.5949 6.11028 30.2816 5.97599C30.2144 5.66265 30.1473 5.32693 30.0801 4.99121C29.8563 5.23741 29.6549 5.50598 29.4535 5.77456C29.1177 5.75218 28.782 5.7298 28.4463 5.70742C28.6477 5.97599 28.8492 6.22219 29.0282 6.51314L28.6701 7.43078L29.5654 7.13982Z"
          fill="#00C968"
        />
        <path
          d="M19.4491 44.6062C19.673 44.36 19.8744 44.0914 20.0758 43.8228C20.4115 43.8452 20.7473 43.8676 21.083 43.89C20.8816 43.6214 20.6801 43.3752 20.5011 43.0843L20.8592 42.1666L19.9639 42.4576C19.7401 42.2338 19.5163 42.0099 19.2925 41.7861L19.203 42.7709C18.912 42.9276 18.621 43.0843 18.3301 43.2185C18.621 43.3752 18.9344 43.4871 19.2477 43.6214V43.6438C19.2925 43.5766 19.3372 43.5095 19.4044 43.4424C19.5834 43.599 19.7401 43.7333 19.9415 43.89C19.6506 43.9571 19.4715 44.0243 19.3372 44.0466C19.382 44.2705 19.4044 44.4271 19.4491 44.6062Z"
          fill="#00C968"
        />
        <path
          d="M38.5407 37.4884L37.9588 36.7051C37.8916 37.0184 37.8021 37.3094 37.7126 37.6227C37.4216 37.7122 37.0859 37.757 36.7949 37.8241L37.5783 38.4284C37.5559 38.7418 37.5335 39.0775 37.4887 39.4132C37.7797 39.2342 38.0483 39.0327 38.3169 38.8537C38.6302 38.9656 38.9435 39.0775 39.2569 39.1894C39.1673 38.8761 39.0554 38.5627 38.9435 38.2494C39.145 37.9808 39.3464 37.7122 39.5255 37.4437C39.1897 37.4437 38.854 37.466 38.5407 37.4884Z"
          fill="#00C968"
        />
        <path
          d="M38.6746 9.73629C37.6226 8.79627 36.4812 7.96816 35.2502 7.25195L34.4893 8.55007C38.876 11.0792 42.0094 15.175 43.3299 20.0765C43.4866 20.6584 43.6209 21.2627 43.7104 21.8446C43.7999 21.867 43.8894 21.9118 43.979 21.9789C43.9342 22.0684 43.9118 22.2027 43.8447 22.2027C43.8223 22.2027 43.7999 22.2027 43.7775 22.2251C43.8447 22.7175 43.9118 23.2099 43.9342 23.6799C43.979 23.7023 44.0237 23.747 44.0685 23.7694C44.0237 23.8142 43.979 23.8366 43.9566 23.8589C44.0685 25.6718 43.9118 27.4847 43.5089 29.2305C43.7328 29.1633 43.9342 29.0962 44.1804 29.32C44.2252 29.1633 44.2699 29.2081 43.9118 28.9619C43.6656 28.7828 43.6656 28.7828 43.9342 28.4471C44.1356 28.5143 44.158 28.8947 44.4937 28.8052C44.5161 28.8052 44.6056 29.0738 44.6056 29.0514C44.5161 29.32 44.2252 29.5662 44.5833 29.8348C44.3594 30.1033 44.158 30.2824 43.8223 30.3048C44.0461 30.7076 43.6209 30.7972 43.5313 31.0434C43.3299 31.0657 43.1285 31.0657 42.9494 31.0881C42.6585 31.9386 42.3004 32.7667 41.8975 33.5725C41.9646 33.6172 42.0318 33.662 42.0989 33.7067C41.8975 33.9306 41.8303 33.9977 41.6513 34.0201C41.5842 34.1544 41.517 34.2887 41.4275 34.4229L42.7256 35.1839C45.4561 30.4391 46.1947 24.9332 44.7623 19.6512C43.7328 15.7793 41.6289 12.3773 38.7193 9.75867C38.585 10.072 38.6746 10.4749 38.2717 10.6092C37.8465 10.7434 37.5779 10.4525 37.3093 10.0944C37.7793 10.0049 38.0703 9.40056 38.6746 9.73629Z"
          fill="#00C968"
        />
        <path
          d="M43.8227 30.3713C43.8899 29.6327 44.0018 29.4537 43.5765 29.5208C43.6884 29.8118 43.3079 30.1699 43.8227 30.3713Z"
          fill="#00C968"
        />
      </g>
      <defs>
        <clipPath id="clip0_2210_12464">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  iconRejectSigned: (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2210_12522)">
        <path
          d="M14.3242 8.95268C14.4809 8.97506 14.6376 9.01982 14.8166 9.06458L15.1747 9.98222L15.6223 9.15411C15.9357 9.15411 16.249 9.17649 16.5624 9.17649L15.9581 8.39314C15.9804 8.326 16.0028 8.25885 16.0252 8.19171C15.9581 8.16933 15.8909 8.14695 15.7566 8.10219C15.9581 7.90075 16.0476 7.81123 16.1595 7.85599C16.2043 7.74408 16.249 7.60979 16.2938 7.49789C15.9804 7.58741 15.6671 7.7217 15.3538 7.83361C15.1747 7.69932 14.9957 7.58741 14.8166 7.45312C14.8166 7.60979 14.839 7.78885 14.7718 7.99028C14.6823 7.78885 14.6152 7.63218 14.548 7.52027C14.5704 7.76646 14.5704 8.03504 14.5928 8.28124C14.5704 8.30362 14.5257 8.326 14.5033 8.37076C14.5928 8.37076 14.6823 8.37076 14.7942 8.37076C14.7942 8.66172 14.6823 8.84077 14.3242 8.95268Z"
          fill="#E50500"
        />
        <path
          d="M13.8545 8.86288C13.8993 8.86288 13.944 8.88527 13.9888 8.88527C13.9888 8.8405 13.9888 8.79574 13.9888 8.75098C13.9216 8.79574 13.8993 8.81812 13.8545 8.86288Z"
          fill="#E50500"
        />
        <path
          d="M20.1208 5.93097C19.9194 5.68477 19.6956 5.43858 19.4718 5.19238C19.4046 5.5281 19.3375 5.84144 19.2927 6.17716L18.8451 6.3786L18.3975 6.60241C18.7108 6.7367 19.0018 6.87099 19.2927 7.02766L19.427 7.99006L20.0761 7.31861C20.3894 7.38576 20.6804 7.49766 20.9713 7.58719L20.5908 6.69193C20.7699 6.42336 20.9489 6.1324 21.128 5.86382C20.7923 5.86382 20.4565 5.90859 20.1208 5.93097Z"
          fill="#E50500"
        />
        <path
          d="M10.9897 12.1309L11.5716 12.9142C11.6387 12.6009 11.7283 12.3099 11.8178 11.9966C12.1087 11.907 12.4445 11.8623 12.7354 11.7951L11.9521 11.1908C11.9744 10.8775 11.9968 10.5418 12.0416 10.2061C11.7506 10.3851 11.4821 10.5865 11.2135 10.7656C10.9001 10.6537 10.5868 10.5418 10.2735 10.4299C10.363 10.7432 10.4749 11.0565 10.5868 11.3699C10.3854 11.6385 10.1839 11.907 10.0049 12.1756C10.3406 12.1756 10.6539 12.1532 10.9897 12.1309Z"
          fill="#E50500"
        />
        <path
          d="M18.1292 35.8776C18.1515 35.6538 18.1292 35.5867 17.9053 35.4748C17.5696 35.3181 17.9501 35.139 18.0396 34.9824C17.9501 34.8929 17.9053 34.8257 17.7934 34.6914C18.0396 34.5795 18.2635 34.4676 18.5096 34.3333C18.6216 34.7138 18.7111 35.0271 18.8006 35.3629C19.2706 35.3629 19.4273 35.721 19.6287 36.1462C19.2259 36.0567 19.3154 35.9672 19.1587 36.4595L22.8293 38.5858C22.8069 38.4291 22.8516 38.2948 23.0083 38.2724C23.0978 38.2501 23.2097 38.2948 23.2769 38.3396L25.1122 35.1614C25.0674 35.1614 25.045 35.1838 25.0002 35.1838C24.9555 35.1838 24.9107 35.0719 24.9107 35.0495C24.9331 35.0048 25.0002 34.96 25.1122 34.8928C25.1345 34.96 25.1569 35.0048 25.1793 35.0495L25.9403 33.7514C25.8507 33.729 25.7388 33.7066 25.5598 33.6395C25.7388 33.5723 25.9179 33.4828 26.0969 33.5052L26.6788 32.4757C26.5893 32.5204 26.4998 32.5652 26.3655 32.5876C26.1193 31.9161 26.3431 31.5804 27.0817 31.5804C27.0593 31.6923 27.0369 31.7818 27.0146 31.8937L30.797 25.3584C30.7523 25.4031 30.7299 25.4255 30.6627 25.4703C30.6851 25.1346 30.7075 24.9331 30.9985 25.0003L33.4828 20.7031C33.4604 20.6583 33.4156 20.5688 33.3709 20.4792C33.438 20.4792 33.5276 20.4792 33.5947 20.5016L37.1533 14.3244L30.5508 10.5195L20.3002 28.2903L13.7872 24.5303L9.95996 31.1552L18.1292 35.8776Z"
          fill="#E50500"
        />
        <path
          d="M0 25.0001C0 25.0896 0 25.1567 0 25.2463C0.0447628 25.2239 0.0895255 25.2015 0.179051 25.2015C0.201432 25.2015 0.290958 25.3134 0.268577 25.3134C0.201432 25.4029 0.15667 25.5148 0.0671442 25.5596C0.0447628 25.5596 0.0223814 25.582 0 25.582C0.0223814 26.9025 0.15667 28.2006 0.402865 29.4764C0.470009 29.4316 0.514772 29.3644 0.559535 29.2749C0.626679 29.1406 0.895255 29.0959 1.09669 29.0063C1.16383 28.6035 0.738586 28.7154 0.581916 28.5363C0.49239 28.2006 0.425246 27.8649 0.290958 27.3725C0.760967 27.7082 0.984781 28.1335 1.38765 28.3349C1.49955 28.3797 1.61146 28.4468 1.72337 28.514C1.70099 28.2901 1.65622 28.0887 1.63384 27.8649C1.41003 27.932 1.20859 27.9768 1.00716 27.753C0.581916 27.2606 0.783348 26.7906 0.80573 26.6339C1.09669 26.522 1.3205 26.4772 1.49955 26.5444C1.47717 26.3206 1.47717 26.0968 1.45479 25.8506C1.41003 25.8506 1.38765 25.8282 1.34288 25.8282C1.09669 25.7163 1.25336 25.582 1.36526 25.4029C1.38765 25.4253 1.41003 25.4477 1.43241 25.4701C1.38765 23.6124 1.5667 21.7772 1.96956 20.009C1.79051 19.8524 1.74575 19.7181 1.79051 19.5614C1.83527 19.4271 1.9248 19.36 2.12623 19.3824C3.9615 11.9517 9.35542 5.61781 16.8979 2.8649C16.8308 2.79775 16.7637 2.73061 16.6741 2.66346C16.8532 2.6187 16.9651 2.57394 17.1441 2.52918C17.1218 2.6187 17.1218 2.70823 17.1218 2.79775C17.547 2.64108 17.9946 2.50679 18.4423 2.37251C18.3751 2.17107 18.2856 1.94726 18.1961 1.67868C18.4199 1.74583 19.3151 1.85773 19.0913 2.19345C22.5381 1.2982 26.0295 1.20867 29.3196 1.83535C29.2972 1.81297 29.2972 1.81297 29.2748 1.79059C29.7225 1.67868 29.7672 1.6563 29.9687 1.96964C30.5058 2.08155 31.0206 2.21584 31.5354 2.37251C31.5577 2.35012 31.5801 2.30536 31.6249 2.2606C31.6473 2.32774 31.6697 2.37251 31.692 2.41727C34.333 3.20062 36.795 4.43159 39.0107 6.06543C39.0107 5.99829 39.0107 5.90876 38.9884 5.75209C39.4136 5.95353 39.3689 5.81924 39.2569 6.2221C39.2346 6.2221 39.2122 6.19972 39.1898 6.19972C43.2408 9.24359 46.3518 13.6303 47.7619 18.89C51.1191 31.4235 43.6437 44.3824 31.1101 47.7396C29.8568 48.0753 28.6034 48.2991 27.3277 48.4334C27.4172 48.5677 27.5515 48.6796 27.5739 48.8139C27.6634 49.3734 27.2381 49.4182 26.6338 49.6867C26.88 49.2167 27.0591 48.8362 27.2605 48.4334C26.0072 48.5453 24.7314 48.5677 23.5005 48.5005C23.6124 48.6348 23.6571 48.702 23.5676 48.9929C23.5676 49.0153 23.3885 49.0153 23.3662 48.9929C23.2319 48.7691 23.3214 48.6124 23.3885 48.5005C23.12 48.4781 22.8514 48.4558 22.5828 48.4334V48.4558C22.4933 48.4558 22.4261 48.4334 22.3814 48.411C20.9937 48.2543 19.6061 47.9634 18.2856 47.5605C18.5765 47.9186 18.487 48.0305 17.9499 48.3439C17.9722 48.1648 18.0618 47.9634 18.017 47.8738C17.9275 47.7172 17.9499 47.6053 18.017 47.4934C16.2936 46.9562 14.6374 46.2176 13.0931 45.3C12.8022 45.3 12.735 45.3 12.6679 45.0538C12.4888 44.9419 12.3098 44.83 12.1531 44.7181C12.1083 44.7628 12.1083 44.7405 11.9964 44.6733C11.9964 44.6509 12.0188 44.6509 12.0188 44.6285C7.38586 41.5623 3.82722 36.8622 2.2829 31.1102C2.12623 30.5283 1.99194 29.924 1.88004 29.3421C1.79051 29.3421 1.70099 29.3197 1.5667 29.2973C1.3205 29.7225 1.07431 30.1254 0.581916 30.2373C0.716204 30.8416 0.872874 31.4459 1.02954 32.0502C1.07431 32.0054 1.16383 31.9607 1.25336 31.8935C1.18621 32.0054 1.14145 32.1397 1.07431 32.2516C1.70099 34.3555 2.61862 36.3474 3.76007 38.1827L3.78245 38.1603C3.93912 38.026 3.62578 37.5336 4.16294 37.6232C4.2077 37.9589 4.2077 38.2499 3.91674 38.4737C3.93912 38.5184 3.9615 38.5632 4.00627 38.608C4.05103 38.5856 4.14056 38.5632 4.29723 38.5184C4.23008 38.5856 4.18532 38.6751 4.11817 38.7646C8.46016 45.3447 15.8236 49.7763 24.239 50.0225C24.2167 50.0001 24.1943 49.9553 24.1719 49.9329C24.3062 49.9777 24.4181 50.0001 24.5076 50.0225C24.6643 50.0225 24.8433 50.0225 25 50.0225C31.0654 50.0225 36.6159 47.8738 40.9355 44.2704C40.8013 44.2704 40.7565 44.2481 40.846 43.9571C41.0251 44.1138 41.0475 44.1138 41.0475 44.1585C44.1361 41.5847 46.5757 38.2499 48.12 34.4898C48.0081 34.5569 47.8962 34.6465 47.7619 34.736C47.7619 34.4226 47.829 34.2212 48.0976 34.1541C48.12 34.1541 48.1647 34.1988 48.2095 34.2436C48.2766 34.0869 48.3438 33.9079 48.4109 33.7512C48.3662 33.7512 48.3214 33.7512 48.2766 33.7512C48.3438 33.6617 48.4333 33.5721 48.5228 33.4379C48.6124 33.1917 48.7019 32.9455 48.769 32.6993C48.7467 32.6993 48.7243 32.7217 48.7019 32.744C48.7914 32.4531 48.8809 32.1621 48.9705 31.8488C48.9928 31.8488 49.0152 31.8488 49.0152 31.8712C49.06 31.6921 49.1048 31.5131 49.1719 31.334C49.1271 31.2669 49.1719 31.1773 49.239 31.0207C49.7091 29.0959 49.9776 27.0815 49.9776 25.0001C49.9776 18.1738 47.2471 11.9741 42.7932 7.47546C42.7708 7.47546 42.7261 7.49784 42.7037 7.52022C42.4575 7.40832 42.3903 7.22926 42.368 7.05021C40.4879 5.23732 38.3169 3.69301 35.9445 2.52918C35.9221 2.55156 35.8774 2.57394 35.855 2.6187C35.855 2.57394 35.855 2.52918 35.855 2.50679C34.2435 1.67868 32.4754 1.07439 30.6625 0.64914C30.5506 0.850572 30.3939 1.02962 30.1477 1.16391C30.0134 1.25344 29.8791 1.36534 29.7001 1.16391C29.9015 1.052 29.9015 0.693902 30.2596 0.761046C30.282 0.761046 30.3715 0.671521 30.3939 0.604377C30.1925 0.559614 29.9911 0.514851 29.7896 0.470088C29.6777 0.537233 29.521 0.626758 29.3196 0.738665C29.2077 0.581995 29.2077 0.470088 29.2301 0.380563C29.0958 0.358182 28.9391 0.3358 28.8048 0.313419C28.7825 0.425326 28.7825 0.581995 28.8048 0.828191C28.6034 0.98486 28.402 1.16391 28.1782 1.34296C28.1558 1.18629 28.0663 1.02962 28.0886 0.895335C28.1334 0.581995 28.1334 0.358182 28.0663 0.201512C27.0815 0.0896051 26.0519 0.0224609 25.0224 0.0224609C23.3214 0.0224609 21.6428 0.201512 20.0313 0.514851C20.0313 0.559614 20.0537 0.626758 20.0313 0.716284C19.8747 0.671521 19.7628 0.626758 19.6956 0.559614C18.8675 0.738665 18.0394 0.962479 17.2337 1.23106C17.1218 1.34296 17.0546 1.36534 16.9651 1.32058C7.0949 4.67779 0 14.0108 0 25.0001Z"
          fill="#E50500"
        />
        <path
          d="M6.02022 25.2235C5.97545 21.8439 6.82595 18.5091 8.57169 15.51L7.27357 14.749C4.54305 19.4939 3.80446 24.9997 5.23687 30.2817C6.6469 35.5637 10.0489 39.9728 14.7713 42.7257L15.5323 41.4276C11.2127 38.9433 8.10169 34.937 6.7588 30.125C6.7588 30.1698 6.73642 30.1698 6.6469 30.2146C6.46784 29.946 6.46784 30.0131 6.69166 29.9012C6.4007 28.7822 6.19927 27.6631 6.10974 26.544C6.08736 26.5664 6.06498 26.6112 6.06498 26.6112C6.08736 27.1707 5.63973 27.2602 5.25925 27.5064C5.12496 27.2378 5.01305 27.014 4.87877 26.7678C5.12496 26.7007 5.41592 26.6783 5.57259 26.5216C5.72926 26.3873 5.77402 26.0964 5.86355 25.8949C5.70688 25.7159 5.57259 25.5816 5.41592 25.4026C5.61735 25.2459 5.75164 25.134 5.88593 24.9997C5.90831 25.0668 5.93069 25.1116 6.02022 25.2235Z"
          fill="#E50500"
        />
        <path
          d="M25.2014 5.3269C25.0671 5.03594 24.9105 4.7226 24.7538 4.43164C24.6195 4.7226 24.4628 5.03594 24.3285 5.3269C23.9928 5.37166 23.6795 5.4388 23.3438 5.52833C23.6123 5.72976 23.8585 5.93119 24.1047 6.15501L23.9928 7.13979C24.2614 6.96074 24.5076 6.80407 24.7985 6.6474C25.0671 6.78169 25.3357 6.96074 25.6043 7.11741L25.4476 6.15501C25.6938 5.93119 25.94 5.70738 26.1862 5.50595C25.8729 5.39404 25.5371 5.37166 25.2014 5.3269Z"
          fill="#E50500"
        />
        <path
          d="M34.7135 40.5778L34.3554 39.6602L33.9078 40.4883C33.5945 40.4883 33.2811 40.4659 32.9678 40.4659L33.5721 41.2492C33.4825 41.5626 33.3706 41.8759 33.2363 42.1669C33.5497 42.0773 33.863 41.9431 34.1764 41.8312C34.4449 42.0326 34.7135 42.2116 35.0045 42.3907C34.9821 42.055 34.9597 41.7192 34.9373 41.4059C35.2059 41.2045 35.4521 40.9807 35.6983 40.7568C35.3402 40.7121 35.0269 40.6449 34.7135 40.5778Z"
          fill="#E50500"
        />
        <path
          d="M29.3871 43.6885C29.5886 43.9347 29.8124 44.2033 30.0362 44.4495C30.1033 44.1138 30.1705 43.8004 30.2152 43.4647L30.6629 43.2633L31.1105 43.0395C30.8867 42.9499 30.6852 42.838 30.4838 42.7485C30.4838 42.7709 30.4838 42.7709 30.4614 42.7933C30.3048 43.0395 30.0586 42.7709 29.4543 42.3233C29.1409 42.2561 28.85 42.1442 28.559 42.0547L28.9395 42.9499C28.7604 43.2185 28.5814 43.5095 28.4023 43.7781C28.7381 43.7557 29.0514 43.7109 29.3871 43.6885Z"
          fill="#E50500"
        />
        <path
          d="M30.1927 42.278L30.1032 41.6289L29.4541 42.3003C29.7898 42.2108 30.036 42.2108 30.1927 42.278Z"
          fill="#E50500"
        />
        <path
          d="M24.3061 44.3148C24.4404 44.6058 24.597 44.9191 24.7537 45.2101C24.888 44.9191 25.0447 44.6058 25.1789 44.3148C25.5147 44.2701 25.828 44.2029 26.1637 44.1134C25.8952 43.912 25.649 43.7105 25.4028 43.4867L25.5147 42.502C25.2461 42.681 24.9999 42.8377 24.7089 42.9943C24.4404 42.8601 24.1718 42.681 23.9032 42.5243L24.0599 43.4867C23.8137 43.7105 23.5675 43.9344 23.3213 44.1358C23.657 44.2253 23.9704 44.2477 24.3061 44.3148Z"
          fill="#E50500"
        />
        <path
          d="M29.5654 7.13982C29.7892 7.36364 30.013 7.58745 30.2368 7.81126L30.3263 6.82648C30.6173 6.66981 30.9082 6.51314 31.1992 6.37886C30.9082 6.22219 30.5949 6.11028 30.2816 5.97599C30.2144 5.66265 30.1473 5.32693 30.0801 4.99121C29.8563 5.23741 29.6549 5.50598 29.4535 5.77456C29.1177 5.75218 28.782 5.7298 28.4463 5.70742C28.6477 5.97599 28.8492 6.22219 29.0282 6.51314L28.6701 7.43078L29.5654 7.13982Z"
          fill="#E50500"
        />
        <path
          d="M19.4491 44.6062C19.673 44.36 19.8744 44.0914 20.0758 43.8228C20.4115 43.8452 20.7473 43.8676 21.083 43.89C20.8816 43.6214 20.6801 43.3752 20.5011 43.0843L20.8592 42.1666L19.9639 42.4576C19.7401 42.2338 19.5163 42.0099 19.2925 41.7861L19.203 42.7709C18.912 42.9276 18.621 43.0843 18.3301 43.2185C18.621 43.3752 18.9344 43.4871 19.2477 43.6214V43.6438C19.2925 43.5766 19.3372 43.5095 19.4044 43.4424C19.5834 43.599 19.7401 43.7333 19.9415 43.89C19.6506 43.9571 19.4715 44.0243 19.3372 44.0466C19.382 44.2705 19.4044 44.4271 19.4491 44.6062Z"
          fill="#E50500"
        />
        <path
          d="M38.5407 37.4884L37.9588 36.7051C37.8916 37.0184 37.8021 37.3094 37.7126 37.6227C37.4216 37.7122 37.0859 37.757 36.7949 37.8241L37.5783 38.4284C37.5559 38.7418 37.5335 39.0775 37.4887 39.4132C37.7797 39.2342 38.0483 39.0327 38.3169 38.8537C38.6302 38.9656 38.9435 39.0775 39.2569 39.1894C39.1673 38.8761 39.0554 38.5627 38.9435 38.2494C39.145 37.9808 39.3464 37.7122 39.5255 37.4437C39.1897 37.4437 38.854 37.466 38.5407 37.4884Z"
          fill="#E50500"
        />
        <path
          d="M38.6746 9.73629C37.6226 8.79627 36.4812 7.96816 35.2502 7.25195L34.4893 8.55007C38.876 11.0792 42.0094 15.175 43.3299 20.0765C43.4866 20.6584 43.6209 21.2627 43.7104 21.8446C43.7999 21.867 43.8894 21.9118 43.979 21.9789C43.9342 22.0684 43.9118 22.2027 43.8447 22.2027C43.8223 22.2027 43.7999 22.2027 43.7775 22.2251C43.8447 22.7175 43.9118 23.2099 43.9342 23.6799C43.979 23.7023 44.0237 23.747 44.0685 23.7694C44.0237 23.8142 43.979 23.8366 43.9566 23.8589C44.0685 25.6718 43.9118 27.4847 43.5089 29.2305C43.7328 29.1633 43.9342 29.0962 44.1804 29.32C44.2252 29.1633 44.2699 29.2081 43.9118 28.9619C43.6656 28.7828 43.6656 28.7828 43.9342 28.4471C44.1356 28.5143 44.158 28.8947 44.4937 28.8052C44.5161 28.8052 44.6056 29.0738 44.6056 29.0514C44.5161 29.32 44.2252 29.5662 44.5833 29.8348C44.3594 30.1033 44.158 30.2824 43.8223 30.3048C44.0461 30.7076 43.6209 30.7972 43.5313 31.0434C43.3299 31.0657 43.1285 31.0657 42.9494 31.0881C42.6585 31.9386 42.3004 32.7667 41.8975 33.5725C41.9646 33.6172 42.0318 33.662 42.0989 33.7067C41.8975 33.9306 41.8303 33.9977 41.6513 34.0201C41.5842 34.1544 41.517 34.2887 41.4275 34.4229L42.7256 35.1839C45.4561 30.4391 46.1947 24.9332 44.7623 19.6512C43.7328 15.7793 41.6289 12.3773 38.7193 9.75867C38.585 10.072 38.6746 10.4749 38.2717 10.6092C37.8465 10.7434 37.5779 10.4525 37.3093 10.0944C37.7793 10.0049 38.0703 9.40056 38.6746 9.73629Z"
          fill="#E50500"
        />
        <path
          d="M43.8227 30.3713C43.8899 29.6327 44.0018 29.4537 43.5765 29.5208C43.6884 29.8118 43.3079 30.1699 43.8227 30.3713Z"
          fill="#E50500"
        />
      </g>
      <defs>
        <clipPath id="clip0_2210_12522">
          <rect width="50" height="50" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  signSuccess: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50.0005 73.9005L36.1005 60.0005L31.3672 64.7005L50.0005 83.3338L90.0005 43.3338L85.3005 38.6338L50.0005 73.9005Z"
        fill="#0D99FF"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#0D99FF" strokeDasharray="5 5" />
    </svg>
  ),
  hidePassLogin: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00033 4.00003C10.527 4.00003 12.7803 5.42003 13.8803 7.6667C13.487 8.48003 12.9337 9.18003 12.2737 9.7467L13.2137 10.6867C14.1403 9.8667 14.8737 8.84003 15.3337 7.6667C14.1803 4.74003 11.3337 2.6667 8.00033 2.6667C7.15366 2.6667 6.34032 2.80003 5.57366 3.0467L6.67366 4.1467C7.10699 4.06003 7.54699 4.00003 8.00033 4.00003ZM7.28699 4.76003L8.66699 6.14003C9.04699 6.3067 9.35366 6.61336 9.52032 6.99336L10.9003 8.37336C10.9537 8.1467 10.9937 7.9067 10.9937 7.66003C11.0003 6.0067 9.65366 4.6667 8.00033 4.6667C7.75366 4.6667 7.52033 4.70003 7.28699 4.76003ZM1.34033 2.58003L3.12699 4.3667C2.04033 5.22003 1.18033 6.35336 0.666992 7.6667C1.82033 10.5934 4.66699 12.6667 8.00033 12.6667C9.01366 12.6667 9.98699 12.4734 10.8803 12.12L13.1603 14.4L14.1003 13.46L2.28033 1.63336L1.34033 2.58003ZM6.34033 7.58003L8.08033 9.32003C8.05366 9.32669 8.02699 9.33336 8.00033 9.33336C7.08033 9.33336 6.33366 8.5867 6.33366 7.6667C6.33366 7.63336 6.34033 7.61336 6.34033 7.58003ZM4.07366 5.31336L5.24033 6.48003C5.08699 6.8467 5.00033 7.2467 5.00033 7.6667C5.00033 9.32003 6.34699 10.6667 8.00033 10.6667C8.42033 10.6667 8.82032 10.58 9.18033 10.4267L9.83366 11.08C9.24699 11.24 8.63366 11.3334 8.00033 11.3334C5.47366 11.3334 3.22033 9.91336 2.12033 7.6667C2.58699 6.71336 3.26699 5.92669 4.07366 5.31336Z"
        fill="#323232"
      />
    </svg>
  ),
  checkDisabled: (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" clipPath="url(#clip0_2178_12364)">
        <path
          d="M20.0547 12.5339C20.274 12.5653 20.4934 12.6279 20.744 12.6906L21.2454 13.9753L21.8721 12.816C22.3107 12.816 22.7494 12.8473 23.1881 12.8473L22.3421 11.7506C22.3734 11.6566 22.4047 11.5626 22.4361 11.4686C22.3421 11.4373 22.2481 11.4059 22.0601 11.3433C22.3421 11.0612 22.4674 10.9359 22.6241 10.9986C22.6867 10.8419 22.7494 10.6539 22.8121 10.4972C22.3734 10.6226 21.9347 10.8106 21.496 10.9672C21.2454 10.7792 20.9947 10.6226 20.744 10.4346C20.744 10.6539 20.7754 10.9046 20.6814 11.1866C20.556 10.9046 20.462 10.6852 20.368 10.5286C20.3994 10.8732 20.3994 11.2493 20.4307 11.5939C20.3994 11.6253 20.3367 11.6566 20.3054 11.7193C20.4307 11.7193 20.556 11.7193 20.7127 11.7193C20.7127 12.1266 20.556 12.3773 20.0547 12.5339Z"
          fill="white"
        />
        <path
          d="M19.3965 12.4086C19.4592 12.4086 19.5218 12.44 19.5845 12.44C19.5845 12.3773 19.5845 12.3146 19.5845 12.252C19.4905 12.3146 19.4592 12.346 19.3965 12.4086Z"
          fill="white"
        />
        <path
          d="M28.1686 8.30355C27.8866 7.95888 27.5732 7.6142 27.2599 7.26953C27.1659 7.73954 27.0719 8.17822 27.0092 8.64822L26.3825 8.93023L25.7559 9.24357C26.1945 9.43157 26.6019 9.61958 27.0092 9.83891L27.1972 11.1863L28.1059 10.2463C28.5446 10.3403 28.9519 10.4969 29.3593 10.6223L28.8266 9.3689C29.0773 8.9929 29.3279 8.58556 29.5786 8.20955C29.1086 8.20955 28.6386 8.27222 28.1686 8.30355Z"
          fill="white"
        />
        <path
          d="M15.3846 16.9828L16.1992 18.0795C16.2932 17.6408 16.4186 17.2335 16.5439 16.7948C16.9513 16.6695 17.4213 16.6068 17.8286 16.5128L16.7319 15.6668C16.7633 15.2281 16.7946 14.7581 16.8573 14.2881C16.4499 14.5388 16.0739 14.8208 15.6979 15.0714C15.2592 14.9148 14.8205 14.7581 14.3819 14.6014C14.5072 15.0401 14.6639 15.4788 14.8205 15.9175C14.5385 16.2935 14.2565 16.6695 14.0059 17.0455C14.4759 17.0455 14.9145 17.0141 15.3846 16.9828Z"
          fill="white"
        />
        <path
          d="M25.3802 50.2279C25.4116 49.9146 25.3802 49.8206 25.0669 49.6639C24.5969 49.4446 25.1296 49.1939 25.2549 48.9746C25.1296 48.8492 25.0669 48.7552 24.9102 48.5672C25.2549 48.4105 25.5682 48.2539 25.9129 48.0659C26.0696 48.5985 26.1949 49.0372 26.3203 49.5072C26.9783 49.5072 27.1976 50.0086 27.4796 50.6039C26.9156 50.4786 27.0409 50.3532 26.8216 51.0426L31.9604 54.0193C31.929 53.8 31.9917 53.612 32.211 53.5806C32.3364 53.5493 32.493 53.612 32.587 53.6746L35.1564 49.2252C35.0938 49.2252 35.0624 49.2566 34.9998 49.2566C34.9371 49.2566 34.8744 49.0999 34.8744 49.0686C34.9058 49.0059 34.9998 48.9432 35.1564 48.8492C35.1878 48.9432 35.2191 49.0059 35.2504 49.0686L36.3158 47.2512C36.1904 47.2199 36.0338 47.1885 35.7831 47.0945C36.0338 47.0005 36.2844 46.8752 36.5351 46.9065L37.3498 45.4652C37.2245 45.5278 37.0991 45.5905 36.9111 45.6218C36.5665 44.6818 36.8798 44.2118 37.9138 44.2118C37.8825 44.3685 37.8511 44.4938 37.8198 44.6505L43.1152 35.501C43.0526 35.5636 43.0212 35.595 42.9272 35.6576C42.9586 35.1876 42.9899 34.9056 43.3972 34.9996L46.8753 28.9835C46.844 28.9208 46.7813 28.7955 46.7186 28.6702C46.8126 28.6702 46.938 28.6702 47.032 28.7015L52.0141 20.0533L42.7706 14.7266L28.4196 39.6057L19.3015 34.3416L13.9434 43.6164L25.3802 50.2279Z"
          fill="white"
        />
        <path
          d="M0 34.9999C0 35.1252 0 35.2192 0 35.3446C0.0626679 35.3133 0.125336 35.2819 0.250671 35.2819C0.282005 35.2819 0.407341 35.4386 0.376007 35.4386C0.282005 35.5639 0.219338 35.7206 0.0940018 35.7833C0.0626679 35.7833 0.0313339 35.8146 0 35.8146C0.0313339 37.6633 0.219338 39.4807 0.564011 41.2667C0.658013 41.204 0.72068 41.11 0.783348 40.9847C0.87735 40.7967 1.25336 40.734 1.53536 40.6087C1.62936 40.0447 1.03402 40.2013 0.814682 39.9507C0.689346 39.4807 0.595345 39.0107 0.407341 38.3213C1.06535 38.7913 1.37869 39.3867 1.9427 39.6687C2.09937 39.7313 2.25604 39.8253 2.41271 39.9193C2.38138 39.606 2.31871 39.324 2.28738 39.0107C1.97404 39.1047 1.69203 39.1673 1.41003 38.854C0.814682 38.1646 1.09669 37.5066 1.12802 37.2873C1.53536 37.1306 1.8487 37.068 2.09937 37.162C2.06804 36.8486 2.06804 36.5353 2.03671 36.1906C1.97404 36.1906 1.9427 36.1593 1.88004 36.1593C1.53536 36.0026 1.7547 35.8146 1.91137 35.5639C1.9427 35.5953 1.97404 35.6266 2.00537 35.6579C1.9427 33.0572 2.19338 30.4878 2.75739 28.0124C2.50671 27.7931 2.44405 27.6051 2.50671 27.3858C2.56938 27.1978 2.69472 27.1038 2.97672 27.1351C5.54611 16.7322 13.0976 7.86473 23.6571 4.01066C23.5631 3.91666 23.4691 3.82265 23.3438 3.72865C23.5945 3.66599 23.7511 3.60332 24.0018 3.54065C23.9705 3.66599 23.9705 3.79132 23.9705 3.91666C24.5658 3.69732 25.1925 3.50932 25.8192 3.32131C25.7252 3.03931 25.5998 2.72597 25.4745 2.34996C25.7878 2.44396 27.0412 2.60063 26.7278 3.07064C31.5533 1.81728 36.4414 1.69195 41.0475 2.5693C41.0161 2.53796 41.0161 2.53796 40.9848 2.50663C41.6115 2.34996 41.6741 2.31863 41.9561 2.7573C42.7081 2.91397 43.4288 3.10197 44.1495 3.32131C44.1808 3.28998 44.2122 3.22731 44.2748 3.16464C44.3062 3.25864 44.3375 3.32131 44.3689 3.38398C48.0663 4.48067 51.513 6.20403 54.615 8.49141C54.615 8.39741 54.615 8.27207 54.5837 8.05274C55.1791 8.33474 55.1164 8.14674 54.9597 8.71075C54.9284 8.71075 54.8971 8.67941 54.8657 8.67941C60.5372 12.9408 64.8926 19.0823 66.8666 26.4458C71.5667 43.9927 61.1012 62.1351 43.5542 66.8352C41.7995 67.3052 40.0448 67.6185 38.2587 67.8065C38.3841 67.9945 38.5721 68.1512 38.6034 68.3392C38.7287 69.1226 38.1334 69.1852 37.2874 69.5612C37.6321 68.9032 37.8827 68.3705 38.1647 67.8065C36.41 67.9632 34.624 67.9945 32.9006 67.9005C33.0573 68.0885 33.12 68.1825 32.9946 68.5899C32.9946 68.6212 32.744 68.6212 32.7126 68.5899C32.5246 68.2765 32.65 68.0572 32.744 67.9005C32.368 67.8692 31.9919 67.8379 31.6159 67.8065V67.8379C31.4906 67.8379 31.3966 67.8065 31.3339 67.7752C29.3912 67.5559 27.4485 67.1485 25.5998 66.5845C26.0072 67.0859 25.8818 67.2425 25.1298 67.6812C25.1611 67.4305 25.2865 67.1485 25.2238 67.0232C25.0985 66.8038 25.1298 66.6472 25.2238 66.4905C22.8111 65.7385 20.4924 64.7045 18.3304 63.4198C17.923 63.4198 17.829 63.4198 17.735 63.0751C17.4843 62.9184 17.2337 62.7618 17.0143 62.6051C16.9517 62.6678 16.9517 62.6364 16.795 62.5424C16.795 62.5111 16.8263 62.5111 16.8263 62.4798C10.3402 58.187 5.3581 51.6069 3.19606 43.5541C2.97672 42.7394 2.78872 41.8934 2.63205 41.0787C2.50671 41.0787 2.38138 41.0474 2.19338 41.016C1.8487 41.6114 1.50403 42.1754 0.814682 42.3321C1.00269 43.1781 1.22202 44.0241 1.44136 44.8701C1.50403 44.8074 1.62936 44.7448 1.7547 44.6508C1.6607 44.8074 1.59803 44.9954 1.50403 45.1521C2.38138 48.0975 3.66607 50.8862 5.2641 53.4556L5.29543 53.4243C5.51477 53.2363 5.0761 52.5469 5.82811 52.6722C5.89078 53.1423 5.89078 53.5496 5.48344 53.8629C5.51477 53.9256 5.54611 53.9883 5.60877 54.0509C5.67144 54.0196 5.79678 53.9883 6.01612 53.9256C5.92211 54.0196 5.85945 54.1449 5.76544 54.2703C11.8442 63.4824 22.1531 69.6866 33.9347 70.0312C33.9033 69.9999 33.872 69.9372 33.8406 69.9059C34.0287 69.9686 34.1853 69.9999 34.3107 70.0312C34.53 70.0312 34.7807 70.0312 35 70.0312C43.4915 70.0312 51.2623 67.0232 57.3098 61.9784C57.1218 61.9784 57.0591 61.9471 57.1844 61.5397C57.4351 61.7591 57.4664 61.7591 57.4664 61.8218C61.7905 58.2183 65.2059 53.5496 67.368 48.2855C67.2113 48.3795 67.0546 48.5048 66.8666 48.6302C66.8666 48.1915 66.9606 47.9095 67.3366 47.8155C67.368 47.8155 67.4306 47.8782 67.4933 47.9408C67.5873 47.7215 67.6813 47.4708 67.7753 47.2515C67.7126 47.2515 67.65 47.2515 67.5873 47.2515C67.6813 47.1261 67.8066 47.0008 67.932 46.8128C68.0573 46.4681 68.1826 46.1235 68.2766 45.7788C68.2453 45.7788 68.214 45.8101 68.1826 45.8414C68.308 45.4341 68.4333 45.0268 68.5586 44.5881C68.59 44.5881 68.6213 44.5881 68.6213 44.6194C68.684 44.3688 68.7466 44.1181 68.8406 43.8674C68.778 43.7734 68.8407 43.6481 68.9347 43.4287C69.5927 40.734 69.9687 37.914 69.9687 34.9999C69.9687 25.4431 66.1459 16.7636 59.9105 10.4654C59.8791 10.4654 59.8165 10.4968 59.7851 10.5281C59.4405 10.3714 59.3465 10.1208 59.3151 9.8701C56.6831 7.33205 53.6437 5.17001 50.3223 3.54065C50.291 3.57198 50.2283 3.60332 50.197 3.66599C50.197 3.60332 50.197 3.54065 50.197 3.50932C47.9409 2.34996 45.4655 1.50394 42.9275 0.9086C42.7708 1.19061 42.5515 1.44128 42.2068 1.62928C42.0188 1.75462 41.8308 1.91129 41.5801 1.62928C41.8621 1.47261 41.8621 0.971268 42.3635 1.06527C42.3948 1.06527 42.5201 0.939934 42.5515 0.845932C42.2695 0.783264 41.9875 0.720596 41.7055 0.657928C41.5488 0.75193 41.3295 0.877266 41.0475 1.03394C40.8908 0.814598 40.8908 0.657929 40.9221 0.532593C40.7341 0.501259 40.5148 0.469925 40.3268 0.438591C40.2954 0.595261 40.2954 0.814598 40.3268 1.15927C40.0448 1.37861 39.7628 1.62928 39.4494 1.87995C39.4181 1.66061 39.2928 1.44128 39.3241 1.25327C39.3868 0.814598 39.3868 0.501259 39.2928 0.281921C37.9141 0.125252 36.4727 0.03125 35.0313 0.03125C32.65 0.03125 30.2999 0.281921 28.0439 0.720596C28.0439 0.783264 28.0752 0.877266 28.0439 1.0026C27.8245 0.939934 27.6679 0.877266 27.5739 0.783264C26.4145 1.03394 25.2551 1.34727 24.1271 1.72328C23.9705 1.87995 23.8765 1.91129 23.7511 1.84862C9.93286 6.54871 0 19.615 0 34.9999Z"
          fill="white"
        />
        <path
          d="M8.4283 35.3137C8.36564 30.5823 9.55633 25.9135 12.0004 21.7148L10.183 20.6494C6.36026 27.2922 5.32624 35.0004 7.33162 42.3952C9.30565 49.79 14.0684 55.9628 20.6799 59.8168L21.7452 57.9995C15.6978 54.5214 11.3424 48.9126 9.46232 42.1758C9.46232 42.2385 9.43099 42.2385 9.30565 42.3012C9.05498 41.9252 9.05498 42.0192 9.36832 41.8625C8.96098 40.2958 8.67898 38.7291 8.55364 37.1624C8.52231 37.1937 8.49097 37.2564 8.49097 37.2564C8.52231 38.0397 7.89563 38.1651 7.36295 38.5098C7.17495 38.1337 7.01828 37.8204 6.83027 37.4757C7.17495 37.3817 7.58229 37.3504 7.80162 37.1311C8.02096 36.9431 8.08363 36.5357 8.20897 36.2537C7.98963 36.003 7.80163 35.815 7.58229 35.5644C7.86429 35.345 8.0523 35.1884 8.2403 35.0004C8.27163 35.0944 8.30297 35.157 8.4283 35.3137Z"
          fill="white"
        />
        <path
          d="M35.2824 7.45746C35.0944 7.05012 34.875 6.61144 34.6557 6.2041C34.4677 6.61144 34.2483 7.05012 34.0603 7.45746C33.5903 7.52013 33.1517 7.61413 32.6816 7.73947C33.0576 8.02147 33.4023 8.30348 33.747 8.61682L33.5903 9.99551C33.9663 9.74484 34.311 9.5255 34.7184 9.30616C35.0944 9.49417 35.4704 9.74484 35.8464 9.96417L35.627 8.61682C35.9717 8.30348 36.3164 7.99014 36.6611 7.70813C36.2224 7.55146 35.7524 7.52013 35.2824 7.45746Z"
          fill="white"
        />
        <path
          d="M48.5983 56.8081L48.097 55.5234L47.4703 56.6828C47.0316 56.6828 46.593 56.6515 46.1543 56.6515L47.0003 57.7482C46.875 58.1868 46.7183 58.6255 46.5303 59.0328C46.969 58.9075 47.4077 58.7195 47.8463 58.5628C48.2223 58.8448 48.5983 59.0955 49.0057 59.3462C48.9743 58.8762 48.943 58.4062 48.9117 57.9675C49.2877 57.6855 49.6324 57.3721 49.977 57.0588C49.4757 56.9961 49.037 56.9021 48.5983 56.8081Z"
          fill="white"
        />
        <path
          d="M41.1424 61.1634C41.4244 61.508 41.7377 61.884 42.051 62.2287C42.145 61.7587 42.2391 61.32 42.3017 60.85L42.9284 60.568L43.5551 60.2547C43.2417 60.1293 42.9597 59.9727 42.6777 59.8473C42.6777 59.8787 42.6777 59.8787 42.6464 59.91C42.4271 60.2547 42.0824 59.8787 41.2364 59.252C40.7977 59.158 40.3903 59.0013 39.983 58.876L40.5157 60.1293C40.265 60.5053 40.0143 60.9127 39.7637 61.2887C40.2337 61.2574 40.6724 61.1947 41.1424 61.1634Z"
          fill="white"
        />
        <path
          d="M42.2703 59.1899L42.145 58.2812L41.2363 59.2213C41.7063 59.0959 42.051 59.0959 42.2703 59.1899Z"
          fill="white"
        />
        <path
          d="M34.0291 62.041C34.2171 62.4483 34.4364 62.887 34.6558 63.2943C34.8438 62.887 35.0631 62.4483 35.2511 62.041C35.7211 61.9783 36.1598 61.8843 36.6298 61.759C36.2538 61.477 35.9091 61.195 35.5645 60.8816L35.7211 59.5029C35.3451 59.7536 35.0004 59.9729 34.5931 60.1923C34.2171 60.0043 33.8411 59.7536 33.4651 59.5343L33.6844 60.8816C33.3397 61.195 32.9951 61.5083 32.6504 61.7903C33.1204 61.9156 33.5591 61.947 34.0291 62.041Z"
          fill="white"
        />
        <path
          d="M41.3929 9.99536C41.7062 10.3087 42.0196 10.622 42.3329 10.9354L42.4582 9.55669C42.8656 9.33735 43.2729 9.11801 43.6803 8.93001C43.2729 8.71067 42.8342 8.554 42.3956 8.366C42.3016 7.92732 42.2076 7.45731 42.1136 6.9873C41.8002 7.33198 41.5182 7.70799 41.2362 8.08399C40.7662 8.05266 40.2962 8.02132 39.8262 7.98999C40.1082 8.366 40.3902 8.71067 40.6409 9.11801L40.1395 10.4027L41.3929 9.99536Z"
          fill="white"
        />
        <path
          d="M27.2288 62.4481C27.5421 62.1034 27.8241 61.7274 28.1062 61.3514C28.5762 61.3827 29.0462 61.4141 29.5162 61.4454C29.2342 61.0694 28.9522 60.7247 28.7015 60.3174L29.2028 59.0327L27.9495 59.44C27.6361 59.1267 27.3228 58.8133 27.0095 58.5L26.8841 59.8787C26.4768 60.098 26.0695 60.3174 25.6621 60.5054C26.0695 60.7247 26.5081 60.8814 26.9468 61.0694V61.1007C27.0095 61.0067 27.0721 60.9127 27.1661 60.8187C27.4168 61.038 27.6361 61.226 27.9182 61.4454C27.5108 61.5394 27.2601 61.6334 27.0721 61.6647C27.1348 61.9781 27.1661 62.1974 27.2288 62.4481Z"
          fill="white"
        />
        <path
          d="M53.9577 52.4844L53.143 51.3877C53.049 51.8264 52.9237 52.2337 52.7984 52.6724C52.391 52.7977 51.921 52.8604 51.5137 52.9544L52.6104 53.8004C52.579 54.2391 52.5477 54.7091 52.485 55.1791C52.8924 54.9284 53.2684 54.6464 53.6444 54.3958C54.0831 54.5524 54.5217 54.7091 54.9604 54.8658C54.8351 54.4271 54.6784 53.9884 54.5217 53.5497C54.8037 53.1737 55.0857 52.7977 55.3364 52.4217C54.8664 52.4217 54.3964 52.453 53.9577 52.4844Z"
          fill="white"
        />
        <path
          d="M54.1446 13.6304C52.6719 12.3144 51.0739 11.155 49.3505 10.1523L48.2852 11.9697C54.4266 15.5104 58.8134 21.2446 60.6621 28.1067C60.8814 28.9214 61.0694 29.7674 61.1947 30.5821C61.3201 30.6134 61.4454 30.6761 61.5707 30.7701C61.5081 30.8954 61.4767 31.0834 61.3827 31.0834C61.3514 31.0834 61.3201 31.0834 61.2887 31.1147C61.3827 31.8041 61.4767 32.4934 61.5081 33.1514C61.5707 33.1828 61.6334 33.2454 61.6961 33.2768C61.6334 33.3394 61.5707 33.3708 61.5394 33.4021C61.6961 35.9402 61.4767 38.4782 60.9127 40.9223C61.2261 40.8283 61.5081 40.7343 61.8527 41.0476C61.9154 40.8283 61.9781 40.8909 61.4767 40.5462C61.1321 40.2956 61.1321 40.2956 61.5081 39.8256C61.7901 39.9196 61.8214 40.4522 62.2914 40.3269C62.3228 40.3269 62.4481 40.7029 62.4481 40.6716C62.3228 41.0476 61.9154 41.3923 62.4168 41.7683C62.1034 42.1443 61.8214 42.395 61.3514 42.4263C61.6647 42.9903 61.0694 43.1156 60.9441 43.4603C60.6621 43.4916 60.3801 43.4916 60.1294 43.523C59.722 44.7137 59.2207 45.873 58.6567 47.001C58.7507 47.0637 58.8447 47.1264 58.9387 47.189C58.6567 47.5024 58.5627 47.5964 58.312 47.6277C58.218 47.8157 58.124 48.0037 57.9987 48.1917L59.816 49.2571C63.6388 42.6143 64.6728 34.9061 62.6674 27.5113C61.2261 22.0906 58.2807 17.3278 54.2073 13.6617C54.0193 14.1004 54.1446 14.6644 53.5806 14.8524C52.9852 15.0404 52.6092 14.6331 52.2332 14.1318C52.8912 14.0064 53.2986 13.1604 54.1446 13.6304Z"
          fill="white"
        />
        <path
          d="M61.3518 42.5205C61.4458 41.4864 61.6025 41.2358 61.0071 41.3298C61.1638 41.7371 60.6311 42.2385 61.3518 42.5205Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2178_12364">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
}
